'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import Select from 'react-select';
import LoadSummaryDrawmap from '../layouts/loadSummaryDrawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import XLSX from "xlsx/dist/xlsx.full.min.js";
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD, getHyphenDDMMMYYYYHHMM, getHyphenDDMMMYYYY, getHyphenYYYYMMDDHHMMSS, getHyphenDDMMYYYYHHMMSS, getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import LoadSummaryColumnChart from "./loadSummaryColumnChart";
import download from 'js-file-download';
import LoadSummaryRecommondations from "./loadSummaryRecommondations";
import TripBarChart from './adherenceTripCharts.js';
import CostBarChart from './adherenceCostCharts.js';
import DemandBarChart from './adherenceDemandCharts.js';
import AdherencePercentBarChart from './adherencePercent.js';
import { Trash } from 'lucide-react';
import SobRunPanel from './sobRunPanel';

// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent = "";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;

// A plain-text Plan Date cell in an uploaded file (not a real Excel Date, not a
// day-serial number) is genuinely ambiguous - 05/08/2026 could be 5-Aug or
// 8-May depending on which convention the file's author used - so the operator
// has to say up front which order the file uses, per Trip No/Consignee input
// error rate seen without it. `order` is the sequence of tokens split off the
// cell text; 'Mon' means a textual month (Aug, August, aug...).
const PLAN_DATE_FORMATS = [
    { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY', example: '05-08-2026', order: ['D', 'M', 'Y'] },
    { value: 'MM-DD-YYYY', label: 'MM-DD-YYYY', example: '08-05-2026', order: ['M', 'D', 'Y'] },
    { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD', example: '2026-08-05', order: ['Y', 'M', 'D'] },
    { value: 'YYYY-DD-MM', label: 'YYYY-DD-MM', example: '2026-05-08', order: ['Y', 'D', 'M'] },
    { value: 'DD-MMM-YYYY', label: 'DD-MMM-YYYY', example: '05-Aug-2026', order: ['D', 'Mon', 'Y'] },
    { value: 'MMM-DD-YYYY', label: 'MMM-DD-YYYY', example: 'Aug-05-2026', order: ['Mon', 'D', 'Y'] },
    { value: 'DD-MM-YY', label: 'DD-MM-YY', example: '05-08-26', order: ['D', 'M', 'Y2'] },
    { value: 'MM-DD-YY', label: 'MM-DD-YY', example: '08-05-26', order: ['M', 'D', 'Y2'] },
    // 2-digit-year counterparts of DD-MMM-YYYY/MMM-DD-YYYY above (e.g.
    // "17-Aug-26") - a real gap before this: neither of the two existing
    // month-name formats accepts a 2-digit year (they require Y, not Y2), and
    // neither of the two existing 2-digit-year formats accepts a month name
    // (they require M, not Mon) - so a plain-text cell shaped like this had no
    // format option that could ever parse it, regardless of what the operator
    // picked. parsePlanDateText already handles 'Mon'+'Y2' generically (no
    // parsing-logic changes needed), these are just the missing combinations.
    { value: 'DD-MMM-YY', label: 'DD-MMM-YY', example: '17-Aug-26', order: ['D', 'Mon', 'Y2'] },
    { value: 'MMM-DD-YY', label: 'MMM-DD-YY', example: 'Aug-17-26', order: ['Mon', 'D', 'Y2'] },
];
const PLAN_DATE_MONTH_NAMES = { jan: 1, feb: 2, mar: 3, apr: 4, may: 5, jun: 6, jul: 7, aug: 8, sep: 9, oct: 10, nov: 11, dec: 12 };
// {value,label} shape for the react-select dropdown (same convention as every
// other <Select> in this codebase, e.g. lmusers.js) - built once here instead
// of re-mapped on every render.
const PLAN_DATE_FORMAT_OPTIONS = PLAN_DATE_FORMATS.map((f) => ({ value: f.value, label: f.label }));



export default class ViewLoadSummaryDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modules: AllModules,
            defaultColDef: {
                resizable: true,
                sortable: true,
                filter: true,
                editable: true,
            },
            eventAction: null,
            show: false,
            frameworkComponents: {
                consignmentforceclose: Consignmentforceclose,
                consignmentActions: ConsignmentActions,
                UpdateButton: UpdateButton,
                MarkDeliver: MarkDeliver,
                commentActions: CommentActions
            },
            modified_by: "",
            basicTitle: '',
            reasonforceclose: "",
            bulkslide: "",
            bulkslide1: "",
            truckloadUploadSlide: "",
            truckloadDragging: false,
            truckloadDateFormat: "",
            truckloadPendingRows: null,
            truckloadDateSample: "",
            truckloadSampleRow: null,
            truckloadDateAmbiguous: false,
            truckloadSliderBusy: false,
            truckloadRulesExpanded: true,
            truckloadUploadFileName: "",
            truckloadValidRows: [],
            truckloadErrors: [],
            truckloadResults: null,
            truckloadDuplicateHUs: [],
            truckloadPlanDateMismatchHUs: [],
            truckloadPlanDateOutOfWindowHUs: [],
            truckloadUploadMessage: null,
            truckload_approved: false,
            truckloadAddSlide: "",
            truckloadAddRow: { trip_no: "", trip_type: "", consignee: "", doc_no: "", hu: "", doc_type: "", plan_date: "" },
            truckloadAddErrors: [],
            file: "",
            uploadFile: "",
            basicType: "default",
            loadshow: 'show-n',
            forceCloseRowNode: "",
            forceclosedata: "",
            csvcontent: "",
            sliderForceCloseTranslate: "",
            overly: '',
            rowData: [],
            bulkslide: "",
            showDiv: "",
            uploadDivWidth: "",
            mapinfo: "",
            dealer: "",
            sliderCommentTranslate: "",
            commentsRowData: "",
            consignment_code: "",
            sliderRouteTranslate: "",
            maptruckno: "",
            routeTruck: "",
            rownode: "",
            googelRoutes: "",
            file: "",
            rowSelection: 'multiple',
            sliderForceCloseTranslate: "",
            maptruckno: "",
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
            paginationPageSize: 200,
            geofencelist: [],
            geoFenceData: "",
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel"
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel"
                    }
                ]
            },
            animateRows: true,
            dept_code: "",
            pagetitle: "",
            markDeliverRowNode: "",
            markDeliverData: "",
            sliderMarkDeliverTranslate: "",
            csvData: 0,
            overly: "show-m",
            loadshow: "show-m",
            holidayEvents: [],
            showCalendar: "show-m",
            showGridData: "show-m",
            loadFile: "",
            config: "",
            summary: "activet",
            trucks: "",
            courier: "",
            hub_hold_loads: "", courier_hold_loads: "",
            recommendations: "",
            dropped: "",
            adherence: "",
            configData: "show-n",
            summaryData: "",
            trucksData: "show-n",
            courierData: "show-n",
            recommendationsData: "show-n",
            droppedData: "show-n",
            adherenceData: 'show-n',
            seriesData: [],
            categories: [],
            costData: [],
            costCategories: [],
            actcostData: [],
            actcostCategories: [],
            drpData: [],
            drpCategories: [],
            fileName: "",
            configurationData: [],
            truckAvailabilityData: [],
            clustersData: [],
            couriersData: [],
            recommData: [],
            droppedPData: [],
            truckloadPlanData: [],
            selectedTruckloadPlanRows: [],
            transactionId: "",
            latLngArray: [],
            mapType: "",
            sliderTitle: "",
            loadingLocation: [],
            comp_short_name: "",
            loading_port_code: "",
            sliderType: 0,
            clusterDetails: [],
            consolidatedFile: "",
            data_type: 1,
            // vehicleType:"",
            filteredTruckDataforTruckAvailability: [],
            adherenceTransactionDetails: [],
            adherenceTripData: [],
            adherenceDemandData: [],
            adherenceCostData: [],
            adherencePercentData: [],
            cost_manual: 0,
            cost_system: 0,
            load: 0,
            percent_adhered_trips: 0,
            dealer_adherence: 0,
            veh_type_adherence: 0,
            pick_ticket_adherence: 0,
            route_adherence: 0,
            percent_truck_adherence: 0,
            manualVsSystemData: [],
            openAdherenceFormula: false,
            demand_manual: 0,
            demand_system: 0,
            mgpdata: 'show-n',
            mgp: '',
            mgprowdata: [],
            total_pick_tickets: 0,
            system_drop: 0,
            manual_drop: 0,
            pick_tickets_received: 0,
            pick_tickets_remaining: 0,
            last_calculated_date: '',
            mgp_total_pick_tickets: 0,
            mgp_pick_tickets_received: 0,
            mgp_pick_tickets_remaining: 0,
            last_synced_at: '',
            num_trips_system: 0,
            num_trips_manual: 0,
            num_trips_system_pending_pick_tickets: 0,
            num_trips_manual_extra_pick_tickets: 0,
            num_extra_pick_tickets: 0,
            cost_manual_extra_pick_tickets: 0,
            total_cost_system: 0,
            demand_extra_pick_tickets: 0,
            manual_total_load: 0,
            manual_total_cost: 0,
            manual_pick_tickets: 0,
            pending_load: 0,
            plannedTrucksCount: [],
            pendingPickTicketsCost: 0, airCourierData: [], pageType: "summary",
            hubHoldLoadData: [], courierHoldLoadData: [],
            insights: null, summaryLoaded: false, openZones: {}, zonePlan: "HUB"

            //components : {datepicker:getDatePicker()}
        }
    }
    async componentDidMount() {
        var transactionId = window.atob(this.props.match.params.eventname);
        // console.log(transactionId,"transactionId")
        var query = {
            "transactionId": transactionId
        }

        redirectURL.post("/lmconsignees/getAdherenceTransactionDetails", query).then((response) => {
            var adherenceTransactionDetails = response.data;
            console.log(adherenceTransactionDetails, "adherenceTransactionDetails");

            if (adherenceTransactionDetails.length > 0) {
                let cost_manual = adherenceTransactionDetails[0].cost_manual;
                let cost_system = adherenceTransactionDetails[0].cost_system;
                let load = adherenceTransactionDetails[0].demand;
                let percent_adhered_trips = adherenceTransactionDetails[0].trip_adherence;
                let dealer_adherence = adherenceTransactionDetails[0].dealer_adherence;
                let veh_type_adherence = adherenceTransactionDetails[0].veh_type_adherence;
                let pick_ticket_adherence = adherenceTransactionDetails[0].pick_ticket_adherence;
                let route_adherence = adherenceTransactionDetails[0].route_adherence;
                let percent_truck_adherence = adherenceTransactionDetails[0].percent_truck_adherence;
                let demand_manual = adherenceTransactionDetails[0].demand_manual
                let demand_system = adherenceTransactionDetails[0].demand_system
                let total_pick_tickets = adherenceTransactionDetails[0].total_pick_tickets
                let system_drop = adherenceTransactionDetails[0].system_unplanned_consignees_data
                let manual_drop = adherenceTransactionDetails[0].manual_unplanned_consignee_data
                let pick_tickets_received = adherenceTransactionDetails[0].pick_tickets_received
                let pick_tickets_remaining = adherenceTransactionDetails[0].pick_tickets_remaining
                let num_trips_system = adherenceTransactionDetails[0].num_trips_system
                let num_trips_manual = adherenceTransactionDetails[0].num_trips_manual
                let num_trips_system_pending_pick_tickets = adherenceTransactionDetails[0].num_trips_system_pending_pick_tickets
                let num_trips_manual_extra_pick_tickets = adherenceTransactionDetails[0].num_trips_manual_extra_pick_tickets
                let num_extra_pick_tickets = adherenceTransactionDetails[0].num_extra_pick_tickets
                let cost_manual_extra_pick_tickets = adherenceTransactionDetails[0].cost_manual_extra_pick_tickets
                let total_cost_system = adherenceTransactionDetails[0].total_cost_system
                let demand_extra_pick_tickets = adherenceTransactionDetails[0].demand_extra_pick_tickets
                let manual_total_load = demand_manual + demand_extra_pick_tickets
                let manual_total_cost = cost_manual_extra_pick_tickets + cost_manual
                let manual_pick_tickets = num_extra_pick_tickets + pick_tickets_received
                let pending_load = load - demand_system
                let pendingPickTicketsCost = total_cost_system - cost_system > 0 ? total_cost_system - cost_system : 0

                let last_calculated_date = moment.parseZone(adherenceTransactionDetails[0].created_date).format("DD-MM-YYYY HH:mm")
                cost_manual = formatIndianNumber(cost_manual)
                cost_system = formatIndianNumber(cost_system)
                manual_total_cost = formatIndianNumber(manual_total_cost)
                total_cost_system = formatIndianNumber(total_cost_system)
                cost_manual_extra_pick_tickets = formatIndianNumber(cost_manual_extra_pick_tickets)
                pendingPickTicketsCost = formatIndianNumber(pendingPickTicketsCost)
                this.setState({
                    adherenceTransactionDetails: adherenceTransactionDetails,
                    cost_manual, cost_system, load, percent_adhered_trips, dealer_adherence, veh_type_adherence, pick_ticket_adherence, route_adherence, percent_truck_adherence, demand_manual, demand_system,
                    total_pick_tickets, pick_tickets_received, pick_tickets_remaining, last_calculated_date, num_trips_system, num_extra_pick_tickets, system_drop, manual_drop,
                    num_trips_manual, num_trips_system_pending_pick_tickets, num_trips_manual_extra_pick_tickets, cost_manual_extra_pick_tickets,
                    total_cost_system, demand_extra_pick_tickets, manual_total_load, manual_total_cost, manual_pick_tickets, pending_load, pendingPickTicketsCost
                });
            }
        });

        await redirectURL.post("/lmconsignees/getLoadProcessRunDetailsByTransactionId", query).then((response) => {
            var loadprocess = response.data;
            // console.log(loadprocess,"215")
            var configurationData = [];
            var truckAvailabilityData = []
            var comp_short_name = "";
            var loading_port_code = "";
            var cdArray = [];
            var data_type = 1;
            if (loadprocess.length > 0) {
                var fileName = loadprocess[0].filename;
                var configurationData = loadprocess[0].vehicleConfig;
                if (loadprocess[0].sobConfig != undefined && loadprocess[0].sobConfig != "") {
                    var truckAvailabilityData = JSON.parse(loadprocess[0].sobConfig);
                }
                var truckConfig = loadprocess[0].truckConfig;
                var comp_short_name = loadprocess[0].comp_short_name;
                var loading_port_code = loadprocess[0].loading_port_code;
                data_type = loadprocess[0].data_type
                if (configurationData != undefined) {
                    configurationData.map(function (cd) {
                        // if (truckConfig != undefined) {
                        //     truckConfig.map(function (tc) {
                        //         if (cd.vehicle_cap == tc.vehicle_capacity) {
                        //             console.log(cd.vehicle_cap, tc.vehicle_capacity, "vech")
                        //             cdArray.push({
                        //                 vehicle_cap: cd.vehicle_cap,
                        //                 min_capacity_cmt: cd.min_capacity_cmt,
                        //                 max_capacity_cmt: cd.max_capacity_cmt,
                        //                 min_courier: cd.min_courier,
                        //                 nodes_per_truck: cd.nodes_per_truck,
                        //                 allowed_distance: cd.allowed_distance,
                        //                 deviation_allowed: cd.deviation_allowed,
                        //                 telescopic_route: cd.telescopic_route,
                        //                 vehicle_count: tc.vehicle_count,
                        //             });
                        //             console.log(cdArray, "cdArray")
                        //         }
                        //     });
                        // }
                        // truckConfig can be absent (older plans, or a snapshot that failed at plan
                        // time) - read that as "no trucks", never crash the whole tab on it.
                        var newObject = Array.isArray(truckConfig)
                            ? truckConfig.find((each) => each.vehicle_capacity == cd.vehicle_cap) : undefined;
                        if (newObject) {
                            cdArray.push({
                                vehicle_cap: cd.vehicle_cap,
                                zone: cd.zone,
                                min_capacity_cmt: cd.min_capacity_cmt,
                                max_capacity_cmt: cd.max_capacity_cmt,
                                min_courier: cd.min_courier,
                                max_consignee_cmt: cd.max_consignee_cmt,
                                minimum_nodes: cd.minimum_nodes,
                                nodes_per_truck: cd.nodes_per_truck,
                                vehicle_capacity: cd.vehicle_capacity,
                                recommendation_cmt: cd.recommendation_cmt,
                                allowed_distance: cd.allowed_distance,
                                vehicle_count: newObject.vehicle_count,
                            });
                        }
                        else {
                            cdArray.push({
                                vehicle_cap: cd.vehicle_cap,
                                zone: cd.zone,
                                min_capacity_cmt: cd.min_capacity_cmt,
                                max_capacity_cmt: cd.max_capacity_cmt,
                                min_courier: cd.min_courier,
                                max_consignee_cmt: cd.max_consignee_cmt,
                                minimum_nodes: cd.minimum_nodes,
                                nodes_per_truck: cd.nodes_per_truck,
                                vehicle_capacity: cd.vehicle_capacity,
                                recommendation_cmt: cd.recommendation_cmt,
                                allowed_distance: cd.allowed_distance,
                                vehicle_count: 0,
                            });
                        }
                    })
                }
            }
            var truckloadApproved = loadprocess.length > 0 ? !!loadprocess[0].truckload_approved : false;
            this.setState({
                rowData: loadprocess,
                fileName: fileName,
                transactionId: transactionId,
                configurationData: cdArray,
                truckAvailabilityData: truckAvailabilityData,
                comp_short_name: comp_short_name,
                loading_port_code: loading_port_code,
                data_type: data_type,
                truckload_approved: truckloadApproved,
                // When this plan was generated (same createDate lmloadsummary.js's own
                // grid already shows) - Upload Loading Plan's own window is derived
                // from this, not a separate field.
                createDate: loadprocess.length > 0 ? loadprocess[0].createDate : null
            })
            let params = {
                transactionId: transactionId,
                plantCode: loading_port_code
            }
            redirectURL.post("/lmconsignees/getTransactionConsolidatedFile", params).then((response1) => {
                var consolidatedFile = response1.data;
                this.setState({
                    consolidatedFile: consolidatedFile
                });
            });
        }).catch((e) => {
            console.log(e);
        })
        await this.onLoadPageData(transactionId);
        // await this.onLoadSeriesData(transactionId);
        // await this.onLoadCostSummaryData(transactionId);
        // await this.getRecommondationsData(transactionId);
    }
    onLoadPageData(transactionId) {
        var data_type = this.state.data_type;
        var depot = this.state.loading_port_code;
        var params = {
            "transactionId": transactionId,
            "data_type": data_type,
            "depot": depot
        }
        redirectURL.post("/lmconsignees/getLoadSummaryDetails", params).then((response) => {
            console.log(response.data, "chartData");
            if (Object.keys(response.data).length == 0) {
                this.setState({
                    show: true,
                    basicTitle: "No data found",
                    basicType: "danger",
                    loadshow: "show-n"
                })
            }
            if (data_type == 2) {
                var respData = [{
                    "name": "Total Order CMT",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_orders.toFixed(2)),
                },
                {
                    "name": "Loads Planned",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_truck_orders.toFixed(2)),
                },
                {
                    "name": "Dropped Orders(CMT)",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_dropped_orders.toFixed(2)),
                },
                ];
                var categories = ["Total Order CMT", "Loads Planned", "Dropped Orders(CMT)"];
            }
            else {
                var respData = [{
                    "name": "Total Order CMT",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_orders.toFixed(2)),
                },
                {
                    "name": "Planned By Truck(CMT)",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_truck_orders.toFixed(2)),
                },
                {
                    "name": "Planned By Courier(CMT)",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_courier_orders.toFixed(2)),
                    "color": "#4c923e"
                },
                {
                    "name": "Dropped Orders(CMT)",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_dropped_orders.toFixed(2)),
                },
                ];
                var categories = ["Total Order CMT", "Planned By Truck(CMT)", "Planned By Courier(CMT)", "Dropped Orders(CMT)"];
            }
            var droppedReasons = Object.values(response.data.droppedReasons);
            var drpData = [];
            var drpCategories = [];
            if (droppedReasons.length > 0) {
                droppedReasons.map(function (k) {
                    drpData.push({
                        "name": k.dropped_reason,
                        "showTooltip": 1,
                        "y": parseFloat(k.dropped_count.toFixed(2)),
                        color: '#ec6b56'
                    })
                    drpCategories.push(k.dropped_reason)
                });
            } else {
                drpData.push({
                    "name": 'No Invalid Orders',
                    "showTooltip": 1,
                    "y": parseFloat(0),
                    color: '	#47b39c'
                })
            }
            drpData.push({
                "name": 'Accepted Orders',
                "showTooltip": 1,
                "y": parseFloat(response.data.total_accepted_count),
                color: '	#47b39c'
            })
            drpCategories.push('Accepted Orders')
            var costResData = Object.values(response.data.cost_summary);
            var costData = [];
            var costCategories = [];
            var totalCost = 0;
            var actcostData = [];
            var actcostCategories = [];
            var acttotalCost = 0;
            costResData.map(function (k) {
                totalCost = parseFloat(totalCost) + parseFloat(k.vehicleCost);
                acttotalCost = parseFloat(acttotalCost) + parseFloat(k.actual_cost);
            });
            costData.push({
                "name": "Total Freight Cost",
                "showTooltip": 1,
                "y": parseFloat(totalCost.toFixed(2)),
            })

            actcostData.push({
                "name": "Total Freight Cost",
                "showTooltip": 1,
                "y": parseFloat(acttotalCost.toFixed(2)),
            })
            costResData.map(function (e) {
                if (e.truck_capacity == "Courier") {
                    costData.push({
                        "name": e.truck_capacity,
                        "showTooltip": 1,
                        "y": parseFloat(e.vehicleCost.toFixed(2)),
                        "color": "#4c923e"
                    })
                    actcostData.push({
                        "name": e.truck_capacity,
                        "showTooltip": 1,
                        "y": parseFloat(e.actual_cost.toFixed(2)),
                        "color": "#4c923e"
                    })
                }
                else {
                    costData.push({
                        "name": e.truck_capacity,
                        "showTooltip": 1,
                        "y": parseFloat(e.vehicleCost.toFixed(2)),
                    })
                    actcostData.push({
                        "name": e.truck_capacity,
                        "showTooltip": 1,
                        "y": parseFloat(e.actual_cost.toFixed(2)),
                    })
                }
                costCategories.push(e.truck_capacity)
                actcostCategories.push(e.truck_capacity)
            });
            this.setState({
                seriesData: respData,
                categories: categories,
                drpData: drpData,
                drpCategories: drpCategories,
                costData: costData,
                costCategories: costCategories,
                actcostData: actcostData,
                actcostCategories: actcostCategories,
                insights: (response.data && response.data.planning) ? response.data : null,
                summaryLoaded: true,
                overly: "show-n",
                loadshow: "show-n",
            })
        }).catch((e) => {
            console.log(e);
            this.setState({
                // seriesData : respData,
                // categories : categories,
                // drpData : drpData,
                // drpCategories : drpCategories,
                // costData : costData,
                // costCategories : costCategories,
                // actcostData : actcostData,
                // actcostCategories : actcostCategories,
                overly: "show-n",
                loadshow: "show-n",
            })
        })
    }
    onLoadSeriesData(transactionId) {
        var data_type = this.state.data_type;
        var params = {
            "transactionId": transactionId,
            "data_type": data_type
        }
        redirectURL.post("/lmconsignees/getLmChartData", params).then((response) => {
            console.log(response.data, "chartData");
            if (data_type == 2) {
                var respData = [{
                    "name": "Total Order CMT",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_orders.toFixed(2)),
                },
                {
                    "name": "Loads Planned",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_truck_orders.toFixed(2)),
                },
                {
                    "name": "Dropped Orders(CMT)",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_dropped_orders.toFixed(2)),
                },
                ];
                var categories = ["Total Order CMT", "Loads Planned", "Dropped Orders(CMT)"];
            }
            else {
                var respData = [{
                    "name": "Total Order CMT",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_orders.toFixed(2)),
                },
                {
                    "name": "Planned By Truck(CMT)",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_truck_orders.toFixed(2)),
                },
                {
                    "name": "Planned By Courier(CMT)",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_courier_orders.toFixed(2)),
                    "color": "#4c923e"
                },
                {
                    "name": "Dropped Orders(CMT)",
                    "showTooltip": 1,
                    "y": parseFloat(response.data.total_dropped_orders.toFixed(2)),
                },
                ];
                var categories = ["Total Order CMT", "Planned By Truck(CMT)", "Planned By Courier(CMT)", "Dropped Orders(CMT)"];
            }
            var droppedReasons = response.data.droppedReasons;
            var drpData = [];
            var drpCategories = [];
            droppedReasons.map(function (k) {
                drpData.push({
                    "name": k.dropped_reason,
                    "showTooltip": 1,
                    "y": parseFloat(k.dropped_count.toFixed(2)),
                })
                drpCategories.push(k.dropped_reason)
            });
            this.setState({
                seriesData: respData,
                categories: categories,
                drpData: drpData,
                drpCategories: drpCategories,
                overly: "show-n",
                loadshow: "show-n",
            })
        }).catch((e) => {
            console.log(e);
        })
    }
    onLoadCostSummaryData(transactionId) {
        var params = {
            "transactionId": transactionId,
            "data_type": this.state.data_type
        }
        redirectURL.post("/lmconsignees/getLmChartCostSummaryData", params).then((response) => {
            console.log(response.data, "costData");
            var costResData = response.data;
            var costData = [];
            var costCategories = [];
            var totalCost = 0;
            costResData.map(function (k) {
                totalCost = parseFloat(totalCost) + parseFloat(k.vehiCost);
            });
            costData.push({
                "name": "Total Freight Cost",
                "showTooltip": 1,
                "y": parseFloat(totalCost.toFixed(2)),
            })
            costResData.map(function (e) {
                if (e.truck_capacity == "Courier") {
                    costData.push({
                        "name": e.truck_capacity,
                        "showTooltip": 1,
                        "y": parseFloat(e.vehiCost.toFixed(2)),
                        "color": "#4c923e"
                    })
                }
                else {
                    costData.push({
                        "name": e.truck_capacity,
                        "showTooltip": 1,
                        "y": parseFloat(e.vehiCost.toFixed(2)),
                    })
                }
                costCategories.push(e.truck_capacity)
            });
            //console.log(costData,"costData");
            //console.log(costCategories,"costCategories");
            this.setState({
                costData: costData,
                costCategories: costCategories,
            })
        }).catch((e) => {
            console.log(e);
        })

        redirectURL.post("/lmconsignees/getLmChartActualCostSummaryData", params).then((response) => {
            console.log(response.data, "actualcostData");
            var actcostResData = response.data;
            var actcostData = [];
            var actcostCategories = [];
            var totalCost = 0;
            actcostResData.map(function (k) {
                totalCost = parseFloat(totalCost) + parseFloat(k.vehiCost);
            });
            actcostData.push({
                "name": "Total Freight Cost",
                "showTooltip": 1,
                "y": parseFloat(totalCost.toFixed(2)),
            })
            actcostResData.map(function (e) {
                if (e.truck_capacity == "Courier") {
                    actcostData.push({
                        "name": e.truck_capacity,
                        "showTooltip": 1,
                        "y": parseFloat(e.vehiCost.toFixed(2)),
                        "color": "#4c923e"
                    })
                }
                else {
                    actcostData.push({
                        "name": e.truck_capacity,
                        "showTooltip": 1,
                        "y": parseFloat(e.vehiCost.toFixed(2)),
                    })
                }
                actcostCategories.push(e.truck_capacity)
            });
            //console.log(actcostData,"actcostData");
            //console.log(costCategories,"costCategories");
            this.setState({
                actcostData: actcostData,
                actcostCategories: actcostCategories,
            })
        }).catch((e) => {
            console.log(e);
        })
    }
    getClustersData(transactionId) {
        var params = {
            "transactionId": transactionId,
            "data_type": this.state.data_type
        }
        redirectURL.post("/lmconsignees/getClustersData", params).then((response) => {
            console.log(response.data, "clustersData");
            this.setState({
                clustersData: response.data,
                overly: "show-n",
                loadshow: "show-n",
            })
        }).catch((e) => {
            console.log(e);
        })
    }
    getCouriersData(transactionId) {
        var params = {
            "transactionId": transactionId
        }
        redirectURL.post("/lmconsignees/getCouriersData", params).then((response) => {
            console.log(response.data, "couriersData");
            this.setState({
                couriersData: response.data,
                overly: "show-n",
                loadshow: "show-n",
            })
        }).catch((e) => {
            console.log(e);
        })
    }
    getAirCourierData(transactionId) {
        var params = {
            "transactionId": transactionId
        }
        redirectURL.post("/lmconsignees/getAirCourierSummaryData", params).then((response) => {
            console.log(response.data, "airCourierData");
            this.setState({
                airCourierData: response.data,
                overly: "show-n",
                loadshow: "show-n",
            })
        }).catch((e) => {
            console.log(e);
        })
    }
    getHubHoldLoadData(transactionId) {
        var params = {
            "transactionId": transactionId
        }
        redirectURL.post("/lmconsignees/getHubHoldLoadData", params).then((response) => {
            // console.log(response.data,"couriersData"); 
            console.log([...new Set(response.data.map((each) => each.zone))])
            this.setState({
                hubHoldLoadData: response.data,
                overly: "show-n",
                loadshow: "show-n",
            })
        }).catch((e) => {
            console.log(e);
        })
    }

    getCourierHoldLoadData(transactionId) {
        var params = {
            "transactionId": transactionId
        }
        redirectURL.post("/lmconsignees/getCourierHoldLoadData", params).then((response) => {
            // console.log(response.data,"couriersData");    

            this.setState({
                courierHoldLoadData: response.data,
                overly: "show-n",
                loadshow: "show-n",
            })
        }).catch((e) => {
            console.log(e);
        })
    }
    getRecommondationsData(transactionId) {
        var params = {
            "transactionId": transactionId
        }
        redirectURL.post("/lmconsignees/getRecommondationsData", params).then((response) => {
            console.log(response.data, "recommData");
            this.setState({
                recommData: response.data,
                overly: "show-n",
                loadshow: "show-n",
            })
        }).catch((e) => {
            console.log(e);
        })
    }
    getDroppedData(transactionId) {
        var params = {
            "transactionId": transactionId
        }
        redirectURL.post("/lmconsignees/getDroppedData", params).then((response) => {
            console.log(response.data, "droppedPData");
            this.setState({
                droppedPData: response.data,
                overly: "show-n",
                loadshow: "show-n",
            })
        }).catch((e) => {
            console.log(e);
        })
    }
    // Same real collection (lm_truckload_plan_data) the mobile Truck Load
    // Automation flow itself reads/writes - this is just a read-only view of
    // whatever's already been uploaded (via Upload Loading Plan on this same
    // page, or the mobile flow's own Input Plan screen) for this transaction.
    getTruckloadPlanData(transactionId) {
        var params = {
            transaction_id: transactionId,
            loading_port_code: this.state.loading_port_code
        }
        console.log('[truckload] getPlanData (Loading Plan tab)', params);
        redirectURL.post("/lmconsignees/truckload/getPlanData", params).then((response) => {
            this.setState({
                truckloadPlanData: response.data || [],
                // Rows selected before this refetch (e.g. right after a bulk
                // delete, or a fresh Upload/Add Row) no longer correspond to
                // anything meaningful in the newly-fetched rowData.
                selectedTruckloadPlanRows: [],
                overly: "show-n",
                loadshow: "show-n",
            })
        }).catch((e) => {
            console.log(e);
            this.setState({
                selectedTruckloadPlanRows: [],
                overly: "show-n",
                loadshow: "show-n",
            })
        })
    }
    // Loading Plan grid's own row-level delete - a completed (already-scanned)
    // HU is never even passed a row here (see PlanRowActionRenderer below,
    // same "no icon shown at all" convention lmtransporters.js's ActionRenderer
    // uses for an action that isn't valid on a given row).
    deleteTruckloadPlanRow = (row) => {
        if (!window.confirm("Delete HU " + row.hu + " (Trip " + row.trip_no + ") from the loading plan?")) return;
        this.setState({ overly: "show-m", loadshow: "show-m" });
        // staff_id/user_name/email - so the backend's soft-delete (is_active:0,
        // not a real removal now) can actually stamp who deleted it
        // (deleted_by), instead of it always coming back null.
        var params = {
            id: row._id, loading_port_code: this.state.loading_port_code,
            staff_id: localStorage.getItem('staff_id'),
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email')
        };
        console.log('[truckload] deleteTruckloadPlanRow', params);
        redirectURL.post("/lmconsignees/truckload/deleteTruckloadPlanRow", params).then(() => {
            this.getTruckloadPlanData(this.state.transactionId);
        }).catch((err) => {
            console.log(err);
            this.setState({
                overly: "show-n",
                loadshow: "show-n",
                show: true,
                basicType: "danger",
                basicTitle: (err.response && err.response.data && err.response.data.message) || "Delete failed"
            });
        });
    };

    // Same lucide-react icon + AG Grid framework-component pattern as
    // lmtransporters.js's ActionRenderer - a real React icon instead of an
    // icofont glyph/inline SVG string, sized down (12px) to sit compactly in
    // the grid row.
    PlanRowActionRenderer = (props) => {
        if (props.data.scan_status === "completed") {
            return <Trash className="text-muted" size={16} style={{ cursor: "not-allowed" }} title="Already scanned - can't be deleted" />;
        }
        return <Trash className="text-danger cursor-pointer" size={16} style={{ cursor: "pointer" }} title="Delete Row" onClick={() => this.deleteTruckloadPlanRow(props.data)} />;
    };

    // A completed (already-scanned) row is never selectable in the first place
    // (see isRowSelectable on the grid, same rule PlanRowActionRenderer already
    // enforces per-row) - selectedTruckloadPlanRows can only ever contain
    // deletable rows, so this stays in sync with the checkbox column.
    onTruckloadPlanSelectionChanged = (event) => {
        this.setState({ selectedTruckloadPlanRows: event.api.getSelectedRows() });
    };

    // Bulk twin of deleteTruckloadPlanRow above - same soft-delete endpoint
    // (is_active:0, never a real removal), just fired once per checked row
    // instead of once per Trash-icon click. No dedicated bulk endpoint on the
    // backend; this is the same request the single-row delete already makes,
    // run in parallel across the selection.
    bulkDeleteTruckloadPlanRows = () => {
        var rows = this.state.selectedTruckloadPlanRows;
        if (!rows.length) return;
        if (!window.confirm("Delete " + rows.length + " selected row(s) from the loading plan?")) return;
        this.setState({ overly: "show-m", loadshow: "show-m" });
        var identity = {
            staff_id: localStorage.getItem('staff_id'),
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email')
        };
        var loadingPortCode = this.state.loading_port_code;
        Promise.all(rows.map((row) => {
            var params = Object.assign({ id: row._id, loading_port_code: loadingPortCode }, identity);
            return redirectURL.post("/lmconsignees/truckload/deleteTruckloadPlanRow", params);
        })).then(() => {
            this.getTruckloadPlanData(this.state.transactionId);
        }).catch((err) => {
            console.log(err);
            // Refresh regardless of the error - some deletes in the batch may
            // have already succeeded even though one of them failed, so the
            // grid shouldn't keep showing rows that are actually gone.
            this.getTruckloadPlanData(this.state.transactionId);
            this.setState({
                show: true,
                basicType: "danger",
                basicTitle: (err.response && err.response.data && err.response.data.message) || "Bulk delete failed"
            });
        });
    };
    onClickSendRecommend() {
        var transactionId = this.state.transactionId;
        console.log(transactionId)
        var rowData = [];
        this.gridApi.forEachNode(node => rowData.push(node.data));
        //return rowData;
        console.log(rowData, "rowData")
    }
    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
        var sort = [
            {
                colId: 'cluster',
                sort: 'asc',
            },
        ];
        this.gridApi.setSortModel(sort);
    };
    onGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }

    getManualVsSystemRowStyle = (params) => {
        const remark = params.data.system_remarks || params.data.remarks;

        if (remark === "System Planned Data") {
            return { backgroundColor: '#e6f7ff' }; // light blue
        } else if (remark === "Extra Manual Pick Picket") {
            return { backgroundColor: '#fff4e6' }; // light orange
        } else if (remark === "Rates Not Available") {
            return { backgroundColor: '#f9e6ff' }; // Light lavender/purple
        } else {
            return null; // Default style
        }
    };


    onRecommGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
        var sort = [
            {
                colId: 'cluster',
                sort: 'asc',
            },
        ];
        this.gridApi.setSortModel(sort);
    };
    onRecommGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }


    closeAlert = () => {
        this.setState({
            show: false
        });
        if (this.state.basicType == "danger") {
            window.location.href = "/lmloadsummary"
        }
    }

    onCellClicked(e) {
        if (e.colDef.field == "container_no") {
            console.log(e.data.container_no);
        }
    }

    onClickHideAll() {
        if (this.state.loadshow === 'show-m' || this.state.truckloadSliderBusy) {
            return;
        }
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            bulkslide: "",
            bulkslide1: "",
            truckloadUploadSlide: "",
            truckloadAddSlide: ""
        });

    }
    showGrid() {
        this.setState({
            showCalendar: "show-n",
            showGridData: "show-m"
        })
    }

    handleDownloadOutputFile = async (idx) => {
        var outputFile = idx;
        let transactionId = this.state.transactionId;
        let plantCode = this.state.loading_port_code;
        let params = {
            transactionId: transactionId,
            plantCode: plantCode,
            outputFile: outputFile
        }
        this.setState({
            loadshow: "show-m",
            overly: "show-m"
        });
        try {
            const response = await redirectURL.post("/lmconsignees/downloadOutputFile", params, {
                responseType: 'blob' // Important: this tells axios to download the data as a Blob
            });

            // Create a new Blob object using the response data
            const blob = new Blob([response.data], { type: 'text/csv' });

            // Create a link element, use it to download the blob, and remove it
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = outputFile;
            document.body.appendChild(link);
            link.click();

            // Clean up and revoke the URL
            window.URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
            this.setState({
                loadshow: "show-n",
                overly: "show-n"
            });
            console.log("File download should have started.");
        } catch (error) {
            console.error('Error downloading file:', error);
            this.setState({
                loadshow: "show-n",
                overly: "show-n"
            });
        }
    }

    // ---------- Upload Load Plan (mobile Truck Load Automation) ----------
    // Upload Loading Plan stays open through 2 days after the plan was generated
    // (createDate) - generated on the 12th means uploads are still allowed all
    // through the 14th, blocked starting the 15th. Compared at the calendar-day
    // level (not exact hours) since this is naturally a whole-day cutoff, not a
    // precise hour-count timer. Fails OPEN (returns true) when createDate is
    // missing rather than unexpectedly blocking a plan we simply don't have
    // this field for.
    isUploadWindowOpen = () => {
        if (!this.state.createDate) return true;
        var created = new Date(this.state.createDate);
        if (isNaN(created.getTime())) return true;
        var deadline = new Date(created.getFullYear(), created.getMonth(), created.getDate() + 2, 23, 59, 59, 999);
        return new Date() <= deadline;
    };

    showTruckloadUpload = () => {
        this.setState({
            overly: "show-m",
            truckloadUploadSlide: "slider-translate-40p",
            truckloadDragging: false,
            truckloadDateFormat: "",
            truckloadPendingRows: null,
            truckloadDateSample: "",
            truckloadSampleRow: null,
            truckloadDateAmbiguous: false,
            truckloadSliderBusy: false,
            truckloadUploadFileName: "",
            truckloadValidRows: [],
            truckloadErrors: [],
            truckloadResults: null,
            truckloadDuplicateHUs: [],
            truckloadPlanDateMismatchHUs: [],
            truckloadPlanDateOutOfWindowHUs: [],
            truckloadUploadMessage: null
        });
    };

    onTruckloadDateFormatChange = (option) => {
        // react-select passes the whole {value,label} option (or null, if
        // cleared) - truckloadDateFormat itself stays a plain string everywhere
        // else in this file (parsePlanDateText lookups, error messages), so
        // only the value is pulled out here.
        var format = option ? option.value : "";
        // The rows read from the file (already past the required-fields check
        // - see checkTruckloadRequiredFields) are held in truckloadPendingRows
        // the moment an ambiguous Plan Date cell is spotted - picking (or
        // changing) a format here just resumes finalizing those same rows
        // against it, no re-upload needed. setState's callback form is
        // required, not a plain read right after - truckloadDateFormat
        // wouldn't be updated yet on the very next line otherwise, and
        // finalizeTruckloadDates reads it internally.
        this.setState({ truckloadDateFormat: format, truckloadErrors: [], truckloadValidRows: [], truckloadResults: null }, () => {
            if (format && this.state.truckloadPendingRows) {
                this.finalizeTruckloadDates(this.state.truckloadPendingRows);
            }
        });
    };

    toggleTruckloadRules = () => {
        this.setState({ truckloadRulesExpanded: !this.state.truckloadRulesExpanded });
    };

    showTruckloadAdd = () => {
        this.setState({
            overly: "show-m",
            truckloadAddSlide: "slider-translate-40p",
            truckloadAddRow: { trip_no: "", trip_type: "", consignee: "", doc_no: "", hu: "", doc_type: "", plan_date: "" },
            truckloadAddErrors: [],
            truckloadResults: null,
            truckloadDuplicateHUs: [],
            truckloadPlanDateMismatchHUs: [],
            truckloadPlanDateOutOfWindowHUs: [],
            truckloadUploadMessage: null,
            truckloadSliderBusy: false
        });
    };

    hideTruckloadAdd = () => {
        this.setState({
            overly: "show-n",
            truckloadAddSlide: ""
        });
    };

    onTruckloadAddFieldChange = (field, value) => {
        this.setState({ truckloadAddRow: Object.assign({}, this.state.truckloadAddRow, { [field]: value }) });
    };

    // react-datetime's onChange passes a moment object when a real date was
    // picked/typed-and-parsed, or the raw typed string when it doesn't parse
    // as a date yet (still mid-typing) - only commit the "YYYY-MM-DD" form
    // once it's a genuine date, same convention this codebase already uses
    // elsewhere (see lmshareofbusiness.js's handlerStartDateTime).
    onTruckloadAddPlanDateChange = (value) => {
        if (value && value._d) {
            var d = new Date(value._d);
            var pad = (n) => String(n).padStart(2, '0');
            this.onTruckloadAddFieldChange('plan_date', d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()));
        } else {
            this.onTruckloadAddFieldChange('plan_date', typeof value === 'string' ? value : '');
        }
    };

    // Same field-level checks as checkTruckloadRequiredFields (bulk upload),
    // applied to the single row from the Add slider - "same restrictions as
    // bulk upload".
    submitTruckloadAddRow = () => {
        var row = this.state.truckloadAddRow;
        var consignee = this.safeIdString(row.consignee) || "";
        var doc_no = this.safeIdString(row.doc_no) || "";
        var hu = this.safeIdString(row.hu);
        var doc_type = String(row.doc_type || "").trim();
        var trip_no = this.safeIdString(row.trip_no) || "";
        var trip_type = String(row.trip_type || "").trim();
        var plan_date = String(row.plan_date || "").trim();
        if (hu === null) {
            this.setState({ truckloadAddErrors: ["HU value lost precision (scientific notation) - re-enter it as plain text"] });
            return;
        }
        // Every field is mandatory - same restriction as the bulk-upload
        // template (see checkTruckloadRequiredFields).
        var missingFields = [];
        if (!consignee) missingFields.push("Consignee");
        if (!doc_no) missingFields.push("Doc. No.");
        if (!hu) missingFields.push("HU");
        if (!doc_type) missingFields.push("Doc. Type");
        if (!trip_no) missingFields.push("Trip No.");
        if (!trip_type) missingFields.push("Trip Type");
        if (!plan_date) missingFields.push("Plan Date");
        if (missingFields.length > 0) {
            this.setState({ truckloadAddErrors: [missingFields.join(', ') + (missingFields.length > 1 ? " are missing" : " is missing") + " - all fields are mandatory"] });
            return;
        }
        // Presence alone isn't enough - the field is typed free-text, so it
        // has to actually be a real, validly-formed calendar date before it's
        // trusted. Without this, a typo (or anything that doesn't split into
        // exactly 3 YYYY-MM-DD parts) would silently become new Date(null) =
        // 1-Jan-1970 once it reaches the backend, with no error shown here.
        var planDateObj = this.planDateStringToDate(plan_date);
        if (!planDateObj) {
            this.setState({ truckloadAddErrors: ["Plan Date '" + plan_date + "' is not a valid date - enter it as YYYY-MM-DD (e.g. 2026-08-06)"] });
            return;
        }
        // Client-side twin of insertNewTripPlanData's own committed-date rule
        // on the backend (see getCommittedPlanDateForTrip) - a trip is one
        // vehicle's load on one scheduled day, so every HU under the same
        // Trip No has to share the same Plan Date. Checked here purely for
        // instant feedback before Submit; the backend re-checks this for real
        // at insert time regardless.
        var committedDate = this.getCommittedPlanDateForTrip(trip_no);
        if (committedDate !== undefined && new Date(committedDate).getTime() !== planDateObj.getTime()) {
            this.setState({ truckloadAddErrors: ["Trip " + trip_no + " already has Plan Date " + getHyphenDDMMMYYYY(committedDate) + " - every HU under the same Trip No must share the same Plan Date"] });
            return;
        }
        // Client-side twin of uploadPlanData's own plan_date-window check on
        // the backend (see isPlanDateWithinWindow) - separate from the
        // committed-date check above, which only compares against this
        // trip's OWN other rows, not against the plan's actual approval
        // window. Checked here purely for instant feedback before Submit.
        if (!this.isPlanDateWithinWindow(planDateObj)) {
            var window = this.getPlanDateWindow();
            this.setState({ truckloadAddErrors: [window
                ? "Plan Date has to fall between " + getHyphenDDMMMYYYY(window.start) + " and " + getHyphenDDMMMYYYY(window.end) + " for this plan"
                : "Plan Date is outside this plan's upload window"] });
            return;
        }
        this.setState({ truckloadAddErrors: [], overly: "show-m", truckloadSliderBusy: true });
        var params = {
            transaction_id: this.state.transactionId,
            plan_id: this.state.transactionId,
            loading_port_code: this.state.loading_port_code,
            comp_code: localStorage.getItem('selected_comp_code') || localStorage.getItem('comp_code'),
            filename: "manual-add",
            rows: [{ consignee, doc_no, hu, doc_type, trip_no, trip_type, plan_date: planDateObj }],
            staff_id: localStorage.getItem('staff_id'),
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email')
        };
        console.log('[truckload] uploadPlanData (single add)', params);
        redirectURL.post("/lmconsignees/truckload/uploadPlanData", params).then((response) => {
            this.handleUploadPlanDataResponse(response);
        }).catch((e) => {
            console.log(e);
            // overly stays "show-m" - the Add slider is still open, its dark
            // backdrop has to stay too. Only truckloadSliderBusy (the in-slider
            // loader) turns off.
            this.setState({
                overly: "show-m",
                truckloadSliderBusy: false,
                show: true,
                basicType: "danger",
                basicTitle: (e.response && e.response.data && e.response.data.message) || "Add row failed"
            });
        });
    };

    hideTruckloadUpload = () => {
        this.setState({
            overly: "show-n",
            truckloadUploadSlide: ""
        });
    };

    // Same engine as lmconsignees.js's bulk upload (XLSX, not CSVFileValidator) -
    // header names map straight onto the plan-data fields the backend/mobile flow
    // expect (consignee, doc_no, hu, doc_type, trip_no, trip_type, plan_date).
    handleTruckloadFile = (file) => {
        if (!file) return;
        // truckloadSliderBusy - a loader scoped to the slider itself (see the
        // render below), not the whole-page loadshow spinner - the actual
        // parse+validate work below is fully synchronous (XLSX parsing,
        // HU-uniqueness checks, date-format parsing across every row), so it
        // can be genuinely slow for a large file; this gives the operator
        // visible feedback (and makes the slider itself uninteractive while
        // busy) instead of the UI looking frozen or clickable mid-check. Also
        // blocks onClickHideAll from closing the slider mid-check.
        this.setState({
            truckloadUploadFileName: file.name, truckloadErrors: [], truckloadValidRows: [], truckloadResults: null,
            // Duplicate-HU table and the result message banner from a
            // PREVIOUS file's check/submit also have to clear here - without
            // this, re-selecting a new file left the old file's leftover
            // duplicates/message sitting on screen alongside (or ahead of)
            // the new file's own results.
            truckloadDuplicateHUs: [], truckloadPlanDateMismatchHUs: [], truckloadPlanDateOutOfWindowHUs: [], truckloadUploadMessage: null,
            truckloadDateFormat: "", truckloadPendingRows: null, truckloadDateSample: "", truckloadSampleRow: null,
            overly: "show-m", truckloadSliderBusy: true
        });

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = (event) => {
            // setTimeout so the loader set above actually gets to paint before
            // this synchronous work blocks the main thread - without it, the
            // browser has no chance to render the loading state at all.
            setTimeout(() => {
                // cellDates:true - without it, a "Plan Date" column that Excel/Google
                // Sheets has formatted as an actual Date cell (not plain text, e.g. after
                // opening/re-saving the .csv template in Excel) comes through as a raw
                // numeric day-serial (Excel's date epoch) instead of a real date, and
                // String(that number) just stores the serial number, not the date.
                const workbook = XLSX.read(new Uint8Array(event.target.result), { type: "array", cellDates: true });
                const sheet = workbook.Sheets[workbook.SheetNames[0]];
                const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

                // checkTruckloadRequiredFields owns turning the loader back off
                // itself now (it may go on to await the stage-2 duplicate
                // pre-check), so switching it off here would hide it while
                // that request is still in flight.
                this.checkTruckloadRequiredFields(data);
            }, 50);
        };
    };

    // Normalizes a "Plan Date" cell to YYYY-MM-DD regardless of how XLSX parsed it:
    // a real Date object (from cellDates:true above), a raw Excel day-serial number
    // (belt-and-suspenders, in case cellDates didn't catch it), or already a plain
    // text string (a genuine .csv upload, never touched by Excel).
    normalizePlanDate = (value) => {
        var pad = (n) => String(n).padStart(2, '0');
        if (value instanceof Date) {
            // Local getters, not UTC - matches how xlsx's own cellDates:true
            // builds this Date (LOCAL-time semantics). BUT: xlsx's internal
            // date math (numdate/datenum) computes a fixed one-time offset
            // between "1899-12-30 local" and "today local" to correct for
            // any DST drift between those two dates - and for Asia/Kolkata
            // specifically, that offset is never actually zero: India's
            // pre-1906 standard time was UTC+05:21, not today's UTC+05:30, a
            // genuine ~9-minute historical discontinuity this IANA timezone
            // database still reports. xlsx's own correction only re-checks
            // for a DST-style mismatch on the RESULT date (which is always a
            // modern date here, so it never differs from "today") - it never
            // catches THIS specific historical mismatch, so every real Excel
            // Date cell parsed under this timezone consistently comes back
            // ~9m50s BEFORE local midnight (verified directly against the
            // installed xlsx version: serial 46251 = 2026-08-17 comes back
            // as "Aug 16, 2026 23:59:50", not "Aug 17, 2026 00:00:00").
            // Reading Y/M/D straight off that lands on the wrong (earlier)
            // day every single time - this is exactly what was turning a
            // typed "17-Aug-26" into a stored "16-Aug-2026". A 1-hour buffer
            // pushes any such near-midnight-undershoot into the correct day
            // while staying far too small to ever misfire on a cell that
            // was already sitting at a clean local midnight.
            var adjusted = new Date(value.getTime() + 60 * 60 * 1000);
            return adjusted.getFullYear() + '-' + pad(adjusted.getMonth() + 1) + '-' + pad(adjusted.getDate());
        }
        if (typeof value === 'number') {
            // Math.round, not Math.floor - a date-only Excel serial is
            // conceptually always a whole integer, but the actual float value
            // Excel/Google Sheets/LibreOffice hands over often carries tiny
            // sub-integer drift (e.g. 46250.999999998 instead of exactly
            // 46251) from =TODAY()/autofill or having been round-tripped
            // through more than one tool. flooring a value that drifted
            // slightly LOW silently lands on the previous day; rounding
            // discards that noise in either direction.
            var utcDays = Math.round(value - 25569); // Excel epoch (1899-12-30) -> Unix epoch offset in days
            var d = new Date(utcDays * 86400 * 1000);
            return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
        }
        return String(value || "").trim();
    };

    // Converts the "YYYY-MM-DD" string normalizePlanDate/normalizePlanDateFromFile
    // produce into a genuine Date (midnight UTC for that calendar day) - plan_date
    // is now stored in the DB as a real ISODate, not a string, so a developer
    // looking at the record directly sees an actual date, not text. UTC (not
    // local) so this can never shift by a day depending on the machine's own
    // timezone - the backend's own day-range match (getTruckloadPlanData/
    // getDashboardTrips) assumes the same UTC-midnight convention. Returns null
    // (not a best-effort guess) on anything that isn't a real, in-range
    // calendar date - Date.UTC on its own silently rolls an out-of-range value
    // like month 13 or day 45 into a DIFFERENT valid date instead of erroring,
    // which would otherwise let a typo through uncaught (see
    // submitTruckloadAddRow's own validity check).
    planDateStringToDate = (yyyyMmDd) => {
        var parts = String(yyyyMmDd || "").split('-');
        if (parts.length !== 3) return null;
        var year = parseInt(parts[0], 10), month = parseInt(parts[1], 10), day = parseInt(parts[2], 10);
        if (!year || !month || !day || isNaN(year) || isNaN(month) || isNaN(day)) return null;
        if (month < 1 || month > 12 || day < 1 || day > 31) return null;
        return new Date(Date.UTC(year, month - 1, day));
    };

    // Splits a plain-text date cell into its 3 tokens and reads them in the
    // order the user picked (see PLAN_DATE_FORMATS) - returns null (not a
    // guess) when the text doesn't split into exactly 3 tokens, when a
    // token's own SHAPE doesn't match what that position should look like
    // (a 4-digit year token landing where a 1-2 digit day/month was expected,
    // or vice versa - range-checking day/month alone let a 4-digit value
    // like "2026" silently pass as a "day" as long as parseInt didn't
    // exceed 31, which it does, but a stray 3-digit value wouldn't have been
    // caught the same way), or when the resulting day/month is out of range -
    // any of those means either the cell isn't a date at all or the picked
    // format genuinely doesn't match this file, not something to guess through.
    parsePlanDateText = (value, order) => {
        var tokens = String(value || "").trim().split(/[^0-9A-Za-z]+/).filter(Boolean);
        if (tokens.length !== 3) return null;
        var pad = (n) => String(n).padStart(2, '0');
        var day = null, month = null, year = null;
        for (var i = 0; i < order.length; i++) {
            var token = order[i];
            var part = tokens[i];
            if (token === 'D') {
                if (!/^\d{1,2}$/.test(part)) return null;
                day = parseInt(part, 10);
            }
            else if (token === 'M') {
                if (!/^\d{1,2}$/.test(part)) return null;
                month = parseInt(part, 10);
            }
            else if (token === 'Mon') {
                if (!/^[A-Za-z]+$/.test(part)) return null;
                month = PLAN_DATE_MONTH_NAMES[part.toLowerCase().slice(0, 3)];
            }
            else if (token === 'Y') {
                if (!/^\d{4}$/.test(part)) return null;
                year = parseInt(part, 10);
            }
            else if (token === 'Y2') {
                if (!/^\d{2}$/.test(part)) return null;
                var y2 = parseInt(part, 10);
                year = y2 < 70 ? 2000 + y2 : 1900 + y2; // 00-69 -> 2000s, 70-99 -> 1900s
            }
        }
        if (!day || !month || !year || isNaN(day) || isNaN(month) || isNaN(year)) return null;
        if (day < 1 || day > 31 || month < 1 || month > 12) return null;
        return year + '-' + pad(month) + '-' + pad(day);
    };

    // Resolves an already-Date/number cell's own (year, month, day), then
    // applies the selected format value the same way for both
    // normalizePlanDateFromFile (which only needs the result) and the Step 3
    // live preview (which needs to explain EXACTLY why to the operator, e.g.
    // "day 13 can't be a month" - not just a generic "pick YYYY-MM-DD or
    // YYYY-DD-MM" when one of those two doesn't actually apply to THIS row
    // either). Excel's own date resolution can itself be wrong (it silently
    // picked using whatever regional format was active on the file author's
    // machine when they entered it - see the "06/08/2026 could be 5-Aug or
    // 8-May" case), so the format picker has to be able to override it, not
    // be silently ignored for anything that happens to already be a Date
    // cell. Only the two Y-first formats can ever apply, since a resolved
    // cell is always DISPLAYED/read back as "YYYY-<part>-<part>" (see
    // normalizePlanDate) - everything else (DD-MM-YYYY, MM-DD-YYYY, etc.)
    // doesn't match that shape at all.
    resolveDateCellFormat = (value, formatValue) => {
        var pad = (n) => String(n).padStart(2, '0');
        var resolved;
        if (value instanceof Date) {
            // +1hr buffer before reading local getters - see normalizePlanDate's
            // own comment on this same pattern: xlsx's cellDates:true Date
            // objects consistently land ~9m50s before local midnight under
            // Asia/Kolkata (a real historical pre-1906 offset mismatch baked
            // into xlsx's own date math, never corrected for), so reading Y/M/D
            // straight off one lands on the wrong (earlier) day every time.
            var adjusted = new Date(value.getTime() + 60 * 60 * 1000);
            resolved = { year: adjusted.getFullYear(), month: adjusted.getMonth() + 1, day: adjusted.getDate() };
        } else {
            // Math.round, not Math.floor - see normalizePlanDate's own comment
            // on this same pattern: a date-only Excel serial is conceptually a
            // whole integer, but the real float value often carries tiny
            // sub-integer drift, and flooring a value that drifted slightly
            // low silently lands one day early.
            var utcDays = Math.round(value - 25569); // Excel epoch (1899-12-30) -> Unix epoch offset in days
            var d = new Date(utcDays * 86400 * 1000);
            resolved = { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() };
        }
        if (formatValue === 'YYYY-MM-DD') {
            return { result: resolved.year + '-' + pad(resolved.month) + '-' + pad(resolved.day) };
        }
        if (formatValue === 'YYYY-DD-MM') {
            // Swap - the operator is saying the two non-year parts read
            // day-then-month, i.e. Excel's own month/day assignment for this
            // cell is backwards.
            var month = resolved.day, day = resolved.month;
            // The swapped pair might not actually be a valid date (day 13
            // can't become month 13) - that's THIS format genuinely not
            // applying to THIS row, regardless of it being one of the two
            // normally-valid choices.
            if (month < 1 || month > 12) {
                return { result: null, reason: "this row's day (" + resolved.day + ") is greater than 12, so it can't be read as a month here - only YYYY-MM-DD applies to this row" };
            }
            return { result: resolved.year + '-' + pad(month) + '-' + pad(day) };
        }
        return { result: null, reason: "a resolved Excel date only accepts YYYY-MM-DD or YYYY-DD-MM, pick one of those above" };
    };

    // Bulk-file-only wrapper around normalizePlanDate - ALWAYS reinterprets
    // through the format the operator picked, for every cell type, not just
    // plain text. Returns null on failure so the caller can flag it as a row
    // error instead of silently uploading a wrong or garbage plan_date.
    normalizePlanDateFromFile = (value) => {
        var formatOption = PLAN_DATE_FORMATS.find((f) => f.value === this.state.truckloadDateFormat);
        if (!formatOption) return null;
        var pad = (n) => String(n).padStart(2, '0');

        if (value instanceof Date || typeof value === 'number') {
            return this.resolveDateCellFormat(value, formatOption.value).result;
        }

        // Plain text - the raw string's own tokens are read in the exact
        // position order the format specifies (see parsePlanDateText).
        var str = String(value || "").trim();
        if (!str) return null;
        return this.parsePlanDateText(str, formatOption.order);
    };

    handleTruckloadFileChange = (e) => {
        const file = e.target.files[0];
        e.target.value = "";
        this.handleTruckloadFile(file);
    };

    onTruckloadDragOver = (e) => {
        e.preventDefault();
        this.setState({ truckloadDragging: true });
    };

    onTruckloadDragLeave = (e) => {
        e.preventDefault();
        this.setState({ truckloadDragging: false });
    };

    onTruckloadDrop = (e) => {
        e.preventDefault();
        this.setState({ truckloadDragging: false });
        var file = e.dataTransfer.files && e.dataTransfer.files[0];
        this.handleTruckloadFile(file);
    };

    // A long numeric-looking ID (like a 12-digit HU barcode) that Excel auto-formats
    // as a Number instead of Text: String(rawNumber) is safe on its own (JS only
    // switches to exponential notation above 1e21), but if the SOURCE cell's own
    // "General" number format already rounded the value to something like
    // "1.01014E+11" before this file was ever uploaded, that precision is already
    // gone - and since many distinct IDs can round to the identical value, this is
    // exactly how "every HU stores the same value" happens. Returns null when that's
    // detected, so the caller can reject the row instead of silently storing a
    // possibly-corrupted/colliding ID.
    safeIdString = (value) => {
        if (typeof value === 'number') {
            return Number.isInteger(value) ? value.toFixed(0) : String(value);
        }
        var str = String(value || '').trim();
        if (/^\d+(\.\d+)?e\+?\d+$/i.test(str)) {
            return null;
        }
        return str;
    };

    // Phase 1 - required-field presence, HU precision-loss, and in-file HU
    // duplicates ONLY. Deliberately does NOT touch Plan Date format at all -
    // just whether the cell has something in it - since there's no point
    // asking the operator about date format in a file that's already missing
    // other mandatory fields. Only once this is 100% clean does the flow even
    // look at whether Plan Date needs a format decision (see below).
    checkTruckloadRequiredFields = (data) => {
        var errorList = [];
        var cleanedData = [];
        data.forEach((row, idx) => {
            var rowNum = idx + 2; // header row is row 1
            var consignee = this.safeIdString(row["Consignee"]) || "";
            var doc_no = this.safeIdString(row["Doc. No."]) || "";
            var hu = this.safeIdString(row["HU"]);
            var doc_type = String(row["Doc. Type"] || "").trim();
            var trip_no = this.safeIdString(row["Trip No."]) || "";
            var trip_type = String(row["Trip Type"] || "").trim();
            var planDateCell = row["Plan Date"];
            var planDateEmpty = !(planDateCell instanceof Date) && typeof planDateCell !== 'number' && !String(planDateCell || "").trim();
            if (hu === null) {
                errorList.push({ row: rowNum, error: "HU value '" + row["HU"] + "' lost precision in Excel (scientific notation) - format the HU column as Text, re-enter the value, and re-upload" });
                return;
            }
            // Every column in the template is mandatory now - collect the
            // SPECIFIC field names missing on THIS row instead of a fixed
            // 3-field message, so the error actually matches what's wrong
            // with this particular row.
            var missingFields = [];
            if (!consignee) missingFields.push("Consignee");
            if (!doc_no) missingFields.push("Doc. No.");
            if (!hu) missingFields.push("HU");
            if (!doc_type) missingFields.push("Doc. Type");
            if (!trip_no) missingFields.push("Trip No.");
            if (!trip_type) missingFields.push("Trip Type");
            if (planDateEmpty) missingFields.push("Plan Date");
            if (missingFields.length > 0) {
                errorList.push({ row: rowNum, error: missingFields.join(', ') + (missingFields.length > 1 ? " are missing" : " is missing") + " - all fields are mandatory" });
                return;
            }
            cleanedData.push({ row: rowNum, consignee, doc_no, hu, doc_type, trip_no, trip_type, planDateCell });
        });

        // An HU has to be unique across the whole plan (see insertNewTripPlanData
        // on the backend - trip_no is deliberately left out of that check too),
        // so it has to be unique within this one file as well - the same HU
        // listed twice (even under two different trips) can't both go through;
        // flag every row that shares a duplicated HU as an error instead of
        // silently letting one in and dropping/duplicating the rest.
        var rowsByHU = {};
        cleanedData.forEach((r) => {
            if (!rowsByHU[r.hu]) rowsByHU[r.hu] = [];
            rowsByHU[r.hu].push(r.row);
        });
        var fieldsValid = [];
        cleanedData.forEach((r) => {
            var rowsWithSameHU = rowsByHU[r.hu];
            if (rowsWithSameHU.length > 1) {
                var otherRows = rowsWithSameHU.filter((x) => x !== r.row).join(', ');
                errorList.push({ row: r.row, error: "HU '" + r.hu + "' is duplicated in this file (also on row " + otherRows + ") - each HU must appear only once" });
            } else {
                fieldsValid.push(r);
            }
        });

        // Hard stop - ANY error here blocks the WHOLE file, not just the bad
        // rows, until the file itself is fixed. The operator is never even
        // asked about Plan Date format until this passes completely.
        if (errorList.length > 0) {
            this.setState({
                overly: "show-m", truckloadSliderBusy: false, truckloadErrors: errorList, truckloadValidRows: [], truckloadDuplicateHUs: [],
                truckloadPendingRows: null, truckloadDateSample: "", truckloadSampleRow: null
            });
            return;
        }

        // All required fields are present and unique - NOW check whether Plan
        // Date needs a format decision. A plain-text cell (05/08/2026 could be
        // 5-Aug or 8-May) genuinely needs the operator to say which order THIS
        // file uses. A real Excel Date cell or a day-serial number has no
        // token order left to ask about - Excel itself already resolved it to
        // one specific date, using whatever regional format the FILE'S AUTHOR
        // had set, at the time they typed/entered it - if that resolution
        // doesn't match what the person uploading the file now assumes, the
        // mismatch already happened upstream in Excel and can't be
        // reconstructed here. The one thing we CAN still do for that case is
        // show the resolved date for a visual gut-check before it's ever
        // submitted, instead of silently trusting it.
        var ambiguousSample = null;
        var sampleRow = null;
        for (var i = 0; i < fieldsValid.length; i++) {
            var cell = fieldsValid[i].planDateCell;
            if (!(cell instanceof Date) && typeof cell !== 'number') { ambiguousSample = String(cell).trim(); sampleRow = fieldsValid[i]; break; }
        }
        // No ambiguous cell found - preview the FIRST row instead, using its
        // own already-resolved date as the confirmation reference point.
        if (!sampleRow) { sampleRow = fieldsValid[0]; }

        this.setState({
            overly: "show-m", truckloadSliderBusy: false, truckloadPendingRows: fieldsValid,
            truckloadDateSample: ambiguousSample, truckloadSampleRow: sampleRow,
            truckloadDateAmbiguous: !!ambiguousSample
        });
    };

    // A trip's committed Plan Date, read straight off the Loading Plan tab's
    // own already-fetched grid data (this.state.truckloadPlanData) - no
    // network round trip needed, since this transaction's existing plan rows
    // are already sitting in memory by the time either upload slider is even
    // open. Client-side twin of insertNewTripPlanData's own committed-date
    // rule on the backend - purely for instant feedback before Submit; that
    // backend check is what actually enforces this (this snapshot can go
    // stale the moment another upload lands, or be bypassed entirely by a
    // caller that skips the UI), so it stays in place regardless of this.
    getCommittedPlanDateForTrip = (tripNo) => {
        var row = this.state.truckloadPlanData.find((r) => String(r.trip_no) === String(tripNo));
        return row ? row.plan_date : undefined;
    };

    // The SAME 2-day window isUploadWindowOpen computes (createDate through
    // createDate+2) - but that function only gates whether the Upload/Add Row
    // buttons are clickable at all right now, not what plan_date VALUE a row
    // is allowed to carry once you're inside that window. This is the
    // client-side twin of the equivalent check in uploadPlanData on the
    // backend (that one is what actually enforces it - this is purely for
    // instant feedback before Submit). Deliberately separate from
    // isUploadWindowOpen rather than reusing it - one answers "can I upload
    // right now", the other answers "does THIS row's date belong to this
    // approval at all".
    getPlanDateWindow = () => {
        if (!this.state.createDate) return null;
        var created = new Date(this.state.createDate);
        if (isNaN(created.getTime())) return null;
        return {
            start: new Date(created.getFullYear(), created.getMonth(), created.getDate()),
            end: new Date(created.getFullYear(), created.getMonth(), created.getDate() + 2, 23, 59, 59, 999)
        };
    };

    // Fails OPEN (treats the date as valid) when createDate is missing,
    // same as isUploadWindowOpen - a plan we don't have this field for
    // shouldn't get unexpectedly blocked over it.
    isPlanDateWithinWindow = (planDateObj) => {
        var window = this.getPlanDateWindow();
        if (!window) return true;
        return planDateObj >= window.start && planDateObj <= window.end;
    };

    // Filters a bulk upload's already-dated rows against both the existing
    // grid (getCommittedPlanDateForTrip) AND each other - a trip is one
    // vehicle's load on one scheduled day, so every HU under the same Trip No
    // has to share one Plan Date, whether that date was already committed
    // before this upload or is only just now being established by this same
    // file. Rows that fail either check are pulled out into their own list
    // instead of being sent on to the duplicate-HU pre-check (or Submit) at
    // all - same shape (trip_no/hu/consignee/doc_no/committed_plan_date) the
    // backend's own rejection already reports, so both render through the
    // same disclaimer table.
    checkPlanDateMismatches = (dated) => {
        var committedByTrip = {};
        this.state.truckloadPlanData.forEach((r) => {
            var tripNo = String(r.trip_no);
            if (!(tripNo in committedByTrip)) committedByTrip[tripNo] = r.plan_date;
        });
        var stillValid = [];
        var mismatches = [];
        dated.forEach((r) => {
            var tripNo = String(r.trip_no);
            var committed = committedByTrip[tripNo];
            var rowDate = this.planDateStringToDate(r.plan_date);
            if (committed !== undefined && new Date(committed).getTime() !== rowDate.getTime()) {
                mismatches.push({ trip_no: r.trip_no, hu: r.hu, consignee: r.consignee, doc_no: r.doc_no, committed_plan_date: committed });
                return;
            }
            // First row for this trip_no with nothing committed in the grid
            // yet - claims this row's own date for the rest of the batch, so
            // a LATER row in this same file for the same (brand-new) trip
            // under a different date is caught too, not just mismatches
            // against what the grid already had before this upload started.
            if (committed === undefined) committedByTrip[tripNo] = rowDate;
            stillValid.push(r);
        });
        return { stillValid: stillValid, mismatches: mismatches };
    };

    // Client-side twin of uploadPlanData's own plan_date-window check on the
    // backend (see isPlanDateWithinWindow) - a row's plan_date has to belong
    // to THIS plan's own 2-day approval window, not just agree with its own
    // trip's other rows (checkPlanDateMismatches, above, is a different
    // check). Same shape (trip_no/hu/consignee/doc_no/plan_date) the
    // backend's own rejection reports, rendered through its own disclaimer
    // table below.
    checkPlanDateOutOfWindow = (dated) => {
        var stillValid = [];
        var outOfWindow = [];
        dated.forEach((r) => {
            var rowDate = this.planDateStringToDate(r.plan_date);
            if (!this.isPlanDateWithinWindow(rowDate)) {
                outOfWindow.push({ trip_no: r.trip_no, hu: r.hu, consignee: r.consignee, doc_no: r.doc_no, plan_date: rowDate });
                return;
            }
            stillValid.push(r);
        });
        return { stillValid: stillValid, outOfWindow: outOfWindow };
    };

    // Phase 2 - actually parses each row's Plan Date (using the format the
    // operator picked, if one was needed) and, once every row's date parses
    // successfully, runs the stage-2 DB-duplicate pre-check. Called either
    // directly (no format was needed) or from onTruckloadDateFormatChange
    // once a format's been picked/changed.
    finalizeTruckloadDates = (rows) => {
        var dated = [];
        var failedCount = 0;
        rows.forEach((r) => {
            var plan_date = this.normalizePlanDateFromFile(r.planDateCell);
            if (plan_date === null) { failedCount += 1; return; }
            dated.push(Object.assign({}, r, { plan_date }));
        });

        // Same hard-stop rule as phase 1 - a format mismatch on even one row
        // blocks the whole file (or points at picking a different format,
        // since the Select stays visible via truckloadPendingRows) rather
        // than silently going ahead with only the rows that happened to
        // parse. Deliberately NOT surfaced via the Validation Errors table -
        // the live preview right above the format Select (Step 3) already
        // shows exactly why the currently-selected format is invalid for the
        // sample row; a second, separate table repeating the same thing in
        // the same slider would just be noise.
        if (failedCount > 0) {
            this.setState({ overly: "show-m", truckloadSliderBusy: false, truckloadErrors: [], truckloadValidRows: [], truckloadDuplicateHUs: [], truckloadPlanDateMismatchHUs: [], truckloadPlanDateOutOfWindowHUs: [] });
            return;
        }

        // Client-side plan_date consistency pre-check (see
        // checkPlanDateMismatches) - runs BEFORE the duplicate-HU round trip,
        // using only data already in memory, so a row that's going to be
        // rejected anyway never even gets sent to checkPlanDuplicates below.
        var dateChecked = this.checkPlanDateMismatches(dated);
        dated = dateChecked.stillValid;

        // Second, separate pre-check: does each row's own plan_date actually
        // belong to THIS plan's 2-day approval window at all (see
        // checkPlanDateOutOfWindow) - independent of whether it agrees with
        // its own trip's other rows, which the check above already covers.
        var windowChecked = this.checkPlanDateOutOfWindow(dated);
        dated = windowChecked.stillValid;

        // Stage 2 - ask the backend which of these HUs already exist ANYWHERE
        // in this plan (any trip, see insertNewTripPlanData's own uniqueness
        // rule). Unlike phase 1/here, this is informational, not a hard stop -
        // a duplicate HU is shown in its own table (truckloadDuplicateHUs,
        // same one the post-submit result uses), but every genuinely new HU
        // still becomes submittable right away. Fixing the duplicates in
        // Excel and re-uploading, or just submitting the valid ones now, is
        // the operator's call either way.
        this.setState({ overly: "show-m", truckloadSliderBusy: true });
        var params = {
            transaction_id: this.state.transactionId,
            loading_port_code: this.state.loading_port_code,
            hus: dated.map((r) => r.hu)
        };
        console.log('[truckload] checkPlanDuplicates', params);
        redirectURL.post("/lmconsignees/truckload/checkPlanDuplicates", params).then((response) => {
            var existingByHU = {};
            (response.data || []).forEach((d) => { existingByHU[String(d.hu)] = d; });
            var validData = [];
            var duplicateHUs = [];
            dated.forEach((r) => {
                var existing = existingByHU[String(r.hu)];
                if (existing) {
                    duplicateHUs.push({ trip_no: r.trip_no, hu: r.hu, consignee: r.consignee, doc_no: r.doc_no, existing_trip_no: existing.trip_no, scan_status: existing.scan_status || 'pending' });
                } else {
                    // A real Date now, not the "YYYY-MM-DD" string
                    // normalizePlanDateFromFile produced - stored in the DB as
                    // a genuine ISODate (see uploadPlanData).
                    validData.push({ consignee: r.consignee, doc_no: r.doc_no, hu: r.hu, doc_type: r.doc_type, trip_no: r.trip_no, trip_type: r.trip_type, plan_date: this.planDateStringToDate(r.plan_date) });
                }
            });
            // overly stays "show-m" - the slider itself is still open, so its
            // dark backdrop has to stay too. Only truckloadSliderBusy (the
            // in-slider loader) turns off. overly only ever goes to "show-n"
            // when the slider is actually closed.
            this.setState({ overly: "show-m", truckloadSliderBusy: false, truckloadErrors: [], truckloadValidRows: validData, truckloadDuplicateHUs: duplicateHUs, truckloadPlanDateMismatchHUs: dateChecked.mismatches, truckloadPlanDateOutOfWindowHUs: windowChecked.outOfWindow });
        }).catch((e) => {
            console.log(e);
            // Fail OPEN on the pre-check itself (e.g. a network hiccup) - Submit
            // still runs the real check server-side (insertNewTripPlanData), so
            // a failed pre-check can't let a genuine duplicate through, it just
            // means the operator finds out one step later than ideal.
            var validData = dated.map((r) => ({ consignee: r.consignee, doc_no: r.doc_no, hu: r.hu, doc_type: r.doc_type, trip_no: r.trip_no, trip_type: r.trip_type, plan_date: this.planDateStringToDate(r.plan_date) }));
            this.setState({ overly: "show-m", truckloadSliderBusy: false, truckloadErrors: [], truckloadValidRows: validData, truckloadDuplicateHUs: [], truckloadPlanDateMismatchHUs: dateChecked.mismatches, truckloadPlanDateOutOfWindowHUs: windowChecked.outOfWindow });
        });
    };

    // Shared by the bulk-file upload and the single-row Add slider (same
    // endpoint, same trip_results shape). Buckets each trip's result into
    // applied / already-completed (Finish Loading was tapped, trip fully closed)
    // / all-duplicate. A merely-started (in-progress) trip is NOT its own bucket -
    // the backend only blocks a trip wholesale once it's fully loaded; while it's
    // in progress, individual HUs are still accepted/rejected one at a time (see
    // duplicateHUs below), so an operator can keep adding/re-adding the remaining
    // pending HUs right up until Finish Loading.
    // Flattens every result's `duplicates` array (present on 'applied' results
    // with partial overlap too, not just 'rejected_all_duplicate') into one list
    // so the disclaimer table can show exactly which HUs already exist - only
    // ones already marked scan_status:'completed' can never be re-uploaded;
    // still-pending duplicates are just a plain re-upload of what's already there.
    // Deliberately does NOT close the slider or pop a global toast - the
    // message, the trip-level results table, and the per-HU duplicate
    // disclaimer all render INSIDE the slider itself (see the render below),
    // so the operator can actually review what happened instead of it landing
    // outside the slider once it auto-closes.
    handleUploadPlanDataResponse = (response) => {
        var tripResults = response.data.trip_results || [];
        var applied = tripResults.filter((r) => r.status === 'applied');
        var rejected = tripResults.filter((r) => r.status !== 'applied');
        var completedRejects = rejected.filter((r) => r.status === 'rejected_already_completed');
        var duplicateRejects = rejected.filter((r) => r.status === 'rejected_all_duplicate');
        var planDateMismatchRejects = rejected.filter((r) => r.status === 'rejected_plan_date_mismatch');
        var planDateOutOfWindowRejects = rejected.filter((r) => r.status === 'rejected_plan_date_out_of_window');
        var parts = [];
        if (applied.length > 0) {
            parts.push("Trip " + applied.map((r) => r.trip_no).join(', ') + " applied (" + applied.reduce((s, r) => s + r.row_count, 0) + " rows)");
        }
        if (completedRejects.length > 0) {
            parts.push("Trip " + completedRejects.map((r) => r.trip_no).join(', ') + " already loaded, can't be re-uploaded");
        }
        if (duplicateRejects.length > 0) {
            parts.push("Trip " + duplicateRejects.map((r) => r.trip_no).join(', ') + " - all rows already exist, nothing new to upload");
        }
        if (planDateMismatchRejects.length > 0) {
            parts.push("Trip " + planDateMismatchRejects.map((r) => r.trip_no).join(', ') + " - Plan Date doesn't match what's already uploaded for this trip, nothing applied");
        }
        if (planDateOutOfWindowRejects.length > 0) {
            parts.push("Trip " + planDateOutOfWindowRejects.map((r) => r.trip_no).join(', ') + " - Plan Date is outside this plan's upload window, nothing applied");
        }
        var duplicateHUs = tripResults.reduce((acc, r) => acc.concat((r.duplicates || []).map((d) => Object.assign({ trip_no: r.trip_no }, d))), []);
        if (duplicateHUs.length > 0) {
            parts.push(duplicateHUs.length + " HU(s) already exist and were skipped - remove them from your file and re-upload only new HUs");
        }
        // A trip is one vehicle's load on one scheduled day - every HU under
        // the same trip_no has to share the same Plan Date, so any row here
        // was rejected outright, never partially applied under the wrong date.
        var planDateMismatchHUs = tripResults.reduce((acc, r) => acc.concat((r.plan_date_mismatches || []).map((d) => Object.assign({ trip_no: r.trip_no }, d))), []);
        if (planDateMismatchHUs.length > 0) {
            parts.push(planDateMismatchHUs.length + " HU(s) skipped - their Plan Date doesn't match this trip's already-uploaded Plan Date");
        }
        // Separate from planDateMismatchHUs above - these HUs' own plan_date
        // doesn't belong to this plan's 2-day approval window at all, never
        // mind whether it agrees with the rest of their trip.
        var planDateOutOfWindowHUs = tripResults.reduce((acc, r) => acc.concat((r.plan_date_out_of_window || []).map((d) => Object.assign({ trip_no: r.trip_no }, d))), []);
        if (planDateOutOfWindowHUs.length > 0) {
            parts.push(planDateOutOfWindowHUs.length + " HU(s) skipped - their Plan Date is outside this plan's upload window");
        }
        // Nothing to review (no rejections, no duplicates, no mismatches, no
        // out-of-window dates) - a plain SweetAlert success toast is enough,
        // so close the slider and its backdrop instead of leaving it open.
        // Anything short of that still needs the operator to actually see
        // what happened, so the slider stays open with the in-slider message/
        // results/disclaimer tables (see below) exactly as before.
        // planDateMismatchHUs/planDateOutOfWindowHUs are checked separately
        // from `rejected` on purpose - a trip can be 'applied' (some rows
        // landed) while STILL having a few of its other rows silently
        // skipped, same as a partial-duplicate 'applied' trip already works.
        var isFullSuccess = rejected.length === 0 && duplicateHUs.length === 0 && planDateMismatchHUs.length === 0 && planDateOutOfWindowHUs.length === 0;
        if (isFullSuccess) {
            this.setState({
                overly: "show-n",
                truckloadSliderBusy: false,
                truckloadUploadSlide: "",
                truckloadAddSlide: "",
                truckloadValidRows: [],
                truckloadResults: null,
                truckloadDuplicateHUs: [],
                truckloadPlanDateMismatchHUs: [],
                truckloadPlanDateOutOfWindowHUs: [],
                truckloadUploadMessage: null,
                show: true,
                basicType: "success",
                basicTitle: parts.join('. ')
            });
        } else {
            this.setState({
                // overly stays "show-m" (not "show-n") - the slider is still
                // open for the operator to review this exact result, so its
                // dark backdrop has to stay too. Only truckloadSliderBusy (the
                // in-slider loader) turns off. overly only ever goes to
                // "show-n" when the slider is actually closed
                // (hideTruckloadUpload/hideTruckloadAdd/onClickHideAll/the
                // success case above).
                overly: "show-m",
                truckloadSliderBusy: false,
                // Cleared so Submit goes back to disabled - the slider staying
                // open is for reviewing what just happened, not for
                // accidentally resubmitting the same rows a second time.
                truckloadValidRows: [],
                truckloadResults: tripResults,
                truckloadDuplicateHUs: duplicateHUs,
                truckloadPlanDateMismatchHUs: planDateMismatchHUs,
                truckloadPlanDateOutOfWindowHUs: planDateOutOfWindowHUs,
                truckloadUploadMessage: { text: parts.join('. '), type: "warning" }
            });
        }
        // The Loading Plan tab's own lazy-load (onClickTab) only fetches once,
        // the first time it's opened - refresh directly whenever anything
        // actually landed in the DB instead of relying on a tab switch to do it.
        if (applied.length > 0) {
            this.getTruckloadPlanData(this.state.transactionId);
        }
    };

    submitTruckloadUpload = () => {
        if (this.state.truckloadValidRows.length === 0) return;
        this.setState({ overly: "show-m", truckloadSliderBusy: true });
        var params = {
            transaction_id: this.state.transactionId,
            plan_id: this.state.transactionId,
            loading_port_code: this.state.loading_port_code,
            // comp_code is never set into this page's own state (getLoadProcessRunDetailsByTransactionId
            // resolves comp_short_name via a join, not comp_code) - read the same
            // localStorage key LoadingPortContext itself keeps current, falling back to
            // the legacy key like that context does.
            comp_code: localStorage.getItem('selected_comp_code') || localStorage.getItem('comp_code'),
            filename: this.state.truckloadUploadFileName,
            rows: this.state.truckloadValidRows,
            staff_id: localStorage.getItem('staff_id'),
            user_name: localStorage.getItem('username'),
            email: localStorage.getItem('email')
        };
        console.log('[truckload] uploadPlanData', params);
        redirectURL.post("/lmconsignees/truckload/uploadPlanData", params).then((response) => {
            this.handleUploadPlanDataResponse(response);
        }).catch((e) => {
            console.log(e);
            // overly stays "show-m" - the upload slider is still open, its
            // dark backdrop has to stay too. Only truckloadSliderBusy (the
            // in-slider loader) turns off.
            this.setState({
                overly: "show-m",
                truckloadSliderBusy: false,
                show: true,
                basicType: "danger",
                basicTitle: (e.response && e.response.data && e.response.data.message) || "Upload failed"
            });
        });
    };

    onClickTab(pageType) {
        if (pageType == "config") {

        }
        if (pageType == "summary") {
            
        }
        if (pageType == "trucks") {
            if (this.state.clustersData.length == 0) {
                this.setState({
                    overly: "show-m",
                    loadshow: "show-m",
                })
                this.getClustersData(this.state.transactionId)
            }
        }
        
        else if (pageType == "courier") {
            if (this.state.couriersData.length == 0) {
                this.setState({
                    overly: "show-m",
                    loadshow: "show-m",
                })
                this.getCouriersData(this.state.transactionId)
            }
        }
        else if (pageType == "airCourier") {
            if (this.state.airCourierData.length == 0) {
                this.setState({
                    overly: "show-m",
                    loadshow: "show-m",
                })
                this.getAirCourierData(this.state.transactionId)
            }
        }
        else if (pageType == "hub_hold_loads") {
            
            if (this.state.hubHoldLoadData.length == 0) {
                this.setState({
                    overly: "show-m",
                    loadshow: "show-m",
                })
                // this.getCouriersData(this.state.transactionId)
                this.getHubHoldLoadData(this.state.transactionId)
            }
        }
        else if (pageType == "courier_hold_loads") {
            
            if (this.state.courierHoldLoadData.length == 0) {
                this.setState({
                    overly: "show-m",
                    loadshow: "show-m",
                })
                // this.getCouriersData(this.state.transactionId)
                this.getCourierHoldLoadData(this.state.transactionId)
            }
        }
        else if (pageType == "recommendations") {
            if (this.state.recommData.length == 0) {
                this.setState({
                    overly: "show-m",
                    loadshow: "show-m",
                })
                this.getRecommondationsData(this.state.transactionId)
            }
        }
        else if (pageType == "dropped") {
            if (this.state.droppedPData.length == 0) {
                this.setState({
                    overly: "show-m",
                    loadshow: "show-m",
                })
                this.getDroppedData(this.state.transactionId)
            }
        }
        else if (pageType == "truckload_plan") {
            if (this.state.truckloadPlanData.length == 0) {
                this.setState({
                    overly: "show-m",
                    loadshow: "show-m",
                })
                this.getTruckloadPlanData(this.state.transactionId)
            }
        }
        else if (pageType == "adherence") {

            this.setState({
                overly: "show-m",
                loadshow: "show-m",
            })
            this.getAdherenceChartData(this.state.transactionId)
            this.getLmManualVsSystemData(this.state.transactionId)
        }
        else if (pageType == "mgp") {
            this.setState({
                overly: "show-m",
                loadshow: "show-m",
            })
            this.getMGPData()
        }
        this.setState({
            pageType: pageType
        })
    }
    onCellClickedGrid(row) {
        var actionTarget = row.colDef.field == "actions" && row.event && row.event.target ? row.event.target.closest("[data-action]") : null;
        var actionClicked = actionTarget ? actionTarget.getAttribute("data-action") : null;
        if (row.colDef.field == "_id" || actionClicked == "map") {
            var cluster = row.data.cluster;
            var zone = row.data.zone;
            var tripDistance = row.data.tripDistance;
            var truck_capacity = row.data.truck_capacity;
            var transactionId = this.state.transactionId;
            var dealer_code = row.data.dealerCode;
            var load_cmt = row.data.load_cmt;
            // if(truck_capacity == "Courier")
            // {
            //     var latLngArray = [{
            //         lat : row.data.lat,
            //         lng : row.data.lng,
            //         dealer_code : dealer_code,
            //         truck_capacity : truck_capacity,
            //         load_cmt : load_cmt,
            //     }]
            //     this.setState({
            //         latLngArray : latLngArray,
            //         mapType : 2,
            //         bulkslide : "slider-translate-60p",
            //         overly: "show-m",
            //         sliderTitle : sliderTitle
            //     })
            // }
            // else
            // {

            // }
            var params = {
                "transactionId": transactionId,
                "cluster": cluster,
                "planning_type": row.data.planning_type || ""
            }
            var loading_port_code = this.state.loading_port_code;
            var aparams = {
                loading_port_code: loading_port_code
            }
            this.setState({
                loadshow: "show-m",
                overly: "show-m",
            })
            Promise.all([
                redirectURL.post("/lmconsignees/getClustersLatData", params),
                redirectURL.post("/lmconsignees/getLmLoadingPortName", aparams).catch((e) => {
                    console.log(e);
                    return null;
                })
            ]).then(([response, response1]) => {
                //console.log(response.data,"latLngData");
                var latLngInfo = response.data;
                var latLngArray = [];
                var latLngData = groupBy(latLngInfo, rdata => rdata.dealer_code);
                latLngData.forEach((det, zonskey) => {
                    //console.log(det,"det")
                    det.map(function (e, index) {
                        if (index == 0) {
                            latLngArray.push({
                                lat: e.lat,
                                lng: e.lng,
                                dealer_code: e.dealer_code,
                                truck_capacity: e.truck_capacity,
                                load_cmt: e.load_cmt,
                                loading_sequence: e.loading_sequence
                            })
                        }
                    })
                })
                latLngArray = latLngArray.sort(GetSortDescOrder("loading_sequence"));
                console.log(latLngArray, "latLngArray")
                var mapType = 1;
                if (truck_capacity == "Courier") {
                    var mapType = 2;
                    var sliderTitle = "Cluster Name : " + cluster + " Total Distance :0 Km";
                }
                else {
                    var sliderTitle = "Cluster Name : " + cluster + " Total Distance : " + tripDistance + " Km";
                }
                var loadingLocation = [];
                if (response1 && response1.data && response1.data[0]) {
                    loadingLocation.push({
                        lat: response1.data[0].lat,
                        lng: response1.data[0].lng,
                    })
                }
                this.setState({
                    sliderType: 0,
                    mapType: mapType,
                    latLngArray: latLngArray,
                    loadingLocation: loadingLocation,
                    bulkslide: "slider-translate-60p",
                    overly: "show-m",
                    loadshow: "show-n",
                    sliderTitle: sliderTitle
                })
            }).catch((e) => {
                console.log(e);
                this.setState({
                    loadshow: "show-n",
                })
            })
        }
        if (row.colDef.field == "details" || actionClicked == "details") {
            this.setState({
                loadshow: "show-m"
            })
            var cluster = row.data.cluster;
            var zone = row.data.zone;
            var tripDistance = row.data.tripDistance;
            var truck_capacity = row.data.truck_capacity;
            var transactionId = this.state.transactionId;
            var dealer_code = row.data.dealerCode;
            var load_cmt = row.data.load_cmt;
            var params = {
                "transactionId": transactionId,
                "cluster": cluster,
                "planning_type": row.data.planning_type || ""
            }
            redirectURL.post("/lmconsignees/getClustersDetails", params).then(async (response) => {
                //console.log(response.data,"latLngData");
                var clusterDetails = response.data;
                //console.log(clusterDetails,"clusterDetails")
                var sliderTitle = "Cluster Name : " + cluster;
                this.setState({
                    sliderType: 1,
                    clusterDetails: clusterDetails,
                    bulkslide: "slider-translate-75p",
                    overly: "show-m",
                    sliderTitle: sliderTitle,
                    loadshow: "show-n"
                })
            }).catch((e) => {
                console.log(e);
            })
        }
        if (row.colDef.field == "vehicle_count") {
            var vehicle_type = row.data.vehicle_cap
            var truckAvailabilityData = this.state.truckAvailabilityData
            var filteredTruckData = truckAvailabilityData.filter((e) => e.vehicle_type == vehicle_type)
            this.setState({
                // vehicleType : vehicle_type,
                filteredTruckDataforTruckAvailability: filteredTruckData,
                bulkslide1: "slider-translate-60p",
                // loadshow:"show-m",
                overly: "show-m",
                sliderTitle: "Truck Availability"
            })
        }
    }
    onClickShowAllCouriers() {
        this.setState({
            bulkslide: "slider-translate-60p",
            loadshow: "show-m",
            overly: "show-m",
            sliderTitle: "All Couriers"
        })
        if (this.state.latLngArray.length > 0) {
            this.setState({
                latLngArray: this.state.latLngArray,
                mapType: 2,
                loadshow: "show-n"
            })
        }
        else {
            var transactionId = this.state.transactionId;
            var params = {
                "transactionId": transactionId,
            }
            redirectURL.post("/lmconsignees/getAllCouriersLatData", params).then((response) => {
                //console.log(response.data,"latLngData");
                var latLngData = response.data;
                var latLngArray = [];

                latLngData.map(function (e) {
                    latLngArray.push({
                        lat: e.lat,
                        lng: e.lng,
                        dealer_code: e.dealer_code,
                        truck_capacity: e.truck_capacity,
                        load_cmt: e.load_cmt,
                    })
                })
                console.log(latLngArray, "latLngArray")

                this.setState({
                    latLngArray: latLngArray,
                    mapType: 2,
                    loadshow: "show-n"
                })
            }).catch((e) => {
                console.log(e);
            })
        }
    }

    getAdherenceChartData(transactionId) {
        var params = {
            "transactionId": transactionId
        }
        redirectURL.post("/lmconsignees/getAdherenceChartData", params).then((response) => {
            console.log(response.data, "getAdherenceChartData");

            const originalArray = response.data;

            // Use the map function to create a new array with only the desired keys
            const tripsArray = originalArray.map(obj => ({
                vehicle_type: obj.vehicle_type,
                num_trips_system: obj.num_trips_system,
                num_trips_manual: obj.num_trips_manual,
            }));

            const demandArray = originalArray.map(obj => ({
                vehicle_type: obj.vehicle_type,
                demand_manual: parseInt(obj.demand_manual),
                demand_system: parseInt(obj.demand_system),
            }));

            const costArray = originalArray.map(obj => ({
                vehicle_type: obj.vehicle_type,
                cost_manual: parseInt(obj.cost_manual),
                cost_system: parseInt(obj.cost_system),
            }));

            const percentArray = originalArray.map(obj => ({
                vehicle_type: obj.vehicle_type,
                percent_demand_system: obj.percent_demand_system,
                percent_demand_manual: obj.percent_demand_manual,
            }));

            let sumX = 0;
            let sumY = 0;
            let count = 0;

            for (const entry of originalArray) {
                if (entry.vehicle_type !== "Courier" && entry.vehicle_type !== "Dropped") {
                    sumX += entry.num_adhered_trips;
                    sumY += entry.num_trips_system;
                    count++;
                }
            }

            const result = sumX / sumY;



            let plannedTrucksCount = []
            let filteredData = originalArray.filter((e) => e.vehicle_type != "Courier" && e.vehicle_type != "Dropped").map((e) => plannedTrucksCount.push({ vehicle_type: e.vehicle_type, available_count: e.available_count, num_trips_manual: e.num_trips_manual, num_trips_system: e.num_trips_system }))
            console.log(plannedTrucksCount, "plannedTrucksCount")


            this.setState({
                // adherenceChartData : response.data,
                // seriesData : respData,
                // categories : categories,
                adherenceTripData: tripsArray,
                adherenceDemandData: demandArray,
                adherenceCostData: costArray,
                adherencePercentData: percentArray,
                overly: "show-n",
                loadshow: "show-n",
                vehicleAdherencePercent: result,
                plannedTrucksCount: plannedTrucksCount
            })
        }).catch((e) => {
            console.log(e);
        })
    }

    getLmManualVsSystemData(transactionId) {
        var params = {
            "transactionId": transactionId
        };

        redirectURL.post("/lmconsignees/getLmManualVsSystemData", params).then((response) => {
            // Separate, filtering out rows with undefined trip numbers
            const manualData = response.data.filter(d => d.data_type === 2 && d.manual_trip_no !== undefined && d.manual_trip_no !== null);
            const systemData = response.data.filter(d => d.data_type === 1 && d.common_trip_no !== undefined && d.common_trip_no !== null);

            // Helper to find matching system row for manual
            function findSystemRow(manualRow) {
                console.log(manualRow, "manualRow");

                return systemData.find(sys => sys.common_trip_no === manualRow.manual_trip_no && sys.system_pick_ticket === manualRow.manual_pick_ticket);
                // console.log(data,"data");
                // return data
            }

            // Merge manual with system
            const mergedRows = [];

            // Add rows where manual_trip_no matches system common_trip_no
            manualData.forEach(manual => {
                var system = findSystemRow(manual);
                if (system) {
                    console.log(system, "system");

                    //   system.forEach(system => {

                    mergedRows.push({
                        manual_transporter_code: manual.manual_transporter_code,
                        manual_plant_code: manual.plant_code,
                        manual_pick_ticket: manual.manual_pick_ticket,
                        manual_trip_no: manual.manual_trip_no,
                        manual_vehicle_type: manual.vehicle_type_manual,
                        manual_dealer_code: manual.manual_dealer_code,
                        manual_city: manual.city,
                        manual_dealer_volume: manual.manual_dealer_volume,

                        system_pick_ticket: system.system_pick_ticket,
                        system_plant_code: system.plant_code,
                        system_common_trip_no: system.common_trip_no,
                        system_trip_no: system.system_trip_no,
                        system_vehicle_type: system.system_vehicle_type,
                        system_dealer_code: system.system_dealer_code,
                        system_city: system.City,
                        system_dealer_volume: system.systems_dealer_volume,
                        system_remarks: system.remarks
                        // ...add more as needed
                    });
                    //   });
                } else {
                    // Only manual exists
                    mergedRows.push({
                        manual_transporter_code: manual.manual_transporter_code,
                        manual_plant_code: manual.plant_code,
                        manual_pick_ticket: manual.manual_pick_ticket,
                        manual_trip_no: manual.manual_trip_no,
                        manual_vehicle_type: manual.vehicle_type_manual,
                        manual_dealer_code: manual.manual_dealer_code,
                        manual_city: manual.city,
                        manual_dealer_volume: manual.manual_dealer_volume,

                        system_pick_ticket: null,
                        system_plant_code: null,
                        system_dealer_volume: null,
                        system_trip_no: null,
                        system_common_trip_no: null,
                        system_vehicle_type: null,
                        system_dealer_code: null,
                        system_city: null,
                        system_remarks: manual.remarks
                    });
                }
            });

            // Include any system records that don't have a matching manual record
            systemData.forEach(system => {
                const manualExists = manualData.some(manual => manual.manual_trip_no === system.common_trip_no);
                if (!manualExists) {
                    mergedRows.push({
                        manual_transporter_code: null,
                        manual_plant_code: null,
                        manual_pick_ticket: null,
                        manual_trip_no: null,
                        manual_vehicle_type: null,
                        manual_dealer_code: null,
                        manual_city: null,
                        manual_dealer_volume: null,

                        system_pick_ticket: system.system_pick_ticket,
                        system_plant_code: system.plant_code,
                        system_dealer_volume: system.systems_dealer_volume,
                        system_trip_no: system.system_trip_no,
                        system_common_trip_no: system.common_trip_no,
                        system_vehicle_type: system.system_vehicle_type,
                        system_dealer_code: system.system_dealer_code,
                        system_city: system.City,
                        system_remarks: system.remarks
                    });
                }
            });

            mergedRows.sort((a, b) => {
                const getRank = (row) => {
                    const remarks = row.system_remarks;
                    const vehicleType = row.system_vehicle_type;

                    if (remarks === "System Planned Data") return 1;
                    if (vehicleType === "Dropped") return 2;
                    if (remarks === "Extra Manual Pick Picket") return 3;
                    return 4; // All others
                };

                return getRank(a) - getRank(b);
            });


            this.setState({
                manualVsSystemData: mergedRows
            });
        });
    }

    openAdherenceCalculation = () => {
        this.setState({
            openAdherenceFormula: true
        })
    }

    handleClosePopup = () => {
        this.setState({
            openAdherenceFormula: false
        })
    }


    calculateadherencedata = () => {
        let transaction_id = this.state.transactionId;
        let loading_port_code = this.state.loading_port_code;
        let params = {
            transaction_id: transaction_id,
            loading_port_code: loading_port_code
        }
        console.log(params, "params");
        redirectURL.post("/lmconsignees/fetchMGPAPIDataAndtriggerScriptForInputPlanData", params)
        this.setState({
            show: true,
            type: 'success',
            basicTitle: 'Process Triggered'
        })
    }

    getMGPData = () => {
        let transaction_id = this.state.transactionId;
        let loading_port_code = this.state.loading_port_code;
        let params = {
            transaction_id: transaction_id,
            loading_port_code: loading_port_code
        }
        redirectURL.post("/lmconsignees/getMGPData", params)
            .then(res => {
                console.log(res, 'ress')
                if (res.data.data.status == undefined) {
                    this.setState({
                        mgprowdata: JSON.parse(res.data.data.data),
                        mgp_total_pick_tickets: res.data.data.total_pick_tickets,
                        mgp_pick_tickets_received: res.data.data.pick_tickets_received,
                        mgp_pick_tickets_remaining: res.data.data.pick_tickets_remaining,
                        last_synced_at: moment.parseZone(res.data.data.last_synced_at).format("DD-MM-YYYY HH:mm"),
                        overly: "show-n",
                        loadshow: "show-n",
                    })
                } else {
                    this.setState({
                        overly: "show-n",
                        loadshow: "show-n",
                        show: true,
                        type: 'warning',
                        basicTitle: 'No Data'
                    })
                }

            })

    }

    toggleZone(idx) {
        var open = Object.assign({}, this.state.openZones);
        open[idx] = !open[idx];
        this.setState({ openZones: open });
    }

    setZonePlan(pt) {
        this.setState({ zonePlan: pt, openZones: {} });
    }

    renderSummaryInsights() {
        var ins = this.state.insights;
        if (!ins || !ins.planning) {
            return "";
        }
        var meta = ins.meta || {};
        var p = ins.planning || {};
        var trips = ins.trips || {};
        var cats = trips.categories || {};
        var cost = ins.cost || {};
        var zones = ins.zones || [];
        var byPlan = (trips.by_planning_type || []);
        var byVeh = (cost.by_vehicle_type || []);

        var inr = function (n) {
            if (n == null || n == undefined || n == "" || isNaN(n)) { return "0"; }
            return "₹" + formatIndianNumber(parseFloat(n));
        };
        var cmt = function (n) {
            if (n == null || n == undefined || n == "" || isNaN(n)) { return "0"; }
            return parseFloat(n).toLocaleString("en-IN") + " CMT";
        };

        var s = {
            wrap: { width: "100%" },
            hdr: {
                background: "linear-gradient(90deg,#0d47a1,#1565c0)", color: "#fff",
                borderRadius: "10px", padding: "16px 20px", display: "flex",
                justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "14px"
            },
            badge: {
                display: "inline-block", background: "rgba(255,255,255,.18)",
                border: "1px solid rgba(255,255,255,.35)", padding: "3px 10px",
                borderRadius: "20px", fontSize: "12px", marginBottom: "4px"
            },
            gnum: { fontSize: "30px", fontWeight: 700, lineHeight: 1, textAlign: "center" },
            glbl: { fontSize: "11px", opacity: .85, textTransform: "uppercase", letterSpacing: ".5px", textAlign: "center" },
            secTitle: { fontSize: "15px", margin: "22px 0 12px", color: "#1565c0", borderLeft: "4px solid #1565c0", paddingLeft: "9px" },
            kpis: { display: "flex", flexWrap: "wrap", gap: "12px" },
            kpi: { flex: "1 1 160px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: "10px", padding: "14px 16px", boxShadow: "0 1px 2px rgba(0,0,0,.04)" },
            kt: { fontSize: "11px", color: "#718096", textTransform: "uppercase", letterSpacing: ".4px" },
            kv: { fontSize: "22px", fontWeight: 700, marginTop: "6px", color: "#2d3748" },
            ks: { fontSize: "11px", color: "#718096", marginTop: "3px" },
            chips: { display: "flex", flexWrap: "wrap", gap: "10px" },
            chip: { flex: "1 1 120px", background: "#fff", border: "1px solid #e2e8f0", borderRadius: "10px", padding: "12px", textAlign: "center" },
            chipC: { fontSize: "20px", fontWeight: 700 },
            chipN: { fontSize: "11px", color: "#718096", marginTop: "3px" },
            chipM: { fontSize: "11px", color: "#2d3748", marginTop: "2px" },
            panel: { background: "#fff", border: "1px solid #e2e8f0", borderRadius: "10px", padding: "14px", marginBottom: "16px" },
            th: { background: "#1565c0", color: "#fff", textAlign: "left", padding: "8px 10px", fontSize: "12px" },
            thr: { background: "#1565c0", color: "#fff", textAlign: "right", padding: "8px 10px", fontSize: "12px" },
            td: { padding: "7px 10px", borderBottom: "1px solid #e2e8f0", fontSize: "12.5px" },
            tdr: { padding: "7px 10px", borderBottom: "1px solid #e2e8f0", fontSize: "12.5px", textAlign: "right" },
            costItem: { display: "inline-block", marginRight: "26px" },
            costV: { fontSize: "26px", fontWeight: 700 },
            costL: { fontSize: "11px", color: "#718096", textTransform: "uppercase" }
        };

        var accents = ["#1565c0", "#2e7d32", "#00838f", "#ef6c00", "#e53935"];

        var chipDefs = [
            { k: "regular_trips", label: "Regular Trips", color: "#1565c0", trip: true },
            { k: "dedicated_trips", label: "Dedicated Trips", color: "#3949ab", trip: true },
            { k: "hub_trips", label: "Hub Trips", color: "#6a1b9a", trip: true },
            { k: "courier_loads", label: "Courier Loads", color: "#00838f", trip: false },
            { k: "air_courier_loads", label: "Air Courier", color: "#0277bd", trip: false },
            { k: "hub_hold_loads", label: "Hub Hold", color: "#ef6c00", trip: true },
            { k: "courier_hold_loads", label: "Courier Hold", color: "#f9a825", trip: true },
            { k: "dropped_loads", label: "Dropped", color: "#e53935", trip: false }
        ];

        var context = this;

        // ---- chart series (reuse LoadSummaryColumnChart: single-series pie/column) ----
        var planSplitSeries = [
            { name: "Planned", y: parseFloat(p.planned_cmt || 0), showTooltip: 1, color: "#2e7d32" },
            { name: "Courier", y: parseFloat(p.courier_cmt || 0), showTooltip: 1, color: "#00838f" },
            { name: "Hold", y: parseFloat(p.hold_cmt || 0), showTooltip: 1, color: "#ef6c00" },
            { name: "Dropped", y: parseFloat(p.dropped_cmt || 0), showTooltip: 1, color: "#e53935" }
        ];
        var ptColorMap = { HUB: "#6a1b9a", REGULAR: "#1565c0", DEDICATED: "#3949ab", COURIER: "#00838f" };
        var ptTripSeries = byPlan.map(function (r) {
            return { name: r.planning_type, y: parseFloat(r.trips || 0), showTooltip: 1, color: ptColorMap[r.planning_type] || "#1565c0" };
        });
        var ptTripCats = byPlan.map(function (r) { return r.planning_type; });
        var vehCostSeries = byVeh.map(function (v) {
            return { name: v.vehicle_type, y: parseFloat(v.actual_cost || 0), showTooltip: 1 };
        });
        var dropReasons = ins.dropped_reasons || [];
        var dropReasonSeries = dropReasons.map(function (r, i) {
            return { name: r.reason, y: parseFloat(r.count || 0), showTooltip: 1, color: ["#e53935", "#ef6c00", "#f9a825", "#8e24aa", "#5c6bc0", "#00838f"][i % 6] };
        });
        var dropReasonCats = dropReasons.map(function (r) { return r.reason; });
        var dropReasonTotal = dropReasons.reduce(function (a, r) { return a + (parseFloat(r.count) || 0); }, 0);
        var vehCostCats = byVeh.map(function (v) { return v.vehicle_type; });

        // ---- interactive zone view (by planning stage, HUB vs Non-HUB) ----
        var zbp = ins.zones_by_planning || {};
        var zonePlanBtns = ["HUB", "REGULAR", "DEDICATED", "COURIER"].filter(function (k) { return zbp[k]; });
        var zoneSel = context.state.zonePlan;
        if (!zbp[zoneSel]) { zoneSel = zonePlanBtns.length ? zonePlanBtns[0] : zoneSel; }
        var zoneGroup = zbp[zoneSel] || { hub: { zones: [] }, non_hub: { zones: [] } };

        var renderZoneBlock = function (title, grp, pfx, accent) {
            if (!grp || !grp.zones || !grp.zones.length) return "";
            return (
                <div style={{ marginBottom: "14px" }}>
                    <div style={{ fontSize: "13px", fontWeight: 700, color: accent, margin: "0 0 6px" }}>
                        {title}
                        <span style={{ color: "#718096", fontWeight: "normal", marginLeft: "8px" }}>
                            {"— " + grp.trips + " trips · " + cmt(grp.cmt) + " · Payable " + inr(grp.actual_cost)}
                        </span>
                    </div>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                            <tr><th style={s.th}>Zone</th><th style={s.thr}>Trips</th><th style={s.thr}>CMT</th>
                                <th style={s.thr}>Actual Payable</th></tr>
                            {grp.zones.map(function (z, zi) {
                                var key = pfx + zi;
                                var isOpen = context.state.openZones[key];
                                var rows = [
                                    <tr key={key} style={{ cursor: "pointer", fontWeight: 600, background: "#f7fafc" }}
                                        onClick={context.toggleZone.bind(context, key)}>
                                        <td style={s.td}><span style={{ color: accent, marginRight: "6px" }}>{isOpen ? "▼" : "▶"}</span>{z.zone}</td>
                                        <td style={s.tdr}>{z.trips}</td>
                                        <td style={s.tdr}>{cmt(z.cmt)}</td>
                                        <td style={s.tdr}>{inr(z.actual_cost)}</td>
                                    </tr>
                                ];
                                if (isOpen) {
                                    (z.vehicle_types || []).forEach(function (v, vi) {
                                        rows.push(
                                            <tr key={key + "v" + vi} style={{ background: "#fbfdff" }}>
                                                <td style={Object.assign({}, s.td, { paddingLeft: "26px", color: "#718096" })}>{"↳ " + v.vehicle_type}</td>
                                                <td style={s.tdr}>{v.trips}</td>
                                                <td style={s.tdr}>{cmt(v.cmt)}</td>
                                                <td style={s.tdr}>{inr(v.actual_cost)}</td>
                                            </tr>
                                        );
                                    });
                                }
                                return rows;
                            })}
                        </tbody>
                    </table>
                </div>
            );
        };

        // ---- recommendations (cheaper dispatch mode per flagged trip) ----
        var green = "#2e7d32";
        var reco = ins.recommendations || {};
        var recByPlan = reco.by_planning_type || [];
        var recByZone = reco.by_zone || [];
        var renderRecoTable = function (rows, firstLabel, firstField, pfx) {
            var tot = rows.reduce(function (a, r) {
                a.loads += (r.loads || 0); a.cmt += (r.cmt || 0); a.truck += (r.truck_cost || 0);
                a.cour += (r.courier_freight || 0); a.diff += (r.cost_difference || 0); return a;
            }, { loads: 0, cmt: 0, truck: 0, cour: 0, diff: 0 });
            return (
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <tbody>
                        <tr><th style={s.th}>{firstLabel}</th><th style={s.thr}>Loads</th><th style={s.thr}>CMT</th>
                            <th style={s.thr}>Truck Cost (₹)</th><th style={s.thr}>Courier Freight (₹)</th>
                            <th style={s.thr}>Cost Difference (₹)</th><th style={s.th}>Recommendation Mode</th></tr>
                        {rows.map(function (r, i) {
                            return (<tr key={pfx + i}>
                                <td style={s.td}>{r[firstField]}</td>
                                <td style={s.tdr}>{r.loads}</td>
                                <td style={s.tdr}>{cmt(r.cmt)}</td>
                                <td style={s.tdr}>{inr(r.truck_cost)}</td>
                                <td style={s.tdr}>{inr(r.courier_freight)}</td>
                                <td style={Object.assign({}, s.tdr, { color: green })}>{"+" + inr(r.cost_difference)}</td>
                                <td style={s.td}>{r.mode}</td>
                            </tr>);
                        })}
                        <tr style={{ fontWeight: 700, background: "#f7fafc" }}>
                            <td style={s.td}>TOTAL</td>
                            <td style={s.tdr}>{tot.loads}</td>
                            <td style={s.tdr}>{cmt(tot.cmt)}</td>
                            <td style={s.tdr}>{inr(tot.truck)}</td>
                            <td style={s.tdr}>{inr(tot.cour)}</td>
                            <td style={Object.assign({}, s.tdr, { color: green })}>{"+" + inr(tot.diff)}</td>
                            <td style={s.td}></td>
                        </tr>
                    </tbody>
                </table>
            );
        };

        return (
            <div style={s.wrap}>
                {/* header strip */}
                <div style={s.hdr}>
                    <div>
                        <span style={s.badge}>{meta.is_automated ? "🔁 " : ""}{meta.plan_type_label || "Plan"}</span>
                        <div style={{ fontSize: "18px", fontWeight: 700 }}>{(meta.depot || "") + " — Load Summary"}</div>
                        <div style={{ fontSize: "12px", opacity: .85 }}>{"Txn: " + (meta.transaction_id || "")}</div>
                    </div>
                    <div>
                        <div style={s.gnum}>{(p.coverage_pct != undefined ? p.coverage_pct : 0) + "%"}</div>
                        <div style={s.glbl}>Plan Coverage (CMT)</div>
                    </div>
                </div>

                {/* planning KPIs */}
                <div style={s.secTitle}>Planning Overview &mdash; Input vs Planned vs Dropped</div>
                {p.gap_flag ? (
                    <div style={{ margin: "6px 0 10px", padding: "8px 12px", background: "#fff3f3", border: "1px solid #f0b4b4", borderLeft: "4px solid #d32f2f", borderRadius: "4px", color: "#b71c1c", fontSize: "13px", fontWeight: 600 }}>
                        {"⚠ Input vs Output gap: " + cmt(p.gap_cmt) + " CMT of input demand is not reflected in the plan output (Input " + cmt(p.input_cmt) + " vs Output " + cmt(p.output_cmt) + ")."}
                    </div>
                ) : null}
                <div style={s.kpis}>
                    <div style={Object.assign({}, s.kpi, { borderTop: "3px solid " + accents[0] })}>
                        <div style={s.kt}>Input Demand</div><div style={s.kv}>{cmt(p.input_cmt)}</div>
                        <div style={s.ks}>{(p.input_consignees || 0) + " consignees"}</div>
                    </div>
                    <div style={Object.assign({}, s.kpi, { borderTop: "3px solid " + accents[1] })}>
                        <div style={s.kt}>Planned (Trucks)</div><div style={s.kv}>{cmt(p.planned_cmt)}</div>
                        <div style={s.ks}>{(p.planned_consignees || 0) + " consignees"}</div>
                    </div>
                    <div style={Object.assign({}, s.kpi, { borderTop: "3px solid " + accents[2] })}>
                        <div style={s.kt}>Courier</div><div style={s.kv}>{cmt(p.courier_cmt)}</div>
                        <div style={s.ks}>{(p.courier_consignees || 0) + " consignees"}</div>
                    </div>
                    <div style={Object.assign({}, s.kpi, { borderTop: "3px solid " + accents[3] })}>
                        <div style={s.kt}>On Hold</div><div style={s.kv}>{cmt(p.hold_cmt)}</div>
                        <div style={s.ks}>{(p.hold_consignees || 0) + " (Hub + Courier hold)"}</div>
                    </div>
                    <div style={Object.assign({}, s.kpi, { borderTop: "3px solid " + accents[4] })}>
                        <div style={s.kt}>Dropped</div><div style={s.kv}>{cmt(p.dropped_cmt)}</div>
                        <div style={s.ks}>{(p.dropped_consignees || 0) + " consignees"}</div>
                    </div>
                    {p.gap_flag ? (
                        <div style={Object.assign({}, s.kpi, { borderTop: "3px solid #d32f2f", background: "#fff5f5" })}>
                            <div style={s.kt}>Input vs Output Gap</div>
                            <div style={Object.assign({}, s.kv, { color: "#d32f2f" })}>{cmt(p.gap_cmt)}</div>
                            <div style={s.ks}>{"Input " + cmt(p.input_cmt) + " vs Output " + cmt(p.output_cmt)}</div>
                        </div>
                    ) : null}
                </div>

                {/* planning charts */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", marginTop: "16px" }}>
                    <div style={Object.assign({}, s.panel, { flex: "1 1 320px", marginBottom: 0 })}>
                        <h4 style={{ fontSize: "13px", color: "#1565c0", margin: "0 0 6px" }}>Load Split (CMT)</h4>
                        <LoadSummaryColumnChart chartType="pie" title={""} subtitle={""} context={this}
                            series={planSplitSeries} categories={["Planned", "Courier", "Hold", "Dropped"]}
                            seriesName="CMT" yaxistitle="CMT" drilldownseries={[]} />
                    </div>
                    <div style={Object.assign({}, s.panel, { flex: "1 1 320px", marginBottom: 0 })}>
                        <h4 style={{ fontSize: "13px", color: "#1565c0", margin: "0 0 6px" }}>Trips by Planning Type</h4>
                        <LoadSummaryColumnChart chartType="column" title={""} subtitle={""} context={this}
                            series={ptTripSeries} categories={ptTripCats}
                            seriesName="Trips" yaxistitle="Trips" drilldownseries={[]} />
                    </div>
                </div>

                {/* category chips */}
                <div style={s.secTitle}>Load Categories &mdash; including Hub / Hold / Air Courier</div>
                <div style={s.chips}>
                    {chipDefs.map(function (c, i) {
                        var blk = cats[c.k] || { count: 0, cmt: 0 };
                        return (
                            <div key={"chip" + i} style={s.chip}>
                                <div style={Object.assign({}, s.chipC, { color: c.color })}>{blk.count || 0}</div>
                                <div style={s.chipN}>{c.label}</div>
                                <div style={s.chipM}>{cmt(blk.cmt)}</div>
                            </div>
                        );
                    })}
                </div>

                {/* trips by planning type */}
                <div style={s.secTitle}>Trips by Planning Type</div>
                <div style={s.panel}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                            <tr><th style={s.th}>Planning Type</th><th style={s.thr}>Trips</th><th style={s.thr}>CMT</th><th style={s.thr}>Actual Payable</th></tr>
                            {byPlan.map(function (r, i) {
                                return (<tr key={"pt" + i}>
                                    <td style={s.td}>{r.planning_type}</td>
                                    <td style={s.tdr}>{r.trips}</td>
                                    <td style={s.tdr}>{cmt(r.cmt)}</td>
                                    <td style={s.tdr}>{inr(r.actual_cost)}</td>
                                </tr>);
                            })}
                            <tr style={{ fontWeight: 700, background: "#f7fafc" }}>
                                <td style={s.td}>TOTAL</td>
                                <td style={s.tdr}>{byPlan.reduce(function (a, r) { return a + (r.trips || 0); }, 0)}</td>
                                <td style={s.tdr}>{cmt(byPlan.reduce(function (a, r) { return a + (r.cmt || 0); }, 0))}</td>
                                <td style={s.tdr}>{inr(cost.actual_payable)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* cost */}
                <div style={s.secTitle}>Cost &mdash; Actual Payable</div>
                <div style={s.panel}>
                    <div style={{ marginBottom: "12px" }}>
                        <div style={s.costItem}><div style={s.costV}>{inr(cost.actual_payable)}</div><div style={s.costL}>Actual Payable</div></div>
                        <div style={s.costItem}><div style={Object.assign({}, s.costV, { color: "#00838f" })}>{inr(cost.courier_cost)}</div><div style={s.costL}>Courier Cost</div></div>
                        <div style={s.costItem}><div style={Object.assign({}, s.costV, { color: "#1565c0" })}>{inr(cost.truck_actual_cost)}</div><div style={s.costL}>Truck (Payable)</div></div>
                    </div>
                    <div style={{ marginBottom: "12px" }}>
                        <h4 style={{ fontSize: "13px", color: "#1565c0", margin: "0 0 6px" }}>Actual Payable by Vehicle Type</h4>
                        <LoadSummaryColumnChart chartType="column" title={""} subtitle={""} context={this}
                            series={vehCostSeries} categories={vehCostCats}
                            seriesName="Actual Payable" yaxistitle="Actual Payable" drilldownseries={[]} />
                    </div>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                            <tr><th style={s.th}>Vehicle Type</th><th style={s.thr}>Trips</th><th style={s.thr}>CMT</th><th style={s.thr}>Actual Payable</th></tr>
                            {byVeh.map(function (r, i) {
                                return (<tr key={"vt" + i}>
                                    <td style={s.td}>{r.vehicle_type}</td>
                                    <td style={s.tdr}>{r.trips}</td>
                                    <td style={s.tdr}>{cmt(r.cmt)}</td>
                                    <td style={s.tdr}>{inr(r.actual_cost)}</td>
                                </tr>);
                            })}
                        </tbody>
                    </table>
                </div>

                {/* zone-wise — interactive by planning stage, HUB vs Non-HUB */}
                <div style={s.secTitle}>Zone-wise &mdash; pick a planning type; click a zone to expand vehicles</div>
                <div style={s.panel}>
                    <div style={{ display: "inline-flex", border: "1px solid #cbd5e0", borderRadius: "8px", overflow: "hidden", marginBottom: "14px" }}>
                        {zonePlanBtns.map(function (bt, bi) {
                            var active = bt === zoneSel;
                            return (
                                <button key={"zpb" + bi} type="button"
                                    onClick={context.setZonePlan.bind(context, bt)}
                                    style={{
                                        border: "none", cursor: "pointer", padding: "7px 18px", fontSize: "12.5px",
                                        fontWeight: active ? 700 : 500,
                                        background: active ? "#1565c0" : "#fff",
                                        color: active ? "#fff" : "#2d3748",
                                        borderRight: bi < zonePlanBtns.length - 1 ? "1px solid #cbd5e0" : "none"
                                    }}>
                                    {bt.charAt(0) + bt.slice(1).toLowerCase()}
                                </button>
                            );
                        })}
                    </div>
                    {renderZoneBlock("Non-HUB Zones", zoneGroup.non_hub, "n_" + zoneSel + "_", "#1565c0")}
                    {renderZoneBlock("HUB Zones", zoneGroup.hub, "h_" + zoneSel + "_", "#6a1b9a")}
                    {(!zoneGroup.hub.zones.length && !zoneGroup.non_hub.zones.length) &&
                        <div style={{ color: "#718096", fontSize: "13px", padding: "8px" }}>No zones for this planning type.</div>}
                </div>

                {/* recommendations — cheaper dispatch mode per flagged trip */}
                {(reco.flagged_trips > 0) &&
                    <div>
                        <div style={s.secTitle}>Load Recommendations &mdash; cheaper dispatch mode per flagged trip (Truck &#8644; Courier)</div>
                        <div style={s.kpis}>
                            <div style={Object.assign({}, s.kpi, { borderTop: "3px solid #6a1b9a" })}>
                                <div style={s.kt}>Recommended Trips</div><div style={s.kv}>{reco.flagged_trips}</div>
                                <div style={s.ks}>flagged for review</div>
                            </div>
                            <div style={Object.assign({}, s.kpi, { borderTop: "3px solid #1565c0" })}>
                                <div style={s.kt}>Load Involved</div><div style={s.kv}>{cmt(reco.cmt_involved)}</div>
                                <div style={s.ks}>{"across " + (reco.zones_involved || 0) + " zones"}</div>
                            </div>
                            <div style={Object.assign({}, s.kpi, { borderTop: "3px solid #2e7d32" })}>
                                <div style={s.kt}>Courier-Dispatch Saving</div>
                                <div style={Object.assign({}, s.kv, { color: green })}>{inr(reco.courier_dispatch_saving)}</div>
                                <div style={s.ks}>{(reco.courier_dispatch_trips || 0) + " trips · courier cheaper"}</div>
                            </div>
                            <div style={Object.assign({}, s.kpi, { borderTop: "3px solid #ef6c00" })}>
                                <div style={s.kt}>Truck-Kept Saving</div>
                                <div style={Object.assign({}, s.kv, { color: green })}>{inr(reco.truck_kept_saving)}</div>
                                <div style={s.ks}>{(reco.truck_kept_trips || 0) + " trips · avoided courier extra"}</div>
                            </div>
                            <div style={Object.assign({}, s.kpi, { borderTop: "3px solid #3949ab" })}>
                                <div style={s.kt}>Total Recommended Saving</div>
                                <div style={Object.assign({}, s.kv, { color: green })}>{inr(reco.total_saving)}</div>
                                <div style={s.ks}>courier + truck-kept savings</div>
                            </div>
                        </div>
                        <div style={s.panel}>
                            <h4 style={{ fontSize: "13px", color: "#1565c0", margin: "0 0 6px" }}>By planning type &amp; recommended mode</h4>
                            {renderRecoTable(recByPlan, "Planning Type", "planning_type", "rp_")}
                            <h4 style={{ fontSize: "13px", color: "#1565c0", margin: "16px 0 6px" }}>By zone</h4>
                            {renderRecoTable(recByZone, "Zone", "zone", "rz_")}
                            <div style={{ fontSize: "11px", color: "#718096", marginTop: "8px" }}>
                                A trip is flagged when its planned load falls below the vehicle&rsquo;s recommendation CMT (under-utilized truck); trip-level detail is available in the Recommendations tab. Rows are split by Recommendation Mode so each is single-mode &mdash; Courier Dispatch (courier freight is lower than truck cost) or Truck Dispatch (truck cost is at or below courier freight). Cost Difference is the saving from adopting the recommended mode; since every row is a saving, the rows total the overall recommended saving. HUB trips are costed on the actual per-dealer courier freight.
                            </div>
                        </div>
                    </div>
                }

                {/* dropped reasons */}
                <div style={s.secTitle}>Dropped Orders &mdash; reason breakdown</div>
                <div style={s.panel}>
                    {dropReasons.length ?
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px", alignItems: "flex-start" }}>
                            <div style={{ flex: "1 1 300px" }}>
                                <LoadSummaryColumnChart chartType="pie" title={""} subtitle={""} context={this}
                                    series={dropReasonSeries} categories={dropReasonCats}
                                    seriesName="Orders" yaxistitle="Orders" drilldownseries={[]} />
                            </div>
                            <div style={{ flex: "1 1 320px" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                    <tbody>
                                        <tr><th style={s.th}>Dropped Reason</th><th style={s.thr}>Orders</th><th style={s.thr}>% of Dropped</th></tr>
                                        {dropReasons.map(function (r, i) {
                                            var c = parseFloat(r.count) || 0;
                                            var pct = dropReasonTotal ? ((c / dropReasonTotal) * 100).toFixed(1) : "0.0";
                                            return (<tr key={"dr" + i}>
                                                <td style={s.td}>
                                                    <span style={{ display: "inline-block", width: "9px", height: "9px", borderRadius: "2px", marginRight: "7px", background: ["#e53935", "#ef6c00", "#f9a825", "#8e24aa", "#5c6bc0", "#00838f"][i % 6] }}></span>
                                                    {r.reason}
                                                </td>
                                                <td style={s.tdr}>{c}</td>
                                                <td style={s.tdr}>{pct + "%"}</td>
                                            </tr>);
                                        })}
                                        <tr style={{ fontWeight: 700, background: "#f7fafc" }}>
                                            <td style={s.td}>TOTAL DROPPED</td>
                                            <td style={s.tdr}>{dropReasonTotal}</td>
                                            <td style={s.tdr}>100%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        : <div style={{ color: "#2e7d32", fontSize: "13px", padding: "8px" }}>No dropped orders — full coverage.</div>}
                </div>
            </div>
        );
    }

    render() {

        var columnwithDefsForConfigs = [
            {
                headerName: "Vehicle Type",
                field: "vehicle_cap",
                width: 160,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Zone",
                field: "zone",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: (params) => params.data.zone || "",
            },
            {
                headerName: "Vehicle Count",
                field: "vehicle_count",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Min Capacity (CMT)",
                field: "min_capacity_cmt",
                width: 160,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Max Capacity (CMT)",
                field: "max_capacity_cmt",
                width: 160,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Min CMT per Consignee",
                field: "min_courier",
                width: 160,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Max CMT Per Consignee",
                field: "max_consignee_cmt",
                width: 180,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Minimum Nodes",
                field: "minimum_nodes",
                width: 150,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Maximum Nodes",
                field: "nodes_per_truck",
                width: 150,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Vehicle Capacity",
                field: "vehicle_capacity",
                width: 150,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Recommendation CMT",
                field: "recommendation_cmt",
                width: 180,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Max Distance",
                field: "allowed_distance",
                width: 150,
                filter: true,
                resizable: true,
                editable: false
            },
        ]
        var columnwithDefsForTruckloadPlan = [
            {
                headerName: "",
                field: "checkbox",
                width: 44,
                pinned: "left",
                filter: false,
                sortable: false,
                resizable: false,
                editable: false,
                // Checked rows land in selectedTruckloadPlanRows (see
                // onTruckloadPlanSelectionChanged) for "Delete Selected".
                // headerCheckboxSelectionFilteredOnly - the header checkbox only
                // selects whatever the current filter actually shows, not every
                // row in the unfiltered dataset.
                checkboxSelection: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
            },
            {
                headerName: "",
                field: "actions",
                width: 60,
                pinned: "left",
                filter: false,
                sortable: false,
                resizable: false,
                editable: false,
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center" },
                cellRenderer: "PlanRowActionRenderer"
            },
            { headerName: "Trip No", field: "trip_no", width: 110, filter: true, resizable: true, editable: false },
            { headerName: "Trip Type", field: "trip_type", width: 120, filter: true, resizable: true, editable: false },
            { headerName: "Consignee", field: "consignee", width: 160, filter: true, resizable: true, editable: false },
            { headerName: "Doc No", field: "doc_no", width: 150, filter: true, resizable: true, editable: false },
            { headerName: "HU", field: "hu", width: 160, filter: true, resizable: true, editable: false },
            { headerName: "Doc Type", field: "doc_type", width: 120, filter: true, resizable: true, editable: false },
            {
                headerName: "Plan Date", field: "plan_date", width: 130, filter: true, resizable: true, editable: false,
                // plan_date is stored as a real Date (UTC midnight for that
                // calendar day, see uploadPlanData) - read back with UTC
                // getters, never local ones, or this would show the wrong
                // calendar day in any positive-UTC-offset timezone (e.g. IST).
                valueGetter: (params) => {
                    if (!params.data.plan_date) return "";
                    var d = new Date(params.data.plan_date);
                    if (isNaN(d.getTime())) return "";
                    var pad = (n) => String(n).padStart(2, '0');
                    return pad(d.getUTCDate()) + "-" + pad(d.getUTCMonth() + 1) + "-" + d.getUTCFullYear();
                }
            },
            {
                headerName: "Scan Status",
                field: "scan_status",
                width: 140,
                filter: true,
                resizable: true,
                editable: false,
                cellStyle: { display: "flex", alignItems: "center" },
                cellRenderer: function (e) {
                    var completed = e.data.scan_status === "completed";
                    var bg = completed ? "#c8e6c9" : "#ffe0b2";
                    var color = completed ? "#1b5e20" : "#e65100";
                    var label = completed ? "Completed" : "Pending";
                    return '<span style="background:' + bg + ';color:' + color + ';padding:3px 10px;border-radius:12px;font-size:12px;font-weight:600;">' + label + '</span>';
                }
            },
            {
                headerName: "Uploaded By", field: "uploaded_by", width: 160, filter: true, resizable: true, editable: false,
                valueGetter: (params) => (params.data.uploaded_by && params.data.uploaded_by.username) || ""
            },
            {
                headerName: "Uploaded At", field: "uploaded_at", width: 170, filter: true, resizable: true, editable: false,
                valueGetter: (params) => params.data.uploaded_at ? moment.parseZone(params.data.uploaded_at).format("DD-MM-YYYY HH:mm") : ""
            },
        ]
        var data_type = this.state.data_type;
        var hiddenRegular = false;
        var hiddenCourier = true;
        if (data_type == 2) {
            hiddenRegular = true;
            hiddenCourier = false;
        }
        var columnwithDefs = [
            {
                headerName: "Details",
                field: "actions",
                width: 100,
                filter: false,
                sortable: false,
                resizable: true,
                editable: false,
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center" },
                cellRenderer: function (e) {
                    return '<i class="icofont icofont-map-pins f22" data-action="map" title="View Map" style="cursor:pointer;color:#1976d2;margin-right:12px;"></i>' +
                        '<i class="icofont icofont-table f22" data-action="details" title="View Details" style="cursor:pointer;color:#667085;"></i>'
                }
            },
            {
                headerName: "Cluster",
                field: "cluster",
                width: 125,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: function (params) {
                    return params.data.cluster
                }
            },
            {
                headerName: "Zone",
                field: "zone",
                width: 120,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: function (params) {
                    return params.data.zone || ""
                }
            },
            {
                headerName: "Planning Type",
                field: "planning_type",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
                hide: ((this.state.clustersData[0] || {}).planning_type || "") ? false : true
            },
            {
                headerName: "Transporter",
                field: "transporter_name",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: function (params) {
                    if (params.data.transporter_name != undefined && params.data.transporter_name != '') {
                        return params.data.transporter_name
                    }
                    else {
                        return "Not Assigned";
                    }
                }
            },
            {
                // Truck assigned by SOB (client, 2026-10-08). Blank for a manual-availability truck
                // (counts only - no registration number), whose source reads 'Manual'.
                headerName: "Vehicle Number",
                field: "vehicle_number",
                width: 140,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: function (params) {
                    if (params.data.vehicle_number) { return params.data.vehicle_number; }
                    return params.data.vehicle_source == "Manual" ? "Manual" : "";
                }
            },
            {
                headerName: "Tentative Arrival",
                field: "tentative_arrival",
                width: 150,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                // Which SOB run allocated this trip (client, 2026-10-14). SOB re-runs are
                // incremental, so a trip keeps the run number that filled it - 1 means the first
                // run, a higher number means it was waiting and a later run found it a truck.
                headerName: "SOB Run No",
                field: "sob_run_no",
                width: 120,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Sequence No",
                field: "sequence_no",
                width: 100,
                filter: true,
                resizable: true,
                editable: false,
                hide: hiddenCourier
            },
            {
                headerName: "No Of Orders",
                field: "total_consignments",
                width: 100,
                filter: true,
                resizable: true,
                editable: false,
                hide: hiddenRegular
            },
            {
                headerName: "Total Load (CMT)",
                field: "tripVolume",
                width: 160,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: (params) => { const v = parseFloat(params.data.tripVolume); return isNaN(v) ? "" : v.toFixed(2); }
            },
            {
                headerName: "Total Cost",
                field: "tripCost",
                width: 180,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: (params) => { const v = parseFloat(params.data.tripCost); return isNaN(v) ? "" : v.toFixed(2); }
            },
            {
                headerName: "Transport Mode",
                field: "truck_capacity",
                width: 200,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Distance (KM)",
                field: "tripDistance",
                width: 180,
                filter: true,
                resizable: true,
                editable: false,
                hide: hiddenRegular
            },
            {
                headerName: "Zone",
                field: "zone",
                width: 160,
                filter: true,
                resizable: true,
                editable: false,
                hide: hiddenCourier
            },
        ]

        var columnwithDefsForHubHoldLoads = [
            // {
            //     headerName: "",
            //     field: "_id",
            //     width:50,
            //     filter: true,
            //     resizable: true,
            //     editable:false,
            //     cellRenderer: function(e){
            //         return '<i class="icofont icofont-map-pins f25"></i>'
            //     }

            // },

            // {
            //     headerName: "Details",
            //     field: "details",
            //     width: 130,
            //     filter: true,
            //     resizable: true,
            //     editable: false,
            //     valueGetter: function (params) {
            //         return "View";
            //     },
            // },
            {
                headerName: "Dealer Code",
                field: "dealer_code",
                width: 200,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "City",
                field: "city",
                width: 200,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "State",
                field: "state",
                width: 200,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Total Load (CMT)",
                field: "trip_volume",
                width: 160,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: (params) => { const v = parseFloat(params.data.trip_volume); return isNaN(v) ? "" : v.toFixed(2); }
            },
            {
                headerName: "Total Cost",
                field: "trip_cost",
                width: 180,
                filter: true,
                resizable: true,
                editable: false,
                hide: true,
                valueGetter: (params) => { const v = parseFloat(params.data.trip_cost); return isNaN(v) ? "" : v.toFixed(2); }
            },
            {
                headerName: "Transport Mode",
                field: "truck_capacity",
                width: 200,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Distance (KM)",
                field: "trip_distance",
                width: 180,
                filter: true,
                resizable: true,
                editable: false,
                // hide:hiddenRegular
                hide: true
            },
            {
                headerName: "Zone",
                field: "zone",
                width: 160,
                filter: true,
                resizable: true,
                editable: false,
                hide: hiddenCourier
            },
        ]

        var columnwithDefsForCouriers = [
            {
                headerName: "Details",
                field: "actions",
                width: 100,
                filter: false,
                sortable: false,
                resizable: true,
                editable: false,
                cellStyle: { display: "flex", justifyContent: "center", alignItems: "center" },
                cellRenderer: function (e) {
                    return '<i class="icofont icofont-map-pins f22" data-action="map" title="View Map" style="cursor:pointer;color:#1976d2;margin-right:12px;"></i>' +
                        '<i class="icofont icofont-table f22" data-action="details" title="View Details" style="cursor:pointer;color:#667085;"></i>'
                }
            },
            {
                headerName: "Cluster",
                field: "cluster",
                width: 130,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: function (params) {
                    return params.data.cluster
                }
            },
            {
                headerName: "Zone",
                field: "zone",
                width: 80,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: function (params) {
                    return params.data.zone
                }
            },
            {
                headerName: "Dealer Code",
                field: "dealerCode",
                width: 200,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Total Load (CMT)",
                field: "tripVolume",
                width: 200,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: (params) => { const v = parseFloat(params.data.tripVolume); return isNaN(v) ? "" : v.toFixed(2); }
            },
            {
                headerName: "Total Cost",
                field: "tripCost",
                width: 200,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: (params) => { const v = parseFloat(params.data.tripCost); return isNaN(v) ? "" : v.toFixed(2); }
            },
            {
                headerName: "Transport Mode",
                field: "truck_capacity",
                width: 250,
                filter: true,
                resizable: true,
                editable: false
            },
        ]

        var columnwithDefsForRecommended = [
            {
                headerName: "Cluster",
                field: "cluster",
                width: 100,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: function (params) {
                    return params.data.cluster + " - " + params.data.zone
                }
            },
            {
                headerName: "No Of Orders",
                field: "total_consignments",
                width: 100,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Total Load (CMT)",
                field: "tripVolume",
                width: 100,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: (params) => { const v = parseFloat(params.data.tripVolume); return isNaN(v) ? "" : v.toFixed(2); }
            },
            {
                headerName: "Total Cost",
                field: "tripCost",
                width: 100,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: (params) => { const v = parseFloat(params.data.tripCost); return isNaN(v) ? "" : v.toFixed(2); }
            },
            {
                headerName: "Current Transport Mode",
                field: "truck_capacity",
                width: 130,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Recommended Transport Mode",
                headerClass: ["cellstylegridB"],
                cellClass: "cellstylegridB",
                field: "recommendation",
                width: 130,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Proposed Total CMT by Truck",
                headerClass: ["cellstylegridB"],
                cellClass: "cellstylegridB",
                field: "prop_truck",
                width: 150,
                filter: true,
                resizable: true,
                editable: true,
                cellEditor: NumericCellEditor,
                valueGetter: function (params) {
                    if (params.data.prop_truck == undefined) {
                        return 0;
                    }
                    else {
                        return params.data.prop_truck
                    }
                },
                valueSetter: function (params) {
                    //console.log(params)
                    var newValue = params.newValue;
                    var initial_load = params.data.tripVolume;
                    if (parseFloat(newValue) > parseFloat(initial_load)) {
                        return false;
                    }
                    else {
                        params.data.prop_truck = newValue;
                        var courier_cmt = Math.round((initial_load - newValue) * 100) / 100;

                        var cost_percmtcourier = params.data.courier_cost;
                        var courier_cost = courier_cmt * 212 * cost_percmtcourier;
                        var cost_percmt = params.data.proposed_truck_cost;
                        var truck_cost = newValue * cost_percmt;
                        var total_cost = courier_cost + truck_cost;

                        params.data.rec_courier = courier_cmt;
                        params.data.rec_courier_cost = Math.round(courier_cost * 100) / 100;
                        params.data.rec_truck_cost = Math.round(truck_cost * 100) / 100;
                        params.data.rec_total_cost = Math.round(total_cost * 100) / 100;
                        return true;
                    }
                }
            },
            {
                headerName: "Proposed Cost/CMT by Truck",
                headerClass: ["cellstylegridB"],
                cellClass: "cellstylegridB",
                field: "proposed_truck_cost",
                width: 150,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Proposed Total CMT by Courier",
                headerClass: ["cellstylegridB"],
                cellClass: "cellstylegridB",
                field: "rec_courier",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Proposed Cost/Kg by Courier",
                headerClass: ["cellstylegridB"],
                cellClass: "cellstylegridB",
                field: "courier_cost",
                width: 150,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Proposed Cost Truck",
                headerClass: ["cellstylegridB"],
                cellClass: "cellstylegridB",
                field: "rec_truck_cost",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
                // valueGetter: function(params){
                //     return 0;
                // }
                valueGetter: function (params) {
                    if (params.data.rec_truck_cost == undefined) {
                        return 0;
                    }
                    else {
                        return params.data.rec_truck_cost
                    }
                },
            },
            {
                headerName: "Proposed Cost by Courier",
                headerClass: ["cellstylegridB"],
                cellClass: "cellstylegridB",
                field: "rec_courier_cost",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Proposed Total Cost",
                headerClass: ["cellstylegridB"],
                cellClass: "cellstylegridB",
                field: "rec_total_cost",
                width: 130,
                filter: true,
                resizable: true,
                editable: false,
            },
        ]

        var columnwithDefsForDropped = [

            {
                headerName: "Dealer Code",
                field: "dealerCode",
                width: 350,
                filter: true,
                resizable: true,
                editable: false
            },
            {
                headerName: "Total Load (CMT)",
                field: "tripVolume",
                width: 350,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: (params) => { const v = parseFloat(params.data.tripVolume); return isNaN(v) ? "" : v.toFixed(2); }
            },
            {
                headerName: "Dropped Reasons",
                field: "dropped_reasons",
                width: 420,
                filter: true,
                resizable: true,
                editable: false
            }
        ]
        var columnwithDefsForClusterDetails = [
            {
                headerName: "S.No",
                field: "sno",
                width: 80,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: function (e) {
                    return e.node.rowIndex + 1;
                }

            },
            {
                headerName: "Consignee Code",
                field: "dealer_code",
                width: 120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "State",
                field: "state",
                width: 120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "City",
                field: "city",
                width: 120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Pick Ticket",
                field: "pick_ticket",
                width: 120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Load CMT",
                field: "load_cmt",
                width: 120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Truck Capacity",
                field: "truck_capacity",
                width: 120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Transporter Name",
                field: "transporter_name",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
            },
        ]
        var columnwithDefsForTruckAvailability = [
            {
                headerName: "Transporter Name",
                field: "transporter_name",
                width: 180,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Transporter Code",
                field: "transporter_code",
                width: 130,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Vehicle Type",
                field: "vehicle_type",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Vehicle Number",
                field: "vehicle_number",
                width: 130,
                filter: true,
                resizable: true,
                editable: false,
                cellClass: "cellstylegrid"
            },
            {
                headerName: "Punching Date",
                field: "punching_date",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
                valueGetter: function (params) {
                    if (params.data.punching_date != undefined && params.data.punching_date != '') {
                        return getHyphenDDMMYYYYHHMMSS(params.data.punching_date);
                    }
                }
            },
        ]

        var columnwithDefsFormanualVsSystemData = [
            {
                headerName: "MGP Data",
                headerClass: [
                    "cellTopHeaderTemplate16",
                    "cellTopHeader",
                    "cellstylegridActual",
                ],
                children: [
                    {
                        headerName: "Plant Code",
                        field: "manual_plant_code",
                        colId: "manual_plant_code",
                        width: 100,
                        headerClass: "cellstylegridActual",
                    },
                    {
                        headerName: "Transporter Code",
                        field: "manual_transporter_code",
                        colId: "manual_transporter_code",
                        width: 130,
                        headerClass: "cellstylegridActual"
                    },
                    {
                        headerName: "Trip No",
                        field: "manual_trip_no",
                        colId: "manual_trip_no",
                        // pinned: "left",
                        width: 130,
                        headerClass: "cellstylegridActual"
                    },
                    {
                        headerName: "Manual Pick Ticket",
                        field: "manual_pick_ticket",
                        colId: "manual_pick_ticket",
                        // pinned: "left",
                        width: 150,
                        headerClass: "cellstylegridActual"
                    },
                    {
                        headerName: "Dealer Code",
                        headerClass: ["cellstylegrid"],
                        field: "manual_dealer_code",
                        colId: "manual_dealer_code",
                        // pinned: "left",
                        width: 150,
                        headerClass: "cellstylegridActual",
                        cellStyle: params => ({
                            backgroundColor:
                                params.value === params.data.system_dealer_code ? '#e6f9e6' : '#ffd6d6',
                        })
                    },
                    {
                        headerName: "Dealer Volume",
                        headerClass: ["cellstylegrid"],
                        field: "manual_dealer_volume",
                        colId: "manual_dealer_volume",
                        // pinned: "left",
                        width: 150,
                        headerClass: "cellstylegridActual",
                        cellStyle: params => ({
                            backgroundColor:
                                params.value === params.data.system_dealer_volume ? '#e6f9e6' : '#ffd6d6',
                        })
                    },
                    {
                        headerName: "City",
                        headerClass: ["cellstylegrid"],
                        field: "manual_city",
                        colId: "manual_city",
                        headerClass: "cellstylegridActual",
                        // pinned: "left",
                        width: 150,
                        cellStyle: params => ({
                            backgroundColor:
                                params.value === params.data.system_city ? '#e6f9e6' : '#ffd6d6',
                        })
                    },
                    {
                        headerName: "Vehicle Type",
                        headerClass: ["cellstylegrid"],
                        field: "manual_vehicle_type",
                        colId: "manual_vehicle_type",
                        headerClass: "cellstylegridActual",
                        // pinned: "left",
                        width: 150,
                        cellStyle: params => ({
                            backgroundColor:
                                params.value === params.data.system_vehicle_type ? '#e6f9e6' : '#ffd6d6',
                        })
                    },

                ],
            },
            {
                headerName: "System Planned Data",
                headerClass: [
                    "cellTopHeaderTemplate16",
                    "cellTopHeader",
                    "cellstylegridPlanned",
                ],
                children: [
                    {
                        headerName: "Trip No",
                        field: "system_trip_no",
                        colId: "system_trip_no",
                        // pinned: "left",
                        width: 130,
                        headerClass: "cellstylegridPlanned"
                    },
                    {
                        headerName: "Common Trip No",
                        field: "system_common_trip_no",
                        colId: "system_common_trip_no",
                        // pinned: "left",
                        width: 130,
                        headerClass: "cellstylegridPlanned"
                    },
                    {
                        headerName: "Plant Code",
                        field: "system_plant_code",
                        colId: "system_plant_code",
                        width: 100,
                        headerClass: "cellstylegridPlanned"
                    },
                    {
                        headerName: "System Pick Ticket",
                        field: "system_pick_ticket",
                        colId: "system_pick_ticket",
                        // pinned: "left",
                        width: 150,
                        headerClass: "cellstylegridPlanned"
                    },
                    {
                        headerName: "Dealer Code",
                        headerClass: ["cellstylegrid"],
                        field: "system_dealer_code",
                        colId: "system_dealer_code",
                        // pinned: "left",
                        width: 150,
                        headerClass: "cellstylegridPlanned",
                        cellStyle: params => ({
                            backgroundColor:
                                params.value === params.data.manual_dealer_code ? '#e6f9e6' : '#ffd6d6',
                        })
                    },
                    {
                        headerName: "Dealer Volume",
                        headerClass: ["cellstylegrid"],
                        field: "system_dealer_volume",
                        colId: "system_dealer_volume",
                        // pinned: "left",
                        width: 150,
                        headerClass: "cellstylegridPlanned",
                        cellStyle: params => ({
                            backgroundColor:
                                params.value === params.data.manual_dealer_volume ? '#e6f9e6' : '#ffd6d6',
                        })
                    },
                    {
                        headerName: "City",
                        headerClass: ["cellstylegrid"],
                        field: "system_city",
                        colId: "system_city",
                        // pinned: "left",
                        width: 150,
                        headerClass: "cellstylegridPlanned",
                        cellStyle: params => ({
                            backgroundColor:
                                params.value === params.data.manual_city ? '#e6f9e6' : '#ffd6d6',
                        })
                    },
                    {
                        headerName: "Vehicle Type",
                        headerClass: ["cellstylegrid"],
                        field: "system_vehicle_type",
                        colId: "system_vehicle_type",
                        // pinned: "left",
                        width: 150,
                        headerClass: "cellstylegridPlanned",
                        cellStyle: params => ({
                            backgroundColor:
                                params.value === params.data.manual_vehicle_type ? '#e6f9e6' : '#ffd6d6',
                        })
                    },
                    {
                        headerName: "Remarks",
                        headerClass: ["cellstylegrid"],
                        field: "system_remarks",
                        colId: "system_remarks",
                        // pinned: "left",
                        width: 150,
                        headerClass: "cellstylegridPlanned",
                    },

                ],
            },
        ]

        // var columnwithDefsFormanualVsSystemData =[
        //     {
        //         headerName: "Trip No (system)",
        //         field: "trip_no_system",
        //         // width:120,
        //         filter: true,
        //         resizable: true,
        //         editable:false,     
        //         cellClass:function(params){
        //             try {
        //                 if(params.data.adherence_status == true)
        //                 {
        //                     return "light-bg";
        //                 }
        //                 else{
        //                     return "light-err-bg";
        //                 }
        //             } catch (error) {

        //             }
        //         },       
        //     },
        //     {
        //         headerName: "Trip No (manual)",
        //         field: "trip_no_manual",
        //         // width:120,
        //         filter: true,
        //         resizable: true,
        //         editable:false,
        //         cellClass:function(params){
        //             try {
        //                 if(params.data.adherence_status == true)
        //                 {
        //                     return "light-bg";
        //                 }
        //                 else{
        //                     return "light-err-bg";
        //                 }
        //             } catch (error) {

        //             }
        //         },
        //     },
        //     {
        //         headerName: "Vehicle Type (system)",
        //         field: "vehicle_type_system",
        //         // width:130,
        //         filter: true,
        //         resizable: true,
        //         editable:false,     
        //         cellClass:function(params){
        //             try {
        //                 if(params.data.adherence_status == true)
        //                 {
        //                     return "light-bg";
        //                 }
        //                 else{
        //                     return "light-err-bg";
        //                 }
        //             } catch (error) {

        //             }
        //         },       
        //     },
        //     {
        //         headerName: "Vehicle Type(manual)",
        //         field: "vehicle_type_manual",
        //         // width:150,
        //         filter: true,
        //         resizable: true,
        //         editable:false,
        //         cellClass:function(params){
        //             try {
        //                 if(params.data.adherence_status == true)
        //                 {
        //                     return "light-bg";
        //                 }
        //                 else{
        //                     return "light-err-bg";
        //                 }
        //             } catch (error) {

        //             }
        //         },
        //     },
        //     {
        //         headerName: "Dealer Code",
        //         field: "dealer_code",
        //         // width:130,
        //         filter: true,
        //         resizable: true,
        //         editable:false,
        //         cellClass:function(params){
        //             try {
        //                 if(params.data.adherence_status == true)
        //                 {
        //                     return "light-bg";
        //                 }
        //                 else{
        //                     return "light-err-bg";
        //                 }
        //             } catch (error) {

        //             }
        //         },
        //     },
        //     {
        //         headerName: "Planned Load",
        //         field: "demand_system",
        //         // width:130,
        //         filter: true,
        //         resizable: true,
        //         editable:false,
        //         cellClass:function(params){
        //             try {
        //                 if(params.data.adherence_status == true)
        //                 {
        //                     return "light-bg";
        //                 }
        //                 else{
        //                     return "light-err-bg";
        //                 }
        //             } catch (error) {

        //             }
        //         },
        //     },
        //     {
        //         headerName: "Actual Load Dispatched",
        //         field: "demand_manual",
        //         // width:130,
        //         filter: true,
        //         resizable: true,
        //         editable:false,
        //         cellClass:function(params){
        //             try {
        //                 if(params.data.adherence_status == true)
        //                 {
        //                     return "light-bg";
        //                 }
        //                 else{
        //                     return "light-err-bg";
        //                 }
        //             } catch (error) {

        //             }
        //         },
        //     },
        //     {
        //         headerName: "Pick Ticket",
        //         field: "pick_ticket",
        //         // width:130,
        //         filter: true,
        //         resizable: true,
        //         editable:false,
        //         cellClass:function(params){
        //             try {
        //                 if(params.data.adherence_status == true)
        //                 {
        //                     return "light-bg";
        //                 }
        //                 else{
        //                     return "light-err-bg";
        //                 }
        //             } catch (error) {

        //             }
        //         },
        //     },
        //     {
        //         headerName: "Adherence Status",
        //         field: "adherence_status",
        //         // width:130,
        //         filter: true,
        //         resizable: true,
        //         editable:false,
        //         cellClass:function(params){
        //             try {
        //                 if(params.data.adherence_status == true)
        //                 {
        //                     return "light-bg";
        //                 }
        //                 else{
        //                     return "light-err-bg";
        //                 }
        //             } catch (error) {

        //             }
        //         },
        //         valueGetter : function(params){
        //             if(params.data.adherence_status == true)
        //             {
        //                 return 'Adhered';
        //             }else{
        //                 return 'Not Adhered';
        //             }
        //         }
        //     },
        //     // {
        //     //     headerName: "Dealer Adherence",
        //     //     field: "dealer_adherence",
        //     //     // width:130,
        //     //     filter: true,
        //     //     resizable: true,
        //     //     editable:false,
        //     //     cellClass:function(params){
        //     //         try {
        //     //             if(params.data.adherence_status == true)
        //     //             {
        //     //                 return "light-bg";
        //     //             }
        //     //             else{
        //     //                 return "light-err-bg";
        //     //             }
        //     //         } catch (error) {

        //     //         }
        //     //     },
        //     //     valueGetter : function(params){
        //     //         if(params.data.adherence_status == true)
        //     //         {
        //     //             return 'Adhered';
        //     //         }else{
        //     //             return 'Not Adhered';
        //     //         }
        //     //     }
        //     // },
        //     // {
        //     //     headerName: "Vehicle Type Adherence",
        //     //     field: "veh_type_adherence",
        //     //     // width:130,
        //     //     filter: true,
        //     //     resizable: true,
        //     //     editable:false,
        //     //     cellClass:function(params){
        //     //         try {
        //     //             if(params.data.adherence_status == true)
        //     //             {
        //     //                 return "light-bg";
        //     //             }
        //     //             else{
        //     //                 return "light-err-bg";
        //     //             }
        //     //         } catch (error) {

        //     //         }
        //     //     },
        //     //     valueGetter : function(params){
        //     //         if(params.data.adherence_status == true)
        //     //         {
        //     //             return 'Adhered';
        //     //         }else{
        //     //             return 'Not Adhered';
        //     //         }
        //     //     }
        //     // },
        //     // {
        //     //     headerName: "Pickup Ticket Adherence",
        //     //     field: "pick_ticket_adherence",
        //     //     // width:130,
        //     //     filter: true,
        //     //     resizable: true,
        //     //     editable:false,
        //     //     cellClass:function(params){
        //     //         try {
        //     //             if(params.data.adherence_status == true)
        //     //             {
        //     //                 return "light-bg";
        //     //             }
        //     //             else{
        //     //                 return "light-err-bg";
        //     //             }
        //     //         } catch (error) {

        //     //         }
        //     //     },
        //     //     valueGetter : function(params){
        //     //         if(params.data.adherence_status == true)
        //     //         {
        //     //             return 'Adhered';
        //     //         }else{
        //     //             return 'Not Adhered';
        //     //         }
        //     //     }
        //     // },
        //     // {
        //     //     headerName: "Route Adherence",
        //     //     field: "route_adherence",
        //     //     // width:130,
        //     //     filter: true,
        //     //     resizable: true,
        //     //     editable:false,
        //     //     cellClass:function(params){
        //     //         try {
        //     //             if(params.data.adherence_status == true)
        //     //             {
        //     //                 return "light-bg";
        //     //             }
        //     //             else{
        //     //                 return "light-err-bg";
        //     //             }
        //     //         } catch (error) {

        //     //         }
        //     //     },
        //     //     valueGetter : function(params){
        //     //         if(params.data.adherence_status == true)
        //     //         {
        //     //             return 'Adhered';
        //     //         }else{
        //     //             return 'Not Adhered';
        //     //         }
        //     //     }
        //     // },
        // ]


        var columnwithDefsForMGPData = [
            {
                headerName: "Pick Ticket",
                field: "pict_no",
                // width:120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Consignee Code",
                field: "cons_id",
                // width:120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "City",
                field: "city",
                // width:120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Pick Ticket Demand (CMT)",
                field: "pict_cmt",
                // width:120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "MGP No.",
                field: "mgp_no",
                // width:120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Truck No.",
                field: "truck_no",
                // width:120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Vehicle Type",
                field: "vehicle_type",
                // width:120,
                filter: true,
                resizable: true,
                editable: false,
            },
            {
                headerName: "Transporter Id",
                field: "tptr_id",
                // width:120,
                filter: true,
                resizable: true,
                editable: false,
            },
        ]

        var chkOutputFile = 0;
        var loading_port_code = this.state.loading_port_code;
        if (loading_port_code == "GUR-3") {
            if (this.state.rowData.length > 0) {
                var data_processed = this.state.rowData[0].data_processed;
                console.log(data_processed, "data_processed")
                if (data_processed == 2) {
                    var chkOutputFile = 1;
                }
                else {
                    if (this.state.recommData.length == 0) {
                        var chkOutputFile = 1;
                    }
                }
            }
        }
        else {
            var chkOutputFile = 1;
        }
        console.log(chkOutputFile, "chkOutputFile", this.state.pageType, this.state.clustersData, columnwithDefs)
        let mgpData_email = localStorage.getItem("email") || "";

        return (
            <div class="container-fluid">
                <SobRunPanel
                    open={!!this.state.sobPanelOpen}
                    transactionId={this.state.transactionId}
                    loadingPortCode={this.state.loading_port_code}
                    dataType={this.state.data_type}
                    onClose={() => this.setState({ sobPanelOpen: false })}
                    onDone={() => this.getClustersData(this.state.transactionId)}
                />
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>

                <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", overflowY: "auto" }}>
                    <div className="d-flex align-items-center" style={{ flexWrap: "nowrap", gap: "10px", padding: "14px 18px" }}>
                        <div className="d-flex align-items-center" style={{ gap: "14px", minWidth: 0, flex: "1 1 auto", overflow: "hidden" }}>
                            <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                            <i className="icofont icofont-vehicle-delivery-van cus-i" style={{ flexShrink: 0 }}></i>
                            <h5
                                style={{
                                    margin: 0,
                                    fontSize: "16px",
                                    fontWeight: 700,
                                    color: "#1a237e",
                                    letterSpacing: "0.2px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    minWidth: 0
                                }}
                                title={this.state.fileName}
                            >
                                Load Manager - {this.state.fileName}
                            </h5>
                        </div>
                    </div>
                    <div className="card-body col-xl-12 col-lg-12" style={{ padding: "15px 18px 0px 18px" }}>
                        <div className="row col-xl-12 col-lg-12 d-flex justify-content-between align-items-center" style={{ marginBottom: "12px", flexWrap: "wrap", gap: "10px" }}>
                            <span style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                backgroundColor: "#eef3f9",
                                color: "#1976d2",
                                fontSize: "13px",
                                fontWeight: 600,
                                letterSpacing: "0.02em",
                                padding: "6px 14px",
                                borderRadius: "999px"
                            }}>
                                <i className="icofont icofont-building" style={{ fontSize: "14px" }}></i>
                                Loading Plant: {this.state.comp_short_name}
                            </span>

                            <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                                {(chkOutputFile == 1 && this.state.consolidatedFile == 1) ?
                                    <button type="button" onClick={() => this.handleDownloadOutputFile(this.state.transactionId + "_" + "finalAssignFile_summary.csv")} className="pill-btn pill-btn-warning pill-btn-soft">Download Summary File</button>
                                    : ""}

                                {(chkOutputFile == 1) ?
                                    <button type="button" onClick={() => this.handleDownloadOutputFile(this.state.transactionId + "_" + "finalAssignFile.csv")} className="pill-btn pill-btn-danger pill-btn-soft">Download Output File</button>
                                    : ""}

                                {(chkOutputFile == 1) ?
                                    <button type="button" onClick={() => this.setState({ sobPanelOpen: true })} className="pill-btn pill-btn-info">SOB / Assign Vehicles</button>
                                    : ""}

                                {/* The transaction-scoped "Truck Availability -> Assign Transporters -> Load Share ->
                                    Run SOB" walk is gone (client, 2026-10-14): "SOB / Assign Vehicles" above now
                                    shows today's trucks and the approved-vs-actual share in one panel and runs SOB
                                    from there. Truck Availability and Current Load Share remain as master screens
                                    on the menu. */}
                                {(chkOutputFile == 1) ? "" :
                                    <button type="button" className="pill-btn pill-btn-danger pill-btn-soft" onClick={this.onClickTab.bind(this, "recommendations")}>Check Recommendations</button>
                                }

                                {(mgpData_email.includes("enmovil") == true) ?
                                    <button type="button" onClick={() => this.handleDownloadOutputFile(this.state.transactionId + "_" + "mgpData.csv")} className="pill-btn pill-btn-danger pill-btn-soft">Download MGPData File</button>
                                    : ""}
                            </div>
                        </div>
                        <ul style={{
                            display: "inline-flex",
                            flexWrap: "wrap",
                            padding: "4px",
                            margin: "0 0 12px 0",
                            listStyle: "none",
                            gap: "4px",
                            backgroundColor: "#ffffff",
                            borderRadius: "10px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
                        }}>
                            {[
                                { key: "config", label: "Configuration" },
                                { key: "summary", label: "Summary" },
                                { key: "trucks", label: this.state.data_type == 2 ? "Planned Loads" : "Planned Truck Loads" },
                                { key: "courier", label: "Surface Courier Loads" },
                                { key: "airCourier", label: "Air Courier Loads" },
                                { key: "hub_hold_loads", label: "Hub Hold Loads" },
                                { key: "courier_hold_loads", label: "Courier Hold Loads" },
                                ...(this.state.data_type != 2 ? [{ key: "recommendations", label: "Recommendations" }] : []),
                                { key: "mgp", label: "MGP Data" },
                                { key: "dropped", label: "Loads Dropped" },
                                // Same base gate the "Upload Loading Plan" button starts from -
                                // there's nothing in lm_truckload_plan_data to show before the
                                // plan's approved. Deliberately NOT also gated on the button's
                                // 2-day upload window (see isUploadWindowOpen) - already-uploaded
                                // data should stay viewable after that window closes, only
                                // uploading NEW data is blocked.
                                ...(this.state.truckload_approved ? [{ key: "truckload_plan", label: "Loading Plan" }] : []),
                                { key: "adherence", label: "Adherence" },
                            ].map(({ key, label }, idx) => {
                                var isActive = this.state.pageType == key;
                                return (
                                    <li key={idx} onClick={() => this.onClickTab(key)} style={{ listStyle: "none" }}>
                                        <button
                                            type="button"
                                            style={{
                                                whiteSpace: "nowrap",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: "999px",
                                                padding: "8px 18px",
                                                fontSize: "13px",
                                                fontWeight: isActive ? 600 : 500,
                                                cursor: "pointer",
                                                transition: "all 0.2s ease",
                                                backgroundColor: isActive ? "#1976d2" : "transparent",
                                                color: isActive ? "#fff" : "#555",
                                                boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                            }}
                                        >
                                            {label}
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                        {this.state.pageType == "config" && <div id="myGrid" style={{ width: "100%", height: "478px" }} className={`ag-theme-balham d-flex flex-column`}>
                            {/* <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefsForConfigs}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.configurationData}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                                onCellClicked={this.onCellClickedGrid.bind(this)}
                            /> */}
                            <TableComponent
                                    rowData={this.state.configurationData}
                                    columnwithDefs={columnwithDefsForConfigs}
                                    onClicked={this.onCellClickedGrid.bind(this)}
                                />
                        </div>}
                        {this.state.pageType == "truckload_plan" && <div id="truckloadPlanGrid" style={{ width: "100%" }} className={`d-flex flex-column`}>
                            <div className="d-flex justify-content-end" style={{ marginBottom: "8px", gap: "8px" }}>
                                {(() => {
                                    // Add Row is the same underlying restriction as bulk upload (both
                                    // land in lm_truckload_plan_data) - the ONLY thing that closes either
                                    // one is the plan's own 2-day upload window. Every existing trip_no
                                    // on this plan being loading_completed does NOT block new uploads -
                                    // the operator can still add as many genuinely new trips as needed
                                    // within that same window, and uploadPlanData already reopens an
                                    // already-completed trip_no on its own if new HUs land on it (see
                                    // reopenTripLoading on the backend) rather than rejecting the upload
                                    // outright - there used to be an extra "all trips completed" gate
                                    // here too, but that stopped matching the backend's own behavior a
                                    // while ago and was blocking legitimate new-trip uploads.
                                    var windowOpen = this.isUploadWindowOpen();
                                    var blocked = !windowOpen;
                                    var reason = blocked ? "Upload window has closed (2 days after this plan was generated)" : "";
                                    return (
                                        <React.Fragment>
                                            <button
                                                type="button"
                                                onClick={blocked ? undefined : this.showTruckloadUpload}
                                                disabled={blocked}
                                                className="pill-btn pill-btn-info pill-btn-soft"
                                                title={reason}
                                                style={blocked ? { cursor: "not-allowed", opacity: 0.6 } : {}}
                                            ><i className="icofont icofont-upload-alt" style={{ marginRight: "5px" }}></i>Upload Loading Plan</button>
                                            <button
                                                type="button"
                                                onClick={blocked ? undefined : this.showTruckloadAdd}
                                                disabled={blocked}
                                                className="pill-btn pill-btn-success pill-btn-soft"
                                                title={reason}
                                                style={blocked ? { cursor: "not-allowed", opacity: 0.6 } : {}}
                                            ><i className="icofont icofont-plus" style={{ marginRight: "5px" }}></i>Add Row</button>
                                        </React.Fragment>
                                    );
                                })()}
                                <button
                                    type="button"
                                    onClick={this.state.selectedTruckloadPlanRows.length === 0 ? undefined : this.bulkDeleteTruckloadPlanRows}
                                    disabled={this.state.selectedTruckloadPlanRows.length === 0}
                                    className="pill-btn pill-btn-danger pill-btn-soft"
                                    title={this.state.selectedTruckloadPlanRows.length === 0 ? "Select one or more rows to delete" : ""}
                                    style={this.state.selectedTruckloadPlanRows.length === 0 ? { cursor: "not-allowed", opacity: 0.6 } : {}}
                                ><Trash size={14} style={{ marginRight: "5px", verticalAlign: "-2px" }} />Delete Selected{this.state.selectedTruckloadPlanRows.length > 0 ? " (" + this.state.selectedTruckloadPlanRows.length + ")" : ""}</button>
                            </div>
                            <div style={{ width: "100%", height: "478px" }} className={`ag-theme-balham d-flex flex-column`}>
                                <TableComponent
                                        rowData={this.state.truckloadPlanData}
                                        columnwithDefs={columnwithDefsForTruckloadPlan}
                                        frameworkComponents={{ PlanRowActionRenderer: this.PlanRowActionRenderer }}
                                        rowSelection="multiple"
                                        isRowSelectable={(node) => !!node.data && node.data.scan_status !== "completed"}
                                        onSelectionChanged={this.onTruckloadPlanSelectionChanged}
                                    />
                            </div>
                        </div>}
                        <div className={`row mt-2 ${this.state.pageType == "summary" ? "" : "d-none"}`}>
                            {this.state.insights &&
                                <div className="col-xl-12" style={{ marginBottom: "20px" }}>
                                    {this.renderSummaryInsights()}
                                </div>}
                            {this.state.summaryLoaded && !this.state.insights && <React.Fragment>
                            <div className="col-xl-6">
                                <div>
                                    <LoadSummaryColumnChart
                                        chartType="column"
                                        title={"Orders Planned For Load"}
                                        subtitle={""}
                                        context={this}
                                        series={this.state.seriesData}
                                        categories={this.state.categories}
                                        seriesName=""
                                        yaxistitle="Orders For Load Plan"
                                        drilldownseries={[]}
                                    // dept_code={this.state.dept_code}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div>
                                    <LoadSummaryColumnChart
                                        chartType="column"
                                        title={"Cost Summary"}
                                        subtitle={""}
                                        context={this}
                                        series={this.state.costData}
                                        categories={this.state.costCategories}
                                        seriesName=""
                                        yaxistitle="Orders For Load Plan"
                                        drilldownseries={[]}
                                    // dept_code={this.state.dept_code}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div>
                                    <LoadSummaryColumnChart
                                        chartType="pie"
                                        title={"Dropped Nodes Summary"}
                                        subtitle={""}
                                        context={this}
                                        series={this.state.drpData}
                                        categories={this.state.drpCategories}
                                        seriesName=""
                                        yaxistitle="Orders For Load Plan"
                                        drilldownseries={[]}
                                    // dept_code={this.state.dept_code}
                                    />
                                </div>
                            </div>
                            {(this.state.data_type != 2) ?
                                <div className="col-xl-6">
                                    <div>
                                        <LoadSummaryColumnChart
                                            chartType="column"
                                            title={"Actual Payable Cost Summary"}
                                            subtitle={""}
                                            context={this}
                                            series={this.state.actcostData}
                                            categories={this.state.actcostCategories}
                                            seriesName=""
                                            yaxistitle="Orders For Load Plan"
                                            drilldownseries={[]}
                                        // dept_code={this.state.dept_code}
                                        />
                                    </div>
                                </div>
                                : ""}
                            </React.Fragment>}
                        </div>
                        {(this.state.pageType == "trucks" && this.state.clustersData.length > 0) && <div id="myGrid" style={{ width: "100%", height: "478px" }} className="d-flex flex-column">
                            {/* <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefs}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.clustersData}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                                onCellClicked={this.onCellClickedGrid.bind(this)}
                            /> */}
                            <TableComponent
                                    rowData={this.state.clustersData}
                                    columnwithDefs={columnwithDefs}
                                    onClicked={this.onCellClickedGrid.bind(this)}
                                />
                        </div>}
                        
                        {this.state.pageType == "courier" && <div id="myGrid" style={{ width: "100%", height: "500px" }} className="d-flex flex-column">
                            <div className="d-flex justify-content-end align-items-center">
                              <button type="button" className="pill-btn pill-btn-info" onClick={this.onClickShowAllCouriers.bind(this)} style={{ marginBottom: "1em" }}>View All Couriers</button>
                            </div>
                            {/* <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefsForCouriers}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.couriersData}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                                onCellClicked={this.onCellClickedGrid.bind(this)}
                            /> */}
                            <TableComponent
                                    rowData={this.state.couriersData}
                                    columnwithDefs={columnwithDefsForCouriers}
                                    onClicked={this.onCellClickedGrid.bind(this)}
                                />
                        </div>}
                        {this.state.pageType == "airCourier" && <div id="myGrid" style={{ width: "100%", height: "500px", display: this.state.pageType === "airCourier" ? "block" : "none" }} className={`ag-theme-balham d-flex flex-column`}>
                            {/* <div className="d-flex justify-content-end align-items-center">
                              <button type="button" className="btn btn-info" onClick={this.onClickShowAllCouriers.bind(this)} style={{ marginBottom: "1em" }}>View All Couriers</button>
                            </div> */}
                            {/* <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefsForCouriers}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.airCourierData}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                                onCellClicked={this.onCellClickedGrid.bind(this)}
                            /> */}
                            {/* <div className=""> */}
                                <TableComponent
                                    rowData={this.state.airCourierData}
                                    columnwithDefs={columnwithDefsForCouriers}
                                    onClicked={this.onCellClickedGrid.bind(this)}
                                />
                            {/* </div> */}
                        </div>}

                        <div className={this.state.pageType == "recommendations" ? "" : "d-none"}>
                            <LoadSummaryRecommondations recommData={this.state.recommData} transactionId={this.state.transactionId} loading_port_code={this.state.loading_port_code} chkOutputFile={chkOutputFile} />
                        </div>

                        {this.state.pageType == "dropped" && <div id="myGrid" style={{ width: "100%", height: "478px" }} className={`d-flex flex-column`}>
                            {/* <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefsForDropped}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.droppedPData}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                            /> */}
                            <TableComponent
                                    rowData={this.state.droppedPData}
                                    columnwithDefs={columnwithDefsForDropped}
                                    onClicked={this.onCellClickedGrid.bind(this)}
                                />
                        </div>}
                        <div id="myGrid" style={{ width: "100%" }} className={`ag-theme-balham ${this.state.pageType == "hub_hold_loads" ? "" : "d-none"}`}>
                            {/* <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefsForHubHoldLoads}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.hubHoldLoadData}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                                onCellClicked={this.onCellClickedGrid.bind(this)}
                            /> */}
                            <GridComponent
                                rowData={this.state.hubHoldLoadData}
                                columnwithDefs={columnwithDefsForHubHoldLoads}
                                onClicked={this.onCellClickedGrid.bind(this)}
                            />
                        </div>
                        {this.state.pageType == "courier_hold_loads" && <div id="myGrid" style={{ width: "100%", height: "478px" }} className={`d-flex flex-column`}>
                            {/* <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefsForHubHoldLoads}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.courierHoldLoadData}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                                onCellClicked={this.onCellClickedGrid.bind(this)}
                            /> */}
                            <TableComponent
                                    rowData={this.state.courierHoldLoadData}
                                    columnwithDefs={columnwithDefsForHubHoldLoads}
                                    onClicked={this.onCellClickedGrid.bind(this)}
                                />
                        </div>}
                    </div>
                </div>
                <div className={"slide-r " + (this.state.bulkslide)} style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}>
                    <h3 className="subH" style={{ background: "linear-gradient(135deg,#1976d2,#1a237e)", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 18px", flexShrink: 0 }}>
                        <span>{this.state.sliderTitle} <span className="ttlDuration"></span></span>
                        <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer", fontSize: "16px" }}>✕</span>
                    </h3>
                    <div className="slide-r-body" style={{ position: "relative", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", padding: "35px" }}>
                        {(this.state.sliderType == 1) ?
                            <div id="cluterDetailsGrid" style={{ width: "100%", flex: 1, minHeight: 0 }} className={"ag-theme-balham"}>
                                <AgGridReact
                                    modules={this.state.modules}
                                    columnDefs={columnwithDefsForClusterDetails}
                                    defaultColDef={this.state.defaultColDef}
                                    rowData={this.state.clusterDetails}
                                    rowHeight={45}
                                    headerHeight={45}
                                    enableCharts={false}
                                    // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                    onGridReady={this.onGridReady}
                                    onGridState={this.onGridState}
                                    frameworkComponents={this.state.frameworkComponents}
                                    statusBar={this.state.statusBar}
                                    sideBar={this.state.sideBar}
                                    stopEditingWhenGridLosesFocus={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    pagination={true}
                                    gridOptions={{
                                        context: { componentParent: this }
                                    }}
                                    // components={this.state.components}
                                    enableRangeSelection={true}
                                />
                            </div>
                            :
                            <div style={{ flex: 1, minHeight: 0 }}>
                                <LoadSummaryDrawmap
                                    context={this} coords={this.state.latLngArray} loadingLocation={this.state.loadingLocation} stepcoords={1} mapType={this.state.mapType} mapFor={"load_management"} />
                            </div>
                        }
                    </div>
                </div>
                <div className={"slide-r " + (this.state.bulkslide1)} style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}>
                    <h3 className="subH" style={{ background: "linear-gradient(135deg,#1976d2,#1a237e)", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 18px", flexShrink: 0 }}>
                        <span>{this.state.sliderTitle} <span className="ttlDuration"></span></span>
                        <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer", fontSize: "16px" }}>✕</span>
                    </h3>
                    <div className="slide-r-body" style={{ position: "relative", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", padding: "16px 18px" }}>

                        <div id="cluterDetailsGrid" style={{ width: "100%", flex: 1, minHeight: 0 }} className={"ag-theme-balham"}>
                            <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefsForTruckAvailability}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.filteredTruckDataforTruckAvailability}
                                rowHeight={45}
                                headerHeight={45}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                            />
                        </div>

                    </div>
                </div>

                {/* .slide-r's own CSS casts a box-shadow even at width:0 (closed) - a
                    0-width element still renders its shadow, showing up as a dark
                    sliver on the right edge of the screen even with the slider
                    "closed". Explicitly killing the shadow when closed (no
                    translate class applied) removes that leftover shadow. */}
                <div className={"slide-r " + (this.state.truckloadUploadSlide)} style={{ overflow: "hidden", display: "flex", flexDirection: "column", height: "100%", right: 0, boxShadow: this.state.truckloadUploadSlide ? undefined : "none" }}>
                    {/* Scoped to this slider (not the whole-page loadshow spinner) -
                        covers the whole panel so every control underneath is
                        genuinely unclickable while busy, not just visually dimmed. */}
                    {this.state.truckloadSliderBusy ?
                        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(255,255,255,0.65)", zIndex: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                        </div>
                        : null}
                    <div style={{ background: "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)", padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <i className="icofont icofont-truck-loaded" style={{ color: "white", fontSize: "22px" }}></i>
                            <div>
                                <h5 style={{ color: "white", margin: 0, fontWeight: 700, fontSize: "15px", letterSpacing: "0.3px" }}>Upload Loading Plan</h5>
                                <p style={{ color: "rgba(255,255,255,0.75)", margin: 0, fontSize: "11px" }}>Upload HU-level plan data for {this.state.transactionId}</p>
                            </div>
                        </div>
                        <button type="button" onClick={this.hideTruckloadUpload} style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: "50%", width: "30px", height: "30px", color: "white", cursor: "pointer", fontSize: "18px", lineHeight: "1", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                    </div>

                    <div className="slide-r-body" style={{ position: "relative", flex: 1, minHeight: 0, overflowY: "auto", padding: "20px 20px 8px 20px" }}>

                        <div style={{ marginBottom: "16px" }}>
                            <p style={{ fontWeight: 700, fontSize: "13px", color: "#333", margin: "0 0 8px 0" }}>Step 1 &mdash; Download Template</p>
                            <div style={{ background: "#e8f4fd", border: "1px solid #b3d9f7", borderRadius: "8px", padding: "12px 14px", display: "flex", alignItems: "center", gap: "10px" }}>
                                <i className="icofont icofont-file-excel" style={{ fontSize: "20px", color: "#1565c0" }}></i>
                                <span style={{ fontSize: "12.5px", color: "#37474f", flex: 1 }}>Use this template - Plan Date, Consignee, Doc. No., HU, Doc. Type, Trip No., Trip Type.</span>
                                <a href={require('../../assets/truck_load_automation_sample_file.xlsx')} target="_blank" className="btn btn-sm btn-primary" download style={{ whiteSpace: "nowrap" }}>Download Template</a>
                            </div>
                        </div>

                        <div style={{ marginBottom: "16px" }}>
                            <div style={{ background: "#fffde7", border: "1px solid #ffe082", borderRadius: "8px", overflow: "hidden" }}>
                                <div
                                    onClick={this.toggleTruckloadRules}
                                    style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "6px", padding: "10px 14px", cursor: "pointer" }}
                                >
                                    <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <i className="icofont icofont-info-circle" style={{ color: "#f9a825", fontSize: "15px" }}></i>
                                        <span style={{ fontSize: "12.5px", fontWeight: 700, color: "#6d5a00" }}>Upload Rules</span>
                                    </span>
                                    <i className={"icofont " + (this.state.truckloadRulesExpanded ? "icofont-rounded-up" : "icofont-rounded-down")} style={{ color: "#6d5a00", fontSize: "13px" }}></i>
                                </div>
                                {this.state.truckloadRulesExpanded ?
                                    <div style={{ padding: "0 14px 12px 14px" }}>
                                        {[
                                            { icon: "icofont-copy-invert", text: "An HU already uploaded is skipped as a duplicate, not replaced - only genuinely new HU(s) get added." },
                                            { icon: "icofont-lock", text: "HU(s) already scanned (Completed) can never be re-uploaded." },
                                            { icon: "icofont-truck-loaded", text: "A trip that's still loading can keep accepting new HU(s) right up until it's fully loaded." },
                                        ].map((item, i) => (
                                            <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: "8px", padding: "5px 0", borderTop: i > 0 ? "1px dashed #f2e2a0" : "none" }}>
                                                <i className={"icofont " + item.icon} style={{ color: "#c99a00", fontSize: "13px", marginTop: "2px", width: "16px", textAlign: "center" }}></i>
                                                <span style={{ fontSize: "12px", color: "#6d5a00", lineHeight: "1.4" }}>{item.text}</span>
                                            </div>
                                        ))}
                                    </div>
                                    : null}
                            </div>
                        </div>

                        <div style={{ marginBottom: "16px" }}>
                            <p style={{ fontWeight: 700, fontSize: "13px", color: "#333", margin: "0 0 8px 0" }}>Step 2 &mdash; Upload Plan Data File</p>
                            <input ref={(el) => this.truckloadFileInputRef = el} type="file" accept=".xlsx,.xls,.csv" onChange={this.handleTruckloadFileChange} style={{ display: "none" }} id="truckloadFileInput" />
                            <label
                                htmlFor="truckloadFileInput"
                                onDragOver={this.onTruckloadDragOver}
                                onDragLeave={this.onTruckloadDragLeave}
                                onDrop={this.onTruckloadDrop}
                                style={{
                                    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "4px",
                                    border: this.state.truckloadDragging ? "2px dashed #1565c0" : (this.state.truckloadUploadFileName ? "2px solid #a5d6a7" : "2px dashed #90caf9"),
                                    background: this.state.truckloadDragging ? "#e3f2fd" : (this.state.truckloadUploadFileName ? "#e8f5e9" : "#fafcff"),
                                    borderRadius: "8px", padding: "16px 14px", margin: 0, cursor: "pointer"
                                }}
                            >
                                {this.state.truckloadUploadFileName ?
                                    <React.Fragment>
                                        <i className="icofont icofont-check-circled" style={{ fontSize: "22px", color: "#2e7d32" }}></i>
                                        <span style={{ fontSize: "12.5px", color: "#2e7d32", fontWeight: 600, textAlign: "center", wordBreak: "break-word" }}>{this.state.truckloadUploadFileName}</span>
                                        <span style={{ fontSize: "11px", color: "#78909c" }}>Click or drop to replace</span>
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <i className="icofont icofont-upload-alt" style={{ fontSize: "26px", color: "#1565c0" }}></i>
                                        <span style={{ fontSize: "12.5px", color: "#546e7a" }}>Drag &amp; drop a file here, or click to browse (.xlsx, .xls, .csv)</span>
                                    </React.Fragment>
                                }
                            </label>
                        </div>

                        {this.state.truckloadPendingRows ?
                            <div style={{ marginBottom: "16px" }}>
                                <p style={{ fontWeight: 700, fontSize: "13px", color: "#333", margin: "0 0 8px 0" }}>Step 3 &mdash; Confirm Plan Date</p>
                                <div style={{ background: "#e8f4fd", border: "1px solid #b3d9f7", borderRadius: "8px", padding: "12px 14px", display: "flex", flexDirection: "column" }}>
                                    <span style={{ fontSize: "12px", color: "#37474f", marginBottom: "10px", lineHeight: "1.4" }}>
                                        Your data looks like this - please select the date format of the Plan Date you uploaded.
                                    </span>
                                    {this.state.truckloadSampleRow ?
                                        <div style={{ overflowX: "auto", marginBottom: "10px" }}>
                                            <table className="table table-sm table-bordered mb-0" style={{ background: "#fff", fontSize: "11.5px" }}>
                                                <thead>
                                                    <tr>
                                                        <th style={{ background: "#fff9c4" }}>Plan Date</th><th>Trip No</th><th>Trip Type</th><th>Consignee</th><th>Doc No</th><th>HU</th><th>Doc Type</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ background: "#fff9c4", fontWeight: 700, color: "#1565c0" }}>
                                                            {this.state.truckloadDateAmbiguous ? this.state.truckloadDateSample : this.normalizePlanDate(this.state.truckloadSampleRow.planDateCell)}
                                                        </td>
                                                        <td>{this.state.truckloadSampleRow.trip_no}</td>
                                                        <td>{this.state.truckloadSampleRow.trip_type}</td>
                                                        <td>{this.state.truckloadSampleRow.consignee}</td>
                                                        <td>{this.state.truckloadSampleRow.doc_no}</td>
                                                        <td>{this.state.truckloadSampleRow.hu}</td>
                                                        <td>{this.state.truckloadSampleRow.doc_type}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        : null}
                                    {/* Live preview of what the currently-selected format actually
                                        produces - lets the operator visually verify/catch a wrong
                                        day/month swap before Continue, instead of only finding out
                                        after it's already been parsed and sent. */}
                                    {this.state.truckloadSampleRow && this.state.truckloadDateFormat ?
                                        (() => {
                                            var cell = this.state.truckloadSampleRow.planDateCell;
                                            var isResolvedCell = cell instanceof Date || typeof cell === 'number';
                                            // resolveDateCellFormat gives the SPECIFIC reason for a resolved
                                            // cell (e.g. "day 13 can't be a month") - the generic "only
                                            // YYYY-MM-DD or YYYY-DD-MM apply" isn't always true either,
                                            // since even one of those two candidates can fail for THIS row's
                                            // actual day value.
                                            var outcome = isResolvedCell
                                                ? this.resolveDateCellFormat(cell, this.state.truckloadDateFormat)
                                                : { result: this.normalizePlanDateFromFile(cell), reason: "doesn't match the selected format" };
                                            if (outcome.result) {
                                                return (
                                                    <div style={{ fontSize: "12px", color: "#2e7d32", background: "#e8f5e9", border: "1px solid #a5d6a7", borderRadius: "6px", padding: "6px 10px", marginBottom: "10px" }}>
                                                        With <b>{this.state.truckloadDateFormat}</b> selected, this row's Plan Date will be stored as <b>{outcome.result}</b>.
                                                    </div>
                                                );
                                            }
                                            return (
                                                <div style={{ fontSize: "12px", color: "#c62828", background: "#fff3f3", border: "1px solid #ffcdd2", borderRadius: "6px", padding: "6px 10px", marginBottom: "10px" }}>
                                                    <b>{this.state.truckloadDateFormat}</b> is invalid for this row - {outcome.reason}.
                                                </div>
                                            );
                                        })()
                                        : null}
                                    {/* Always shown and always applied - whether or not the file's
                                        Plan Date was ambiguous text or a real Excel Date cell. Excel's
                                        own date resolution can itself be wrong (it silently used
                                        whatever regional format was active when the file's author
                                        entered it), so this format is genuinely re-applied to every
                                        row, not skipped for cells that already look resolved - see
                                        normalizePlanDateFromFile. Picking the format that already
                                        matches Excel's own order is a no-op; picking any other order
                                        genuinely changes the stored date, per the live preview above. */}
                                    <span style={{ fontSize: "12px", fontWeight: 700, color: "#1565c0", marginBottom: "6px", display: "flex", alignItems: "center" }}>
                                        <i className="icofont icofont-calendar" style={{ marginRight: "5px" }}></i>Plan Date Format <span style={{ color: "#c62828" }}>*</span>
                                    </span>
                                    {/* Plain wrapper div with a fixed width, not a Select prop/style -
                                        the parent here is a flex column (stretches children to full
                                        width by default); this just caps the OUTER box so the Select
                                        fills that instead of the whole slider, without touching
                                        anything about how react-select itself positions its menu. */}
                                    <div style={{ width: "220px" }}>
                                        <Select
                                            placeholder={"Select Plan Date format"}
                                            closeMenuOnSelect={true}
                                            onChange={this.onTruckloadDateFormatChange}
                                            classNamePrefix="react-select"
                                            value={PLAN_DATE_FORMAT_OPTIONS.find((o) => o.value === this.state.truckloadDateFormat) || null}
                                            options={PLAN_DATE_FORMAT_OPTIONS}
                                            isClearable={true}
                                            // Opens upward instead of react-select's own default
                                            // downward placement - this field sits low in the slider,
                                            // with the (often long) Validation Errors box right below
                                            // it, so a downward menu had too little room and either
                                            // got clipped or forced the whole slider to scroll just to
                                            // see the options. menuPlacement="top" is a plain layout
                                            // preference, not a fix for the z-index issue the styles
                                            // prop below already handles (open menu painting above the
                                            // Validation Errors box's own header instead of under it).
                                            menuPlacement="top"
                                            // No portal, no scroll changes - just a plain z-index bump so
                                            // the open (still rendered inline) options list paints above
                                            // its neighbors instead of going under them by plain DOM
                                            // order. Since menuPlacement="top" opens the list UPWARD, that
                                            // now means the "Your data looks like this" sample table right
                                            // ABOVE this field, not the Validation Errors box below it -
                                            // 10 was nowhere near enough to beat that table's own header,
                                            // bumped way up so this can't lose a stacking fight with
                                            // anything else in the slider again.
                                            styles={{ menu: (base) => ({ ...base, zIndex: 3000 }) }}
                                        />
                                    </div>
                                </div>
                            </div>
                            : null}

                        {this.state.truckloadErrors.length > 0 ?
                            <div style={{ background: "#fff3f3", border: "1px solid #ffcdd2", borderRadius: "8px", padding: "12px 14px", marginBottom: "16px" }}>
                                <p style={{ fontWeight: 700, fontSize: "12.5px", color: "#c62828", margin: "0 0 8px 0" }}>
                                    <i className="icofont icofont-warning-alt" style={{ marginRight: "6px" }}></i>Validation Errors ({this.state.truckloadErrors.length})
                                </p>
                                {/* overflowX:auto scopes any horizontal scroll to just this table's
                                    own box - it can never force the slider (or the page) itself to
                                    scroll sideways. table-layout:fixed + word-break on the
                                    description cell keep long error text wrapping within its
                                    column instead of stretching the table wider. */}
                                <div style={{ maxHeight: "360px", overflowY: "auto" }}>
                                    {/* Both columns get an explicit width (not just Row) - with
                                        table-layout:fixed, leaving Error Description's width
                                        unspecified lets the browser size it off content instead of
                                        the container, which is exactly what was forcing the
                                        horizontal scroll. word-break then wraps long text within
                                        that fixed width instead of stretching the table. */}
                                    <table className="table table-sm" style={{ width: "100%", tableLayout: "fixed", marginBottom: 0 }}>
                                        <thead><tr><th style={{ width: "60px" }}>Row</th><th style={{ width: "calc(100% - 60px)" }}>Error Description</th></tr></thead>
                                        <tbody>
                                            {this.state.truckloadErrors.map((e, i) => (
                                                <tr key={i}><td>{e.row}</td><td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{e.error}</td></tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            : null}

                        {this.state.truckloadValidRows.length > 0 ?
                            <div style={{ background: "#e8f4fd", border: "1px solid #b3d9f7", borderRadius: "8px", padding: "10px 14px", marginBottom: "16px", fontSize: "12.5px", color: "#37474f" }}>
                                {this.state.truckloadValidRows.length} valid row(s) ready to submit, across trip no(s): {[...new Set(this.state.truckloadValidRows.map(r => r.trip_no))].join(', ')}
                                {this.state.truckloadDuplicateHUs && this.state.truckloadDuplicateHUs.length > 0 ?
                                    <div style={{ marginTop: "4px", color: "#e65100" }}>
                                        The {this.state.truckloadDuplicateHUs.length} duplicate HU(s) below will be skipped - Submit now to upload just the valid rows, or fix them in your file and re-upload.
                                    </div>
                                    : null}
                                {this.state.truckloadPlanDateMismatchHUs && this.state.truckloadPlanDateMismatchHUs.length > 0 ?
                                    <div style={{ marginTop: "4px", color: "#6a1b9a" }}>
                                        The {this.state.truckloadPlanDateMismatchHUs.length} HU(s) below have a Plan Date that doesn't match their trip and will be skipped - Submit now to upload just the valid rows, or fix the dates in your file and re-upload.
                                    </div>
                                    : null}
                                {this.state.truckloadPlanDateOutOfWindowHUs && this.state.truckloadPlanDateOutOfWindowHUs.length > 0 ?
                                    <div style={{ marginTop: "4px", color: "#ad1457" }}>
                                        The {this.state.truckloadPlanDateOutOfWindowHUs.length} HU(s) below have a Plan Date outside this plan's upload window and will be skipped - Submit now to upload just the valid rows, or fix the dates in your file and re-upload.
                                    </div>
                                    : null}
                            </div>
                            : null}

                        {this.state.truckloadUploadMessage ?
                            <div style={this.state.truckloadUploadMessage.type === "success"
                                ? { background: "#e8f5e9", border: "1px solid #a5d6a7", color: "#2e7d32", borderRadius: "8px", padding: "10px 14px", fontSize: "12.5px", marginBottom: "16px" }
                                : { background: "#fff3f3", border: "1px solid #ffcdd2", color: "#c62828", borderRadius: "8px", padding: "10px 14px", fontSize: "12.5px", marginBottom: "16px" }}>
                                {this.state.truckloadUploadMessage.text}
                            </div>
                            : null}

                        {this.state.truckloadResults ?
                            <div style={{ marginBottom: "16px" }}>
                                <p style={{ fontWeight: 700, fontSize: "13px", color: "#333", margin: "0 0 8px 0" }}>Upload Result</p>
                                <div style={{ maxHeight: "360px", overflowY: "auto", overflowX: "auto" }}>
                                    <table className="table table-sm" style={{ width: "100%", tableLayout: "fixed", marginBottom: 0 }}>
                                        <thead><tr><th style={{ width: "16%" }}>Trip No</th><th style={{ width: "28%" }}>Status</th><th style={{ width: "14%" }}>Rows Applied</th><th style={{ width: "14%" }}>Duplicates</th><th style={{ width: "14%" }}>Date Mismatches</th><th style={{ width: "14%" }}>Out of Window</th></tr></thead>
                                        <tbody>
                                            {this.state.truckloadResults.map((r, i) => {
                                                var badge = { text: "Applied", bg: "#c8e6c9", color: "#2e7d32" };
                                                if (r.status === 'rejected_already_completed') badge = { text: "Loading Already Completed", bg: "#ffcdd2", color: "#c62828" };
                                                else if (r.status === 'rejected_all_duplicate') badge = { text: "All Rows Duplicate", bg: "#ffe0b2", color: "#e65100" };
                                                // A trip is one vehicle's load on one scheduled day - every
                                                // HU under it has to share the same Plan Date (see
                                                // insertNewTripPlanData on the backend), so this status means
                                                // every row here was rejected for landing on a DIFFERENT date
                                                // than what's already committed for this trip_no.
                                                else if (r.status === 'rejected_plan_date_mismatch') badge = { text: "Plan Date Mismatch", bg: "#e1bee7", color: "#6a1b9a" };
                                                // Every row's OWN plan_date fell outside this plan's 2-day
                                                // approval window (createDate through createDate+2) - never
                                                // even compared against the trip's other rows.
                                                else if (r.status === 'rejected_plan_date_out_of_window') badge = { text: "Plan Date Out of Window", bg: "#f8bbd0", color: "#ad1457" };
                                                return (
                                                    <tr key={i}>
                                                        <td>{r.trip_no}</td>
                                                        <td><span style={{ display: "inline-block", padding: "2px 10px", borderRadius: "12px", fontSize: "11.5px", fontWeight: 600, background: badge.bg, color: badge.color, whiteSpace: "normal" }}>{badge.text}</span></td>
                                                        <td>{r.row_count || 0}</td>
                                                        <td>{r.duplicate_count || 0}</td>
                                                        <td>{r.plan_date_mismatch_count || 0}</td>
                                                        <td>{r.plan_date_out_of_window_count || 0}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            : null}

                        {this.state.truckloadPlanDateMismatchHUs && this.state.truckloadPlanDateMismatchHUs.length > 0 ?
                            <div style={{ background: "#f3e5f5", border: "1px solid #ce93d8", borderRadius: "8px", padding: "12px 14px", marginBottom: "16px" }}>
                                <p style={{ fontWeight: 700, fontSize: "12.5px", color: "#6a1b9a", margin: "0 0 8px 0" }}>
                                    <i className="icofont icofont-warning-alt" style={{ marginRight: "6px" }}></i>{this.state.truckloadPlanDateMismatchHUs.length} HU(s) skipped - Plan Date doesn't match this trip
                                </p>
                                <span style={{ fontSize: "12px", color: "#6a1b9a" }}>A trip is one vehicle's load on one scheduled day, so every HU under the same Trip No has to share the same Plan Date - fix the Plan Date in your file to match what's already uploaded (or use a different Trip No for a genuinely different load) and re-upload:</span>
                                <div style={{ maxHeight: "360px", overflowY: "auto", overflowX: "auto", marginTop: "8px" }}>
                                    <table className="table table-sm table-bordered mb-0" style={{ width: "100%", tableLayout: "fixed" }}>
                                        <thead><tr><th style={{ width: "14%" }}>Trip</th><th style={{ width: "20%" }}>HU</th><th style={{ width: "22%" }}>Consignee</th><th style={{ width: "20%" }}>Doc No</th><th style={{ width: "24%" }}>Existing Trip's Plan Date</th></tr></thead>
                                        <tbody>
                                            {this.state.truckloadPlanDateMismatchHUs.map((d, idx) => (
                                                <tr key={idx}>
                                                    <td style={{ wordBreak: "break-word" }}>{d.trip_no}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.hu}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.consignee}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.doc_no}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.committed_plan_date ? getHyphenDDMMMYYYY(d.committed_plan_date) : "—"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            : null}

                        {this.state.truckloadPlanDateOutOfWindowHUs && this.state.truckloadPlanDateOutOfWindowHUs.length > 0 ?
                            <div style={{ background: "#fce4ec", border: "1px solid #f48fb1", borderRadius: "8px", padding: "12px 14px", marginBottom: "16px" }}>
                                <p style={{ fontWeight: 700, fontSize: "12.5px", color: "#ad1457", margin: "0 0 8px 0" }}>
                                    <i className="icofont icofont-warning-alt" style={{ marginRight: "6px" }}></i>{this.state.truckloadPlanDateOutOfWindowHUs.length} HU(s) skipped - Plan Date is outside this plan's upload window
                                </p>
                                <span style={{ fontSize: "12px", color: "#ad1457" }}>
                                    {(() => {
                                        var window = this.getPlanDateWindow();
                                        return window
                                            ? "Plan Date has to fall between " + getHyphenDDMMMYYYY(window.start) + " and " + getHyphenDDMMMYYYY(window.end) + " for this plan - "
                                            : "";
                                    })()}
                                    fix the Plan Date in your file and re-upload:
                                </span>
                                <div style={{ maxHeight: "360px", overflowY: "auto", overflowX: "auto", marginTop: "8px" }}>
                                    <table className="table table-sm table-bordered mb-0" style={{ width: "100%", tableLayout: "fixed" }}>
                                        <thead><tr><th style={{ width: "14%" }}>Trip</th><th style={{ width: "22%" }}>HU</th><th style={{ width: "24%" }}>Consignee</th><th style={{ width: "20%" }}>Doc No</th><th style={{ width: "20%" }}>Row's Plan Date</th></tr></thead>
                                        <tbody>
                                            {this.state.truckloadPlanDateOutOfWindowHUs.map((d, idx) => (
                                                <tr key={idx}>
                                                    <td style={{ wordBreak: "break-word" }}>{d.trip_no}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.hu}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.consignee}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.doc_no}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.plan_date ? getHyphenDDMMMYYYY(d.plan_date) : "—"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            : null}

                        {this.state.truckloadDuplicateHUs && this.state.truckloadDuplicateHUs.length > 0 ?
                            <div style={{ background: "#fff3f3", border: "1px solid #ffcdd2", borderRadius: "8px", padding: "12px 14px", marginBottom: "16px" }}>
                                <p style={{ fontWeight: 700, fontSize: "12.5px", color: "#c62828", margin: "0 0 8px 0" }}>
                                    <i className="icofont icofont-warning-alt" style={{ marginRight: "6px" }}></i>{this.state.truckloadDuplicateHUs.length} HU(s) already exist in this plan and were not uploaded again
                                </p>
                                <span style={{ fontSize: "12px", color: "#c62828" }}>An HU can only belong to one trip in the whole plan - remove these HU(s) from your file and re-upload only new HU(s):</span>
                                {/* overflowX:auto scopes any horizontal scroll to just this table's own
                                    box - it can never force the slider (or the page) itself to scroll
                                    sideways. tableLayout:fixed + explicit % widths keep the 6 columns
                                    within the slider's own width instead of growing past it. maxHeight
                                    widened to fit ~10 rows before it needs to scroll vertically. */}
                                <div style={{ maxHeight: "360px", overflowY: "auto", overflowX: "auto", marginTop: "8px" }}>
                                    <table className="table table-sm table-bordered mb-0" style={{ width: "100%", tableLayout: "fixed" }}>
                                        <thead><tr><th style={{ width: "14%" }}>Trip</th><th style={{ width: "18%" }}>HU</th><th style={{ width: "20%" }}>Consignee</th><th style={{ width: "16%" }}>Doc No</th><th style={{ width: "14%" }}>In Trip</th><th style={{ width: "18%" }}>Status</th></tr></thead>
                                        <tbody>
                                            {this.state.truckloadDuplicateHUs.map((d, idx) => (
                                                <tr key={idx}>
                                                    <td style={{ wordBreak: "break-word" }}>{d.trip_no}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.hu}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.consignee}</td>
                                                    <td style={{ wordBreak: "break-word" }}>{d.doc_no}</td>
                                                    <td style={{ wordBreak: "break-word" }}>
                                                        {d.existing_trip_no}{String(d.existing_trip_no) !== String(d.trip_no) ? <span style={{ color: "#c62828", fontWeight: 600 }}> (diff.)</span> : null}
                                                    </td>
                                                    <td>{d.scan_status === "completed" ?
                                                        <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: 600, background: "#c8e6c9", color: "#1b5e20", whiteSpace: "normal" }}>Completed</span> :
                                                        <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: 600, background: "#ffe0b2", color: "#e65100", whiteSpace: "normal" }}>Exists</span>}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            : null}
                    </div>

                    <div style={{ borderTop: "1px solid #e8e8e8", background: "#fff", padding: "14px 20px", display: "flex", gap: "10px", flexShrink: 0 }}>
                        <button
                            type="button"
                            onClick={this.submitTruckloadUpload}
                            disabled={this.state.truckloadValidRows.length === 0}
                            style={{
                                flex: 1, height: "42px", borderRadius: "6px", border: "none", fontWeight: 600, fontSize: "13px",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: this.state.truckloadValidRows.length === 0 ? "#90caf9" : "#1565c0",
                                color: "#fff", cursor: this.state.truckloadValidRows.length === 0 ? "not-allowed" : "pointer"
                            }}
                        >
                            <i className="icofont icofont-upload-alt" style={{ marginRight: "6px" }}></i>Submit
                        </button>
                        <button
                            type="button"
                            onClick={this.hideTruckloadUpload}
                            className="btn btn-default"
                            style={{ flex: 1, height: "42px", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center" }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>

                <div className={"slide-r " + (this.state.truckloadAddSlide)} style={{ overflow: "hidden", display: "flex", flexDirection: "column", height: "100%", right: 0, boxShadow: this.state.truckloadAddSlide ? undefined : "none" }}>
                    {this.state.truckloadSliderBusy ?
                        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(255,255,255,0.65)", zIndex: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                        </div>
                        : null}
                    <div style={{ background: "linear-gradient(135deg, #1565c0 0%, #1976d2 100%)", padding: "16px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <i className="icofont icofont-truck-loaded" style={{ color: "white", fontSize: "22px" }}></i>
                            <div>
                                <h5 style={{ color: "white", margin: 0, fontWeight: 700, fontSize: "15px", letterSpacing: "0.3px" }}>Add Loading Plan Row</h5>
                                <p style={{ color: "rgba(255,255,255,0.75)", margin: 0, fontSize: "11px" }}>Add a single HU for {this.state.transactionId}</p>
                            </div>
                        </div>
                        <button type="button" onClick={this.hideTruckloadAdd} style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: "50%", width: "30px", height: "30px", color: "white", cursor: "pointer", fontSize: "18px", lineHeight: "1", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                    </div>

                    <div className="slide-r-body" style={{ position: "relative", flex: 1, minHeight: 0, overflowY: "auto", padding: "20px 20px 8px 20px" }}>
                        <p style={{ fontSize: "12px", color: "#78909c", margin: "0 0 14px 0", lineHeight: "1.4" }}>
                            Every field below is mandatory - same restrictions as the bulk-upload template (HU must be unique across the whole plan, Plan Date as YYYY-MM-DD).
                        </p>

                        {this.state.truckloadAddErrors.length > 0 ?
                            <div style={{ background: "#fff3f3", border: "1px solid #ffcdd2", borderRadius: "8px", padding: "10px 14px", marginBottom: "16px" }}>
                                <p style={{ fontWeight: 700, fontSize: "12px", color: "#c62828", margin: "0 0 6px 0" }}>
                                    <i className="icofont icofont-warning-alt" style={{ marginRight: "6px" }}></i>Please fix before adding
                                </p>
                                {this.state.truckloadAddErrors.map((err, i) => (
                                    <p key={i} style={{ fontSize: "12.5px", color: "#c62828", margin: 0 }}>{err}</p>
                                ))}
                            </div>
                            : null}

                        {/* One card per logical group instead of a flat list of 7 identical
                            boxes - a section label + spacing makes it easier to scan than
                            trying to read every field the same way. inputStyle is shared so
                            every field (including the Datetime picker's own input) looks
                            and sizes identically. */}
                        {(() => {
                            var inputStyle = { fontSize: "12.5px", height: "38px", borderRadius: "6px", border: "1px solid #cfd8dc", padding: "8px 12px" };
                            var sectionLabelStyle = { fontSize: "11px", fontWeight: 700, color: "#78909c", textTransform: "uppercase", letterSpacing: "0.5px", margin: "0 0 10px 0" };
                            var fieldLabelStyle = { fontSize: "12px", fontWeight: 600, color: "#333", display: "flex", alignItems: "center", gap: "5px", marginBottom: "5px" };
                            var cardStyle = { background: "#f8fafc", border: "1px solid #e0e6ed", borderRadius: "10px", padding: "14px 16px", marginBottom: "14px" };
                            var sections = [
                                {
                                    label: "Trip Details",
                                    fields: [
                                        { key: "trip_no", label: "Trip No", icon: "icofont-road", placeholder: "e.g. 3" },
                                        { key: "trip_type", label: "Trip Type", icon: "icofont-tasks-alt", placeholder: "e.g. Regular" }
                                    ]
                                },
                                {
                                    label: "Shipment Details",
                                    fields: [
                                        { key: "consignee", label: "Consignee", icon: "icofont-businessman", placeholder: "Consignee code/name" },
                                        { key: "doc_no", label: "Doc. No.", icon: "icofont-file-text", placeholder: "Document number" },
                                        { key: "doc_type", label: "Doc. Type", icon: "icofont-tag", placeholder: "e.g. Invoice" }
                                    ]
                                },
                                {
                                    label: "Handling Unit & Date",
                                    fields: [
                                        { key: "hu", label: "HU", icon: "icofont-barcode", placeholder: "Handling Unit barcode" }
                                    ]
                                }
                            ];
                            return sections.map((section, sIdx) => (
                                <div key={sIdx} style={cardStyle}>
                                    <p style={sectionLabelStyle}>{section.label}</p>
                                    <div className="row" style={{ marginLeft: 0, marginRight: 0 }}>
                                        {section.fields.map((f) => (
                                            <div key={f.key} className={section.fields.length > 1 ? "col-6 form-group" : "col-12 form-group"} style={{ marginBottom: "10px" }}>
                                                <label style={fieldLabelStyle}>
                                                    <i className={"icofont " + f.icon} style={{ color: "#1565c0", fontSize: "13px" }}></i>
                                                    {f.label} <span style={{ color: "#c62828" }}>*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={inputStyle}
                                                    placeholder={f.placeholder}
                                                    value={this.state.truckloadAddRow[f.key]}
                                                    onChange={(e) => this.onTruckloadAddFieldChange(f.key, e.target.value)}
                                                />
                                            </div>
                                        ))}
                                        {section.label === "Handling Unit & Date" ?
                                            <div className="col-12 form-group" style={{ marginBottom: 0 }}>
                                                <label style={fieldLabelStyle}>
                                                    <i className="icofont icofont-calendar" style={{ color: "#1565c0", fontSize: "13px" }}></i>
                                                    Plan Date <span style={{ color: "#c62828" }}>*</span>
                                                </label>
                                                <Datetime
                                                    value={this.state.truckloadAddRow.plan_date}
                                                    dateFormat="YYYY-MM-DD"
                                                    timeFormat={false}
                                                    closeOnSelect={true}
                                                    // Greys out every day outside this plan's own 2-day upload
                                                    // window (see getPlanDateWindow) so an operator can't even
                                                    // pick a date that submitTruckloadAddRow would reject a
                                                    // moment later - fails OPEN (every day selectable) when the
                                                    // window itself is unknown, same convention as every other
                                                    // check derived from it.
                                                    isValidDate={(current) => {
                                                        var window = this.getPlanDateWindow();
                                                        if (!window) return true;
                                                        return current.isSameOrAfter(window.start, 'day') && current.isSameOrBefore(window.end, 'day');
                                                    }}
                                                    inputProps={{
                                                        placeholder: "YYYY-MM-DD, e.g. 2026-08-06",
                                                        className: "form-control",
                                                        autoComplete: "off",
                                                        style: inputStyle
                                                    }}
                                                    onChange={this.onTruckloadAddPlanDateChange}
                                                />
                                                {(() => {
                                                    var window = this.getPlanDateWindow();
                                                    return window ? (
                                                        <p style={{ fontSize: "11px", color: "#78909c", margin: "5px 0 0 0" }}>
                                                            Allowed: {getHyphenDDMMMYYYY(window.start)} to {getHyphenDDMMMYYYY(window.end)}
                                                        </p>
                                                    ) : null;
                                                })()}
                                            </div>
                                            : null}
                                    </div>
                                </div>
                            ));
                        })()}

                        {/* A single-row add that doesn't fully succeed (handleUploadPlanDataResponse's
                            isFullSuccess check) is always exactly one rejected/duplicate result - a
                            table with one row reads worse than a plain disclaimer, so show the reason
                            as a banner instead, matching the truckloadAddErrors box above it. */}
                        {this.state.truckloadResults && this.state.truckloadResults[0] ?
                            (() => {
                                var r = this.state.truckloadResults[0];
                                // A single-row add's own duplicate (if any) is the only entry in
                                // r.duplicates - read its scan_status to tell "already uploaded,
                                // still pending" apart from "already scanned, can't be re-added".
                                var dupScanStatus = (r.duplicates && r.duplicates[0] && r.duplicates[0].scan_status) || 'pending';
                                var isCompleted = r.status === 'rejected_already_completed' || dupScanStatus === 'completed';
                                var message = r.status === 'rejected_already_completed'
                                    ? "Trip " + r.trip_no + " has already completed loading - rows can't be added to it anymore."
                                    : (isCompleted
                                        ? "This HU already exists on Trip " + r.trip_no + " and has already been scanned/completed - it can't be re-added."
                                        : "This HU already exists on Trip " + r.trip_no + " - nothing new to add.");
                                return (
                                    <div style={{ background: isCompleted ? "#e8f5e9" : "#fff8e1", border: "1px solid " + (isCompleted ? "#a5d6a7" : "#ffe082"), borderRadius: "8px", padding: "10px 14px", marginTop: "10px", marginBottom: "16px" }}>
                                        <p style={{ fontWeight: 700, fontSize: "12px", color: isCompleted ? "#2e7d32" : "#e65100", margin: 0 }}>
                                            <i className="icofont icofont-warning-alt" style={{ marginRight: "6px" }}></i>{message}
                                        </p>
                                    </div>
                                );
                            })()
                            : null}
                    </div>

                    <div style={{ borderTop: "1px solid #e8e8e8", background: "#fff", padding: "14px 20px", display: "flex", gap: "10px", flexShrink: 0 }}>
                        <button
                            type="button"
                            onClick={this.submitTruckloadAddRow}
                            style={{
                                flex: 1, height: "42px", borderRadius: "6px", border: "none", fontWeight: 600, fontSize: "13px",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                background: "#1565c0", color: "#fff", cursor: "pointer"
                            }}
                        >
                            <i className="icofont icofont-upload-alt" style={{ marginRight: "6px" }}></i>Add
                        </button>
                        <button
                            type="button"
                            onClick={this.hideTruckloadAdd}
                            className="btn btn-default"
                            style={{ flex: 1, height: "42px", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center" }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>

                {this.state.pageType == "adherence" && <div className={"row mt-10p"}>
                    <div className={`col-sm-12 d-flex ${this.state.adherenceTransactionDetails.length === 0 ? 'justify-content-end' : 'justify-content-between'} pb-5px`}>
                        {this.state.adherenceTransactionDetails.length > 0 ? <span>Last Calculated Stats : {this.state.last_calculated_date}</span> : ''}
                        <div>
                            <button onClick={this.openAdherenceCalculation} className={`btn btn-info mr-2`}>Adherence Calculation Logic</button>
                            <button onClick={this.calculateadherencedata} disabled={this.state.adherenceTransactionDetails.length > 0} className={`btn btn-primary ${this.state.adherenceTransactionDetails.length > 0 ? 'fc-not-allowed' : ''}`}>Calculate Adherence Stats</button>
                        </div>
                    </div>
                    {(this.state.adherenceTransactionDetails.length > 0) ?
                        <>
                            {/* <div className="col-sm-12 mt-20p mb-3">
                  <div className="col-xl-12 col-lg-12 col-sm-12 beffect ">
                    <div className="card">
                      <div className="card-body">
                        <div className="crm-numbers pb-0">
                          <div className="row">
                            <div className="col cursorPointer">
                              <span className="f13">
                                
                                <br /> Trips Adherence %
                              </span>
                              <h4 className="darkgreen f30">
                                <span className="counter">
                                  {this.state.percent_adhered_trips.toFixed(2)}
                                </span>
                              </h4>
                            </div>
                            <div className="col cursorPointer">
                              <span className="f13">
                                <br /> Truck Adherence %
                              </span>
                              <h4 className="darkgreen f30">
                                <span className="counter">
                                  {this.state.percent_truck_adherence.toFixed(2)}
                                </span>
                              </h4>
                            </div>

                            <div className="col cursorPointer">
                              <span className="f13">
                                <br /> Manual Cost
                              </span>
                              <h4 className=" txt-primary f30">
                                <span className="counter">
                                  {this.state.cost_manual.toFixed(2)}
                                </span>
                              </h4>
                            </div>
                            <div className="col cursorPointer">
                              <span className="f13">
                                <br /> System Cost
                              </span>
                              <h4 className=" darkgreen f30">
                                <span className="counter">
                                  {this.state.cost_system.toFixed(2)}
                                </span>
                              </h4>
                            </div>
                            <div className="col cursorPointer">
                              <span className="f13">
                                <br /> Load (CMT)
                              </span>
                              <h4 className=" txt-success f30">
                                <span className="counter">
                                  {this.state.load.toFixed(2)}
                                </span>
                              </h4>
                            </div>
                            {this.state.demand_system != undefined ?
                            <div className="col cursorPointer" title='Load planned as per system output for dispatched pick tickets'>
                              <span className="f13">
                                <br /> Planned Load
                              </span>
                              <h4 className="darkgreen f30">
                                <span className="counter">
                                  {this.state.demand_system.toFixed(2)}
                                </span>
                              </h4>
                            </div>
                            :''}
                            
                            {this.state.demand_manual != undefined ?
                            <div className="col cursorPointer" title='Actual Load through dispatched pick tickets as per MGP Data'>
                              <span className="f13">
                                <br /> Actual Load Dispatched
                              </span>
                              <h4 className="darkgreen f30">
                                <span className="counter">
                                  {this.state.demand_manual.toFixed(2)}
                                </span>
                              </h4>
                            </div>
                            :''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                    </div>     */}


                            <div className="col-xl-12 col-lg-12 col-sm-12 beffect ">
                                <div className="card"><div><div className="crm-numbers pb-0">

                                    {this.state.num_extra_pick_tickets != undefined ?

                                        <>
                                            <div className="">
                                                {/* Adherence Section */}
                                                <div className="row">
                                                    <div className="col-md-4" style={{ paddingRight: '0px' }}>
                                                        <div className="">
                                                            <div className="card-body">
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <h6 className="card-subtitle text-muted">Trips Adherence</h6>
                                                                    <h2 className="card-title mb-2">{this.state.percent_adhered_trips.toFixed(2)}%</h2>
                                                                </div>
                                                                <div className="progress">
                                                                    <div
                                                                        className="progress-bar"
                                                                        role="progressbar"
                                                                        style={{ width: `${this.state.percent_adhered_trips.toFixed(2)}%` }}
                                                                        aria-valuenow={this.state.percent_adhered_trips.toFixed(2)}
                                                                        aria-valuemin={0}
                                                                        aria-valuemax={100}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4" style={{ paddingRight: '0px' }}>
                                                        <div className="">
                                                            <div className="card-body">
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <h6 className="card-subtitle text-muted">Vehicle Type Adherence</h6>
                                                                    <h2 className="card-title mb-2">{this.state.veh_type_adherence.toFixed(2)}%</h2>
                                                                </div>
                                                                <div className="progress">
                                                                    <div
                                                                        className="progress-bar"
                                                                        role="progressbar"
                                                                        style={{ width: `${this.state.veh_type_adherence.toFixed(2)}%` }}
                                                                        aria-valuenow={this.state.veh_type_adherence.toFixed(2)}
                                                                        aria-valuemin={0}
                                                                        aria-valuemax={100}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-md-4" style={{paddingRight: '0px'}}>
                    <div className="">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="card-subtitle text-muted">Trucks Adherence</h6>
                        <h2 className="card-title mb-2">{this.state.percent_truck_adherence.toFixed(2)}%</h2>
                        </div>
                        <div className="progress">
                          <div 
                            className="progress-bar" 
                            role="progressbar" 
                            style={{ width: `${this.state.percent_truck_adherence.toFixed(2)}%` }} 
                            aria-valuenow={this.state.percent_truck_adherence.toFixed(2)} 
                            aria-valuemin={0} 
                            aria-valuemax={100}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                                                    <div className="col-md-4" style={{ paddingLeft: '0px' }}>
                                                        <div className="">
                                                            <div className="card-body">
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <h6 className="card-subtitle text-muted">Dealer Adherence</h6>
                                                                    <h2 className="card-title mb-2">{this.state.dealer_adherence.toFixed(2)}%</h2>
                                                                </div>
                                                                <div className="progress">
                                                                    <div
                                                                        className="progress-bar"
                                                                        role="progressbar"
                                                                        style={{ width: `${this.state.dealer_adherence.toFixed(2)}%` }}
                                                                        aria-valuenow={this.state.dealer_adherence.toFixed(2)}
                                                                        aria-valuemin={0}
                                                                        aria-valuemax={100}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4" style={{ paddingRight: '0px' }}>
                                                        <div className="">
                                                            <div className="card-body">
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <h6 className="card-subtitle text-muted">Pick Ticket Adherence</h6>
                                                                    <h2 className="card-title mb-2">{this.state.pick_ticket_adherence.toFixed(2)}%</h2>
                                                                </div>
                                                                <div className="progress">
                                                                    <div
                                                                        className="progress-bar"
                                                                        role="progressbar"
                                                                        style={{ width: `${this.state.pick_ticket_adherence.toFixed(2)}%` }}
                                                                        aria-valuenow={this.state.pick_ticket_adherence.toFixed(2)}
                                                                        aria-valuemin={0}
                                                                        aria-valuemax={100}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4" style={{ paddingRight: '0px' }}>
                                                        <div className="">
                                                            <div className="card-body">
                                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <h6 className="card-subtitle text-muted">Route Adherence</h6>
                                                                    <h2 className="card-title mb-2">{this.state.route_adherence.toFixed(2)}%</h2>
                                                                </div>
                                                                <div className="progress">
                                                                    <div
                                                                        className="progress-bar"
                                                                        role="progressbar"
                                                                        style={{ width: `${this.state.route_adherence.toFixed(2)}%` }}
                                                                        aria-valuenow={this.state.route_adherence.toFixed(2)}
                                                                        aria-valuemin={0}
                                                                        aria-valuemax={100}
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="">
                                                <table className="table table-bordered">
                                                    <colgroup>
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                    </colgroup>
                                                    <thead >
                                                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                                                            <th colSpan="6" style={{ textAlign: "center", padding: '0px' }}>System Plan</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Total Cost (₹)</span><h4 className="txt-pink-light f30"><span className="counter">{this.state.total_cost_system}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br />Input Load (CMT) </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.load.toFixed(2)}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br />Trips </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.num_trips_system}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Pick Tickets </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.total_pick_tickets}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Dropped Consignees </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.system_drop}</span></h4></div></td>

                                                            <td style={{ textAlign: 'center', color: '#777777' }}>
                                                                Planned VS Available Vehicles
                                                                <tr className='d-flex justify-content-center'>
                                                                    {this.state.plannedTrucksCount.length ?

                                                                        this.state.plannedTrucksCount.map((item, index) => {

                                                                            return (
                                                                                <td style={{ padding: '0px' }}><div className="col cursorPointer"><span className="f13"><br /> {item.vehicle_type}</span><h4 className="txt-pink-light f17"><span className="counter">{item.num_trips_system + ' / ' + item.available_count}</span></h4></div></td>
                                                                            )
                                                                        })
                                                                        : 'NA'}
                                                                </tr>
                                                            </td>
                                                        </tr>
                                                    </tbody>

                                                </table>
                                            </div>

                                            <div className="">
                                                <table className="table table-bordered">
                                                    <colgroup>
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                    </colgroup>
                                                    <thead  >
                                                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                                                            <th colSpan="6" style={{ textAlign: "center", padding: '0px' }}>Manual Plan ( w.r.t Input Plan )</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Total Cost (₹)</span><h4 className="txt-pink-light f30"><span className="counter">{this.state.cost_manual}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Load Dispatched (CMT) </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.demand_manual.toFixed(2)}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Trips </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.num_trips_manual}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Pick Tickets </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.pick_tickets_received}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Dropped Consignees </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.manual_drop}</span></h4></div></td>

                                                            <td style={{ textAlign: 'center', color: '#777777' }}>
                                                                Planned VS Available Vehicles
                                                                <tr className='d-flex justify-content-center'>
                                                                    {this.state.plannedTrucksCount.length ?

                                                                        this.state.plannedTrucksCount.map((item, index) => {
                                                                            return (
                                                                                <td style={{ padding: '0px' }}><div className="col cursorPointer"><span className="f13"><br /> {item.vehicle_type}</span><h4 className="txt-pink-light f17"><span className="counter">{item.num_trips_manual + ' / ' + item.available_count}</span></h4></div></td>
                                                                            )
                                                                        })
                                                                        : 'NA'}
                                                                </tr>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="">
                                                <table className="table table-bordered">
                                                    <colgroup>
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                        <col style={{ width: '20%' }} />
                                                    </colgroup>
                                                    <thead  >
                                                        <tr style={{ backgroundColor: "#f0f0f0" }}>
                                                            <th colSpan="6" style={{ textAlign: "center", padding: '0px' }}>Manual Plan ( Overall )</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Total Cost (₹)</span><h4 className="txt-pink-light f30"><span className="counter">{this.state.manual_total_cost}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br />Load Dispatched (CMT) </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.manual_total_load.toFixed(2)}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br />Trips </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.num_trips_manual}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Pick Tickets </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.manual_pick_tickets}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Dropped Consignees </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.manual_drop}</span></h4></div></td>
                                                            <td style={{ textAlign: 'center', color: '#777777' }}>
                                                                Planned VS Available Vehicles
                                                                <tr className='d-flex justify-content-center'>
                                                                    {this.state.plannedTrucksCount.length ?

                                                                        this.state.plannedTrucksCount.map((item, index) => {

                                                                            return (
                                                                                <td style={{ padding: '0px' }}><div className="col cursorPointer"><span className="f13"><br /> {item.vehicle_type}</span><h4 className="txt-pink-light f17"><span className="counter">{item.num_trips_manual + ' / ' + item.available_count}</span></h4></div></td>
                                                                            )
                                                                        })
                                                                        : 'NA'}
                                                                </tr>
                                                            </td>
                                                        </tr>


                                                    </tbody>
                                                </table>

                                            </div>
                                        </>

                                        :

                                        <div className="row">
                                            <div className={this.state.total_pick_tickets == undefined ? "col-md-6" : "col-md-4"}>
                                                <table className="table table-bordered">
                                                    <thead>

                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Trips Adherence %</span><h4 className="txt-pink-light f30"><span className="counter">{this.state.percent_adhered_trips.toFixed(2)}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Manual Cost (₹)</span><h4 className="txt-primary f30"><span className="counter">{this.state.cost_manual}</span></h4></div></td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br />Truck Adherence % </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.percent_truck_adherence.toFixed(2)}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> System Cost (₹)</span><h4 className="txt-primary f30"><span className="counter">{this.state.cost_system}</span></h4></div></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className={this.state.total_pick_tickets == undefined ? "col-md-6" : "col-md-4"} style={{ borderRight: "1px solid lightgrey" }}>
                                                <table className="table table-bordered">
                                                    <thead>

                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td colspan="2"><div className="col cursorPointer"><span className="f13"><br /> Load (CMT)</span><h4 className="txt-success f30"><span className="counter">{this.state.load.toFixed(2)}</span></h4></div></td>
                                                        </tr>
                                                        <tr>
                                                            {this.state.demand_system != undefined ?
                                                                <td><div className="col cursorPointer"><span className="f13"><br /> Planned Load (CMT)</span><h4 className="txt-success f30"><span className="counter">{this.state.demand_system.toFixed(2)}</span></h4></div></td>
                                                                : <td><div className="col cursorPointer"><span className="f13"><br /> Planned Load (CMT)</span><h4 className="txt-success f30"><span className="counter">{this.state.load.toFixed(2)}</span></h4></div></td>}
                                                            {this.state.demand_manual != undefined ?
                                                                <td><div className="col cursorPointer"><span className="f13"><br /> Actual Load Dispatched (CMT)</span><h4 className="txt-success f30"><span className="counter">{this.state.demand_manual.toFixed(2)}</span></h4></div></td>
                                                                : <td><div className="col cursorPointer"><span className="f13"><br /> Actual Load Dispatched (CMT)</span><h4 className="txt-success f30"><span className="counter">{this.state.load.toFixed(2)}</span></h4></div></td>}
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            {this.state.total_pick_tickets != undefined ?
                                                <div className="col-md-4">
                                                    <table className="table table-bordered">
                                                        <thead>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td colspan="2"><div className="col cursorPointer"><span className="f13"><br /> Total Pick Tickets</span><h4 className="txt-secondary f30"><span className="counter">{this.state.total_pick_tickets}</span></h4></div></td>
                                                            </tr>
                                                            <tr>
                                                                <td><div className="col cursorPointer"><span className="f13"><br /> Pick Tickets Received</span><h4 className="txt-secondary f30"><span className="counter">{this.state.pick_tickets_received}</span></h4></div></td>
                                                                <td><div className="col cursorPointer"><span className="f13"><br />Pick Tickets Remaining</span><h4 className="txt-secondary f30"><span className="counter">{this.state.pick_tickets_remaining}</span></h4></div></td>
                                                            </tr>
                                                        </tbody>

                                                    </table>
                                                </div>
                                                : ''}
                                        </div>
                                    }

                                </div></div></div></div>

                            {this.state.num_extra_pick_tickets != undefined ?
                                <div className="col-xl-12 col-lg-12 col-sm-12 beffect ">
                                    <div className="card"><div className="crm-numbers pb-0">
                                        <div style={{ backgroundColor: "#f0f0f0", textAlign: "center", fontWeight: '600' }}>Discrepancies ( w.r.t Manual )</div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <table className="table table-bordered">
                                                    <thead>

                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Extra Pick Tickets</span><h4 className="txt-pink-light f30"><span className="counter">{this.state.num_extra_pick_tickets}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Extra Load Dispatched (CMT)</span><h4 className="txt-primary f30"><span className="counter">{this.state.demand_extra_pick_tickets.toFixed(2)}</span></h4></div></td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br />Pick Tickets Yet To Receive </span><h4 className="txt-pink-light f30"><span className="counter">{this.state.pick_tickets_remaining}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Load Yet To Receive (CMT)</span><h4 className="txt-primary f30"><span className="counter">{this.state.pending_load.toFixed(2)}</span></h4></div></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="col-md-6">
                                                <table className="table table-bordered">
                                                    <thead>

                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Extra Pick Tickets Cost (₹)</span><h4 className="txt-pink-light f30"><span className="counter">{this.state.cost_manual_extra_pick_tickets}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> Trips Dispatched With Extra Pick Tickets</span><h4 className="txt-primary f30"><span className="counter">{this.state.num_trips_manual_extra_pick_tickets}</span></h4></div></td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br />Cost of Pick Tickets Yet to Receive (₹)</span><h4 className="txt-pink-light f30"><span className="counter">{this.state.pendingPickTicketsCost}</span></h4></div></td>
                                                            <td style={{ borderRight: "1px solid lightgrey" }}><div className="col cursorPointer"><span className="f13"><br /> System Trips With Pending Pick Tickets</span><h4 className="txt-primary f30"><span className="counter">{this.state.num_trips_system_pending_pick_tickets}</span></h4></div></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div></div></div>
                                : ""}

                            <div id='percentChart1' className="col-sm-6">
                                <div id='percentChart'>
                                    <AdherencePercentBarChart data={this.state.adherencePercentData} />
                                </div>
                            </div>
                            <div id="tripChart1" className="col-sm-6">
                                <div id="tripChart">
                                    <TripBarChart data={this.state.adherenceTripData} />
                                </div>
                            </div>

                            <div id='costChart1' className="col-sm-6 mt-2">
                                <div id='costChart'>
                                    <CostBarChart data={this.state.adherenceCostData} />
                                </div>
                            </div>

                            <div id='demandChart1' className="col-sm-6 mt-2">
                                <div id='demandChart'>
                                    <DemandBarChart data={this.state.adherenceDemandData} />
                                </div>
                            </div>
                            <div className='col-sm-12 mt-10p'>
                                <h4>Adherence Data Table</h4>
                                <div id="cluterDetailsGrid" style={{ width: "100%", height: "550px", minWidth: '900px', marginTop: '10px', overflowX: "auto" }} className={"ag-theme-balham"}>
                                    <AgGridReact
                                        modules={this.state.modules}
                                        columnDefs={columnwithDefsFormanualVsSystemData}
                                        defaultColDef={this.state.defaultColDef}
                                        rowData={this.state.manualVsSystemData}
                                        rowHeight={45}
                                        headerHeight={45}
                                        enableCharts={false}
                                        // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                        onGridReady={this.onGridReady}
                                        onGridState={this.onGridState}
                                        frameworkComponents={this.state.frameworkComponents}
                                        statusBar={this.state.statusBar}
                                        // sideBar={this.state.sideBar}
                                        stopEditingWhenGridLosesFocus={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        getRowStyle={this.getManualVsSystemRowStyle}
                                        pagination={true}
                                        gridOptions={{
                                            context: { componentParent: this }
                                        }}
                                        // components={this.state.components}
                                        enableRangeSelection={true}
                                    />
                                </div>
                            </div>
                        </>
                        : <div className='col-sm-12'> <h4>No Data</h4></div>}

                    {this.state.openAdherenceFormula && (

                        <div className="popup-overlay d-flex justify-content-center align-items-center" style={{ borderRadius: "0px", backgroundColor: "", paddingLeft: "0px", position: "fixed", zIndex: "1000000000001" }}>
                            <div
                                className="popup-content d-flex flex-column beffect"
                                style={{ width: "85%", height: "90%", borderRadius: "15px", backgroundColor: "#fff", position: "relative" }}
                            >
                                <div className="d-flex justify-content-between align-items-center" style={{ padding: "10px 19px 10px 19px", flexShrink: 0, backgroundColor: "#efefef", borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}>
                                    <p className="m-0" style={{ color: "#000", fontWeight: "500", fontSize: "15px" }}>Adherence Calculation Logic</p>
                                    <div className="d-flex justify-content-center align-items-center"
                                        onClick={this.handleClosePopup}
                                        style={{ width: "30px", height: "30px", borderRadius: "50%", backgroundColor: "lightgrey", color: "#fff", cursor: "pointer" }}>
                                        X
                                    </div>
                                </div>
                                <iframe
                                    src="/docs/Adherence_Logic_Documentation.pdf" // or use officeUrl for Word/Excel
                                    title="Document Viewer"
                                    style={{
                                        width: "100%",
                                        height: "80vh",
                                        border: "none"
                                    }}
                                />
                            </div>
                        </div>
                    )}

                </div>}

                {this.state.pageType == "mgp" && <div className={"row mt-10p"}>
                    <span className='col'>Last Synced Time : {this.state.last_synced_at}</span>
                    <div className="col-sm-12 mt-20p mb-3">
                        <div className="beffect ">
                            <div className="card">
                                <div className="card-body">
                                    <div className="crm-numbers pb-0">
                                        <div className="row">
                                            <div className="col cursorPointer">
                                                <span className="f13">

                                                    <br /> Total Pick Tickets
                                                </span>
                                                <h4 className="darkgreen f30">
                                                    <span className="counter">
                                                        {this.state.mgp_total_pick_tickets}
                                                    </span>
                                                </h4>
                                            </div>
                                            <div className="col cursorPointer">
                                                <span className="f13">
                                                    <br /> Pick Tickets Received
                                                </span>
                                                <h4 className="darkgreen f30">
                                                    <span className="counter">
                                                        {this.state.mgp_pick_tickets_received}
                                                    </span>
                                                </h4>
                                            </div>

                                            <div className="col cursorPointer">
                                                <span className="f13">
                                                    <br /> Pick Tickets Remaining
                                                </span>
                                                <h4 className=" txt-primary f30">
                                                    <span className="counter">
                                                        {this.state.mgp_pick_tickets_remaining}
                                                    </span>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-sm-12 mt-10p'>
                        <div id="myGrid" style={{ width: "100%", height: "478px" }} className={"ag-theme-balham "}>
                            <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefsForMGPData}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.mgprowdata}
                                rowHeight={45}
                                headerHeight={45}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                                onCellClicked={this.onCellClickedGrid.bind(this)}
                            />
                        </div>
                    </div>
                </div>}

                <div className={"dataLoadpage " + (this.state.loadshow)}>
                </div>
                <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            </div>

        );
    }
}

function NumericCellEditor() {
}

// gets called once before the renderer is used
NumericCellEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');

    if (isCharNumeric(params.charPress)) {
        this.eInput.value = params.charPress;
    } else {
        if (params.value !== undefined && params.value !== null) {
            this.eInput.value = params.value;
        }
    }

    var that = this;
    this.eInput.addEventListener('keypress', function (event) {
        if (!isKeyPressedNumeric(event)) {
            that.eInput.focus();
            if (event.preventDefault) event.preventDefault();
        } else if (that.isKeyPressedNavigation(event)) {
            event.stopPropagation();
        }
    });

    // only start edit if key pressed is a number, not a letter
    var charPressIsNotANumber = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
    this.cancelBeforeStart = charPressIsNotANumber;
};

function getCharCodeFromEvent(event) {
    event = event || window.event;
    return (typeof event.which == "undefined") ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
    return !!/\d/.test(charStr);
}

function isCharDecimal(charStr) {
    return !!/\./.test(charStr);
}

function isKeyPressedNumeric(event) {
    const charCode = getCharCodeFromEvent(event);
    const charStr = String.fromCharCode(charCode);
    return isCharNumeric(charStr) || isCharDecimal(charStr);
}

NumericCellEditor.prototype.isKeyPressedNavigation = function (event) {
    return event.keyCode === 39
        || event.keyCode === 37;
};


// gets called once when grid ready to insert the element
NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
NumericCellEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
};

// returns the new value after editing
NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
};

// example - will reject the number if it contains the value 007
// - not very practical, but demonstrates the method.
NumericCellEditor.prototype.isCancelAfterEnd = function () {
    var value = this.getValue();
    return value.indexOf('007') >= 0;
};

// returns the new value after editing
NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
};

// any cleanup we need to be done here
NumericCellEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could  even leave this method out as it's optional
};

// if true, then this editor will appear in a popup 
NumericCellEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};

function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

function GetSortDescOrder(prop) {
    return function (a, b) {
        if (a[prop] > b[prop]) {
            return -1;
        } else if (a[prop] < b[prop]) {
            return 1;
        }
        return 0;
    }
}

function formatIndianNumber(number) {
    // console.log(number, 'number');
    if (number == null || number == undefined || number == '' || number == NaN) {
        return 0;
    }
    let x = number.toFixed(0).toString();
    let lastThree = x.substring(x.length - 3);
    let otherNumbers = x.substring(0, x.length - 3);
    if (otherNumbers !== '') {
        lastThree = ',' + lastThree;
    }
    let result = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return result;
}


const GridComponent = ({ rowData, columnwithDefs, onClicked }) => {
    // 🔥 GROUP DATA INSIDE SAME COMPONENT
    const groupedData = Object.values(
        rowData.reduce((acc, item) => {
            if (!acc[item.zone]) {
                acc[item.zone] = {
                    zone: item.zone,
                    totalLoad: 0,
                    children: [],
                };
            }

            acc[item.zone].children.push(item);
            acc[item.zone].totalLoad += Number(item.load_cmt || 0);

            return acc;
        }, {})
    );
    // console.log(groupedData)
    const gridOptions = {
        masterDetail: true,

        columnDefs: [
            {
                field: "zone",
                cellRenderer: "agGroupCellRenderer",
            },
            {
                headerName: "Total Load (CMT)",
                field: "totalLoad",
                valueGetter: (params) => {
                    return params.data.totalLoad.toFixed(2);
                }
            },
        ],

        defaultColDef: {
            flex: 1,
            resizable: true,
            sortable: true,
            filter: true,
        },
        getDetailRowHeight: () => {
            return 1000;
        },

        detailCellRendererParams: {
            detailGridOptions: {
                // domLayout: "autoHeight", // 🔥 auto expands
                columnDefs: columnwithDefs,
                defaultColDef: {
                    flex: 1,
                    resizable: true,
                },
                statusBar: {
                    statusPanels: [
                        { statusPanel: "agTotalRowCountComponent", align: "right" }
                    ]
                },
                animateRows: true,
                rowSelection: "multiple",
                rowHeight: 35,
                // height: 450,
                headerHeight: 41,
                onCellClicked: onClicked
            },

            getDetailRowData: (params) => {
                params.successCallback(params.data.children);
            },
        },
    };
    return (
        <div className="ag-theme-balham grid-wrapper mt-3 mb-3 px-3" style={{ height: "63vh" }}>
            <AgGridReact
                // ref={this.gridRef}
                modules={AllModules}
                rowData={groupedData}
                // columnDefs={columnwithDefs}
                defaultColDef={{
                    sortable: true,
                    filter: true,
                    floatingFilter: true, resizable: true
                }}
                statusBar={{
                    statusPanels: [
                        { statusPanel: "agTotalRowCountComponent", align: "right" }
                    ]
                }}
                animateRows rowSelection={"multiple"}
                rowHeight={45}
                headerHeight={45}
                onCellClicked={onClicked}
                gridOptions={gridOptions}
                // frameworkComponents={this.state.frameworkComponents}
                // onSelectionChanged={() => {
                //     if (this.gridRef && this.gridRef.current && this.gridRef.current.api) {
                //         const selected = this.gridRef.current.api.getSelectedRows();
                //         this.setState({ selectedRows: selected })

                //     }
                // }} 
                suppressRowClickSelection={true}
                suppressRowTransform={true}
            />
        </div>
    )
}
const TableComponent = ({ rowData, columnwithDefs, onClicked, frameworkComponents, rowSelection, onSelectionChanged, isRowSelectable }) => {
    // console.log(groupedData)
    const gridOptions = {
        masterDetail: true,

        columnDefs: columnwithDefs,

        defaultColDef: {
            flex: 1,
            resizable: true,
            sortable: true,
            filter: true,
        },
        getDetailRowHeight: () => {
            return 1000;
        },
        // Only set by callers that actually need bulk selection (e.g. the
        // Loading Plan tab's "Delete Selected") - undefined for every other
        // TableComponent usage, same as before this was added.
        isRowSelectable: isRowSelectable,

    };
    return (
        <div className="ag-theme-balham grid-wrapper mt-0 mb-3" style={{ flexGrow: 1 }}>
            <AgGridReact
                // ref={this.gridRef}
                modules={AllModules}
                rowData={rowData}
                // columnDefs={columnwithDefs}
                defaultColDef={{
                    sortable: true,
                    filter: true,
                    floatingFilter: true, resizable: true
                }}
                statusBar={{
                    statusPanels: [
                        { statusPanel: "agTotalAndFilteredRowCountComponent", align: "left" },
                        { statusPanel: "agFilteredRowCountComponent" },
                        { statusPanel: "agTotalRowCountComponent", align: "right" }
                    ]
                }}
                sideBar={{
                    toolPanels: [
                        {
                            id: "columns",
                            labelDefault: "Columns",
                            labelKey: "columns",
                            iconKey: "columns",
                            toolPanel: "agColumnsToolPanel"
                        },
                        {
                            id: "filters",
                            labelDefault: "Filters",
                            labelKey: "filters",
                            iconKey: "filter",
                            toolPanel: "agFiltersToolPanel"
                        }
                    ]
                }}
                animateRows
                rowSelection={rowSelection}
                rowHeight={45}
                headerHeight={45}
                onCellClicked={onClicked}
                gridOptions={gridOptions}
                frameworkComponents={frameworkComponents}
                onSelectionChanged={onSelectionChanged}
                suppressRowClickSelection={true}
                suppressRowTransform={true}
            />
        </div>
    )
}